export const WorldLow =
[
  {'type': 'FeatureCollection',
 'features': [{'type': 'Feature',
   'properties': {'id': 'GS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-35.26896003699994, -54.34013171099997],
      [-37.57308746699994, -54.34013171099997],
      [-37.86025388899998, -54.044094722999944],
      [-35.561711514999956, -54.044094722999944],
      [-35.26896003699994, -54.34013171099997]],
     [[-26.010917055999982, -58.559001415999944],
      [-26.08144213199995, -58.85057169099997],
      [-26.473102040999947, -58.850544990999936],
      [-26.40152491999993, -58.55896957199997],
      [-26.010917055999982, -58.559001415999944]],
     [[-26.93540468699996, -59.335067090999985],
      [-27.01033782199994, -59.627907266999955],
      [-27.404855432999966, -59.62788045099995],
      [-27.32883458799995, -59.33503510799994],
      [-26.93540468699996, -59.335067090999985]],
     [[-27.193755395999972, -56.32398667799998],
      [-27.262135890999957, -56.611960547999956],
      [-27.646011833999978, -56.611934178999945],
      [-27.57667486899993, -56.32395522599995],
      [-27.193755395999972, -56.32398667799998]],
     [[-26.20943213099997, -57.61511337899998],
      [-26.27827909399997, -57.90515391699995],
      [-26.66657272599997, -57.90512735799996],
      [-26.59671530999998, -57.61508170199994],
      [-26.20943213099997, -57.61511337899998]]]},
   'id': 'GS'},
  {'type': 'Feature',
   'properties': {'id': 'AU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[145.54102602000012, -17.011641097999927],
      [148.4988690570001, -19.139899491999927],
      [149.39392874300006, -22.476088324999978],
      [151.22578375800003, -23.741539261999947],
      [153.44779433600002, -29.55110947299994],
      [148.93986109800005, -36.74496831099998],
      [150.19837672100005, -38.591782301999956],
      [140.9352811540001, -38.591782301999956],
      [138.3668242860001, -37.20646488699998],
      [136.50740000100006, -33.98018775199995],
      [135.68590085100004, -35.24605508299993],
      [134.88333211100007, -33.77608653799996],
      [132.3449713860001, -32.254572838999934],
      [125.57852356400008, -32.254572838999934],
      [124.45360003500002, -33.80762626099994],
      [118.953925378, -33.80762626099994],
      [117.4654886080001, -35.88003339199997],
      [114.28748709100012, -33.98018775199995],
      [115.82282814100006, -31.966970352999965],
      [112.99128604000009, -22.591129319999936],
      [114.78998153900011, -20.69295291399993],
      [119.56918782600007, -20.69295291399993],
      [124.26686659100005, -15.746190160999959],
      [125.51787005400001, -15.746190160999959],
      [127.54560592700011, -13.675452263999944],
      [128.74250059700012, -14.595780217999959],
      [130.3860152200001, -14.595780217999959],
      [129.1872536620001, -13.675452263999944],
      [131.9490769800001, -10.914468400999965],
      [136.0083610790001, -10.914468400999965],
      [137.1804417290001, -11.83479635499998],
      [136.26595993600006, -12.755124308999939],
      [136.67911527100011, -15.228505686999938],
      [140.0388767820001, -17.693033250999974],
      [142.28282836200003, -15.28602618399998],
      [141.4924737650001, -10.29059674499996],
      [142.8011707390001, -10.29059674499996],
      [143.04694103100007, -12.064878343999965],
      [144.84197518000008, -13.44537027499996],
      [145.54102602000012, -17.011641097999927]],
     [[148.66083048000007, -43.76869879199995],
      [146.47567437400005, -43.76869879199995],
      [144.11367860000007, -40.84178966199994],
      [147.42015971500007, -40.84242468599996],
      [148.36564312100006, -42.03642005599994],
      [147.98526151200008, -42.98069204099994],
      [148.66083048000007, -43.76869879199995]],
     [[158.81806744300002, -54.59454705099995],
      [159.19532528500008, -54.87892911599994],
      [158.81701313200006, -54.878903081999965],
      [158.44064677500012, -54.594515985999976],
      [158.81806744300002, -54.59454705099995]]]},
   'id': 'AU'},
  {'type': 'Feature',
   'properties': {'id': 'CL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-68.11398778899996, -18.712486318999936],
      [-68.61367772699998, -22.774057797999944],
      [-67.03580336699997, -22.774057797999944],
      [-67.30324039199996, -24.804843536999954],
      [-67.93690808699995, -24.804843536999954],
      [-68.85022902699995, -25.498282569999958],
      [-69.99814324999994, -31.29345163199997],
      [-69.34354223899999, -31.986890664999976],
      [-71.92879524899996, -40.47652393799996],
      [-71.10239861599996, -41.45097277599996],
      [-71.92221455099997, -43.50487459599998],
      [-71.28744843599998, -44.283147492999944],
      [-72.39709446599994, -46.806547852999984],
      [-71.85489504299994, -47.49116411899996],
      [-73.04102985799994, -49.96100403699995],
      [-71.37598288599997, -52.22658920899994],
      [-71.34310465599998, -52.27203357099995],
      [-69.06976531699996, -52.272705170999984],
      [-71.66839765499998, -53.69976652599996],
      [-75.35993752399997, -48.629545114999985],
      [-74.32931097599999, -46.48622597199994],
      [-75.40460511299995, -46.48622597199994],
      [-74.97988050399994, -45.569779292999954],
      [-73.91276967299996, -45.57450608999994],
      [-73.26285779599993, -44.091005930999984],
      [-73.66714392399996, -43.58893874499995],
      [-72.71033357899995, -41.24096900599994],
      [-73.89582147599998, -39.83686979299995],
      [-71.16248157499996, -30.874919705999957],
      [-72.01465660999997, -29.977163814999983],
      [-70.18394360499997, -18.306337233999955],
      [-69.26831110199998, -17.598030729999948],
      [-68.11398778899996, -18.712486318999936]],
     [[-68.05356667599995, -52.94580128999996],
      [-68.55647062099996, -53.868952356999955],
      [-67.19279577799995, -53.868742149999946],
      [-66.27008699899994, -55.13550988399999],
      [-71.50188595599997, -55.13504537999995],
      [-72.08236798399997, -54.285886879999964],
      [-70.91142557599994, -54.285886879999964],
      [-70.49051554199997, -53.55272733399994],
      [-69.37978481499994, -52.94588210699993],
      [-68.05356667599995, -52.94580128999996]],
     [[-73.53317108999994, -41.69547692799995],
      [-74.22489935499993, -43.369413839999936],
      [-74.73831365599995, -42.74263318699997],
      [-74.31299515399996, -41.709844406999935],
      [-73.53317108999994, -41.69547692799995]],
     [[-80.54992401099997, -33.57531082899993],
      [-80.63448042099998, -33.844846236999956],
      [-80.96832402899997, -33.84482157499997],
      [-80.88341808399997, -33.575281367999935],
      [-80.54992401099997, -33.57531082899993]],
     [[-78.64885964999996, -33.52717873599994],
      [-78.73123072499999, -33.796714142999974],
      [-79.06501198699993, -33.79668948199998],
      [-78.98229232599994, -33.52714927399995],
      [-78.64885964999996, -33.52717873599994]]]},
   'id': 'CL'},
  {'type': 'Feature',
   'properties': {'id': 'HM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[74.05169603600007, -53.344999159999986],
      [73.37058197900006, -53.344999159999986],
      [73.08903332300008, -52.85768573699994],
      [73.76753370700004, -52.85768573699994],
      [74.05169603600007, -53.344999159999986]]]},
   'id': 'HM'},
  {'type': 'Feature',
   'properties': {'id': 'FK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-59.26494725499998, -52.29791100399996],
      [-60.125838303999956, -52.29791100399996],
      [-58.57789403199996, -51.395651328999975],
      [-57.72284301899998, -51.395651328999975],
      [-59.26494725499998, -52.29791100399996]],
     [[-60.64237293299993, -52.29791100399996],
      [-60.87194387799997, -52.29791100399996],
      [-60.45900625999997, -51.395651328999975],
      [-59.09092463999997, -51.395651328999975],
      [-60.64237293299993, -52.29791100399996]]]},
   'id': 'FK'},
  {'type': 'Feature',
   'properties': {'id': 'NZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[169.02715460600007, -46.86233037599993],
      [167.7746910090001, -46.86233037599993],
      [165.48815045800006, -45.86082052799998],
      [166.06410369000002, -43.50661930499996],
      [171.41916345700008, -43.50661930499996],
      [172.5093207540001, -39.84666593099996],
      [174.44171847500002, -41.97383107199994],
      [173.71044045600001, -45.25512822999997],
      [169.3512757410001, -45.25512822999997],
      [169.02715460600007, -46.86233037599993]],
     [[174.87596766700005, -37.25231861599997],
      [176.25223893600003, -37.93775681899996],
      [176.43378184100004, -37.49069741399995],
      [176.85366612000007, -37.69930903599993],
      [175.43277514800002, -41.85377430699998],
      [174.70111214700012, -41.07397713599994],
      [174.99556328100005, -40.14551047899994],
      [173.56281620300012, -39.458727642999975],
      [174.34262484900012, -37.49069741399995],
      [171.92061263800008, -34.187568382999984],
      [173.044860942, -34.78164236899994],
      [174.87596766700005, -37.25231861599997]],
     [[178.80959463900012, -49.57145004599994],
      [179.14740660100006, -49.849292306999985],
      [178.78344225900003, -49.849266876999934],
      [178.44631191200006, -49.57141968899998],
      [178.80959463900012, -49.57145004599994]],
     [[166.13152350400003, -50.70675594099998],
      [166.46968658600008, -50.98669052799994],
      [166.10275608000006, -50.98666490099998],
      [165.7653338760001, -50.70672536099994],
      [166.13152350400003, -50.70675594099998]]]},
   'id': 'NZ'},
  {'type': 'Feature',
   'properties': {'id': 'TF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[70.26363586900004, -49.25075347899997],
      [70.47753671700008, -49.70031263499993],
      [68.89508542600004, -49.69891503699995],
      [68.45112907100008, -48.74220659399998],
      [69.38620648800003, -48.74220659399998],
      [70.26363586900004, -49.25075347899997]],
     [[77.94158659600004, -38.066145362999976],
      [77.32184108700005, -38.066145362999976],
      [77.15657278900005, -37.59958277499993],
      [77.77499365000006, -37.59958277499993],
      [77.94158659600004, -38.066145362999976]],
     [[52.61541592000003, -46.673645703999966],
      [51.965515277000065, -46.673645703999966],
      [51.81185835300005, -46.198497405999944],
      [52.459837304000075, -46.198497405999944],
      [52.61541592000003, -46.673645703999966]]]},
   'id': 'TF'},
  {'type': 'Feature',
   'properties': {'id': 'ZA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[30.68549027000006, -26.042805931999965],
      [30.765022737000038, -27.06439022199993],
      [32.032046010000045, -27.06439022199993],
      [31.93727983100007, -25.974341298999946],
      [32.695291428000075, -25.974341298999946],
      [32.84647545400003, -27.683532215999946],
      [26.104161065000028, -34.06069475099997],
      [18.381419876000052, -34.06069475099997],
      [18.218216606000055, -31.73940201199997],
      [16.734204657000078, -30.376799888999983],
      [16.650867429000073, -28.736073605999934],
      [20.423134541000024, -28.724323023999943],
      [20.241747899000075, -25.05983862499994],
      [21.129877476000047, -25.79185922099998],
      [21.17528672700007, -26.657423507999965],
      [22.71602755500004, -26.657423507999965],
      [22.671830069000066, -25.874293914999953],
      [23.488756082000066, -25.874293914999953],
      [25.410934936000046, -25.874293914999953],
      [25.359233477000032, -25.00872962899996],
      [28.828206687000034, -21.876211258999945],
      [31.67166065600003, -21.87931221799994],
      [31.915136141000062, -25.671220994999942],
      [31.09080793000004, -25.671320735999927],
      [30.68549027000006, -26.042805931999965]],
     [[38.31860934800005, -46.88071609499997],
      [37.66786163900008, -46.88071609499997],
      [37.555793648000076, -46.40530834499998],
      [38.20460527700004, -46.40530834499998],
      [38.31860934800005, -46.88071609499997]]]},
   'id': 'ZA'},
  {'type': 'Feature',
   'properties': {'id': 'UY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-55.88587368299994, -31.033411993999948],
      [-54.67206711499995, -31.045794833999935],
      [-52.764981509999984, -32.95326668399997],
      [-52.942296933999955, -33.84896066399995],
      [-54.48570061199996, -34.94112714099998],
      [-57.33413615099994, -34.947318560999975],
      [-58.285057490999975, -33.96288279099997],
      [-58.50496960299995, -34.117102821999936],
      [-57.67695139199998, -30.11752903699994],
      [-57.17168979099995, -29.745935908999968],
      [-55.88587368299994, -31.033411993999948]]]},
   'id': 'UY'},
  {'type': 'Feature',
   'properties': {'id': 'NF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[168.16456493500004, -28.91290820699993],
      [168.29763918300011, -29.182443614999954],
      [167.96908540300012, -29.182418953999957],
      [167.83626967300006, -28.91287874699998],
      [168.16456493500004, -28.91290820699993]]]},
   'id': 'NF'},
  {'type': 'Feature',
   'properties': {'id': 'LS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[29.69092825000007, -29.24334931599998],
      [28.21179664400006, -30.63861584899996],
      [26.888668075000055, -29.709902857999964],
      [28.376048120000064, -28.31463632499998],
      [29.69092825000007, -29.24334931599998]]]},
   'id': 'LS'},
  {'type': 'Feature',
   'properties': {'id': 'PF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-149.23328209, -23.243185652999955],
      [-149.31160261699998, -23.51272106099998],
      [-149.63559290399996, -23.51269640099997],
      [-149.55710208999997, -23.243156192999948],
      [-149.23328209, -23.243185652999955]],
     [[-148.07698110799998, -15.67813948099996],
      [-148.13386460199996, -15.947674888999927],
      [-148.45365473099997, -15.947650228999976],
      [-148.39664850299997, -15.678110020999952],
      [-148.07698110799998, -15.67813948099996]],
     [[-134.77470843999998, -22.99209645899998],
      [-134.844927209, -23.26163186699995],
      [-135.168760788, -23.26160720699994],
      [-135.098373289, -22.992066998999974],
      [-134.77470843999998, -22.99209645899998]],
     [[-140.454050377, -21.536841613999968],
      [-140.523857524, -21.806377020999946],
      [-140.84680451999998, -21.806352361999927],
      [-140.77683680799998, -21.53681215299997],
      [-140.454050377, -21.536841613999968]],
     [[-146.14554419599997, -16.05396168699997],
      [-146.20316030099997, -16.323497093999947],
      [-146.52312416599997, -16.32347243499993],
      [-146.46538203499998, -16.053932225999972],
      [-146.14554419599997, -16.05396168699997]],
     [[-150.83400525399998, -16.630655244999957],
      [-150.89578625299998, -16.900190651999935],
      [-151.21602535499997, -16.900165991999927],
      [-151.15411320799998, -16.63062578399996],
      [-150.83400525399998, -16.630655244999957]],
     [[-143.39077622199994, -16.50469419199993],
      [-143.449046142, -16.774229599999956],
      [-143.76922444299998, -16.774204939999947],
      [-143.71082453699995, -16.50466473199998],
      [-143.39077622199994, -16.50469419199993]],
     [[-144.11174765899997, -27.510029002999943],
      [-144.21761117999998, -27.779564410999967],
      [-144.54483157599998, -27.77953975099996],
      [-144.43872718899996, -27.509999542999935],
      [-144.11174765899997, -27.510029002999943]],
     [[-151.12332959099996, -22.346800103999954],
      [-151.20040856599996, -22.616335511999978],
      [-151.52384292099998, -22.61631085199997],
      [-151.44659873499998, -22.346770643999946],
      [-151.12332959099996, -22.346800103999954]],
     [[-139.935820789, -8.819930366999927],
      [-139.96446432899995, -9.089465774999951],
      [-140.28187787299998, -9.089441113999953],
      [-140.253169954, -8.819900906999976],
      [-139.935820789, -8.819930366999927]],
     [[-140.61375104799998, -17.718849766999938],
      [-140.67549221699994, -17.988385174999962],
      [-140.99628100399997, -17.988360514999954],
      [-140.93439907599998, -17.71882030699993],
      [-140.61375104799998, -17.718849766999938]],
     [[-136.129150117, -18.423432187999936],
      [-136.191527663, -18.69296759599996],
      [-136.51269308399998, -18.69294293599995],
      [-136.45016849499996, -18.423402727999928],
      [-136.129150117, -18.423432187999936]],
     [[-140.52871826499995, -7.907371977999958],
      [-140.55496552099999, -8.176907385999925],
      [-140.87216959399996, -8.176882724999928],
      [-140.845863717, -7.90734251799995],
      [-140.52871826499995, -7.907371977999958]],
     [[-138.86334726899997, -9.716897790999951],
      [-138.894223185, -9.986433198999976],
      [-139.21186154999998, -9.986408537999978],
      [-139.18091556999997, -9.716868330999944],
      [-138.86334726899997, -9.716897790999951]],
     [[-139.88207247799994, -9.326514455999927],
      [-139.91209753299995, -9.596049862999962],
      [-140.22963572999998, -9.596025202999954],
      [-140.19954308499996, -9.32648499499993],
      [-139.88207247799994, -9.326514455999927]],
     [[-149.10816830899998, -17.56435558499993],
      [-149.17299109399997, -17.833890991999965],
      [-149.49369918899998, -17.833866332999946],
      [-149.42873696599997, -17.56432612499998],
      [-149.10816830899998, -17.56435558499993]],
     [[-151.34636882699996, -16.502824826999927],
      [-151.40783922299997, -16.77236023399996],
      [-151.72801632499997, -16.772335573999953],
      [-151.66641590799998, -16.50279536599993],
      [-151.34636882699996, -16.502824826999927]]]},
   'id': 'PF'},
  {'type': 'Feature',
   'properties': {'id': 'SZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[31.93727983100007, -25.974341298999946],
      [32.032046010000045, -27.06439022199993],
      [30.765022737000038, -27.06439022199993],
      [30.68549027000006, -26.042805931999965],
      [31.09080793000004, -25.671320735999927],
      [31.915136141000062, -25.671220994999942],
      [31.93727983100007, -25.974341298999946]]]},
   'id': 'SZ'},
  {'type': 'Feature',
   'properties': {'id': 'PN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-128.09579110899995, -24.26276847899993],
      [-128.16524225499995, -24.532303885999966],
      [-128.48988638299994, -24.532279226999947],
      [-128.42025929299996, -24.262739017999934],
      [-128.09579110899995, -24.26276847899993]]]},
   'id': 'PN'},
  {'type': 'Feature',
   'properties': {'id': 'CK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-159.53454139299998, -21.122015765999947],
      [-159.61269079199997, -21.39155117399997],
      [-159.93539233099997, -21.391526513999963],
      [-159.85708452699998, -21.12198630599994],
      [-159.53454139299998, -21.122015765999947]],
     [[-157.72108318799997, -21.804680288999975],
      [-157.80010704599997, -22.074215696999943],
      [-158.12321307299996, -22.074191036999935],
      [-158.04402700099996, -21.804650828999968],
      [-157.72108318799997, -21.804680288999975]],
     [[-157.51768465599997, -19.673532946999956],
      [-157.59513846999997, -19.94306835499998],
      [-157.91701145699997, -19.943043693999982],
      [-157.83939911399997, -19.673503486999948],
      [-157.51768465599997, -19.673532946999956]]]},
   'id': 'CK'},
  {'type': 'Feature',
   'properties': {'id': 'NC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[167.59651625800007, -22.407764330999953],
      [167.21114913000008, -22.874969679999936],
      [163.7438339580001, -20.4954916799999],
      [164.14097734900008, -20.028286329999958],
      [167.59651625800007, -22.407764330999953]],
     [[160.07102803600003, -19.02086963299996],
      [160.14598927500003, -19.29040504099993],
      [159.82447887700005, -19.29038037999993],
      [159.7496678110001, -19.020840172999954],
      [160.07102803600003, -19.02086963299996]],
     [[167.17500830900008, -20.62186053399995],
      [167.25461572000006, -20.891395940999928],
      [166.932189998, -20.891371280999977],
      [166.85273557000005, -20.621831072999953],
      [167.17500830900008, -20.62186053399995]],
     [[168.13469255300004, -21.512676941999928],
      [168.21719788000007, -21.782212349999952],
      [167.89425123400008, -21.782187688999954],
      [167.81190376900008, -21.512647481999977],
      [168.13469255300004, -21.512676941999928]]]},
   'id': 'NC'},
  {'type': 'Feature',
   'properties': {'id': 'AR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-64.72272363699994, -22.154915803999927],
      [-62.20106103699999, -22.154915803999927],
      [-62.285223213999984, -22.87312051699996],
      [-61.04859754299997, -24.061873144999936],
      [-59.524301219999984, -24.061873144999936],
      [-58.23599560799994, -25.30015713199998],
      [-58.55508776199997, -27.479536949999954],
      [-55.655845134999936, -27.479536949999954],
      [-55.57582625699996, -26.93469199599997],
      [-55.025762147999956, -26.93469199599997],
      [-54.85602011199995, -25.696408007999935],
      [-53.874731285999985, -25.696408007999935],
      [-54.11565010399994, -27.45477127099997],
      [-57.17168979099995, -29.745935908999968],
      [-57.67695139199998, -30.11752903699994],
      [-58.50496960299995, -34.117102821999936],
      [-58.68276501799994, -34.241496687999984],
      [-56.979970797999954, -35.99559407099997],
      [-57.63077357999998, -38.52947903199998],
      [-61.66317134399998, -38.52947903199998],
      [-62.43648190499994, -41.03320770199997],
      [-65.52546862099996, -41.03320770199997],
      [-64.71440212499994, -41.95848595999996],
      [-63.37737440799998, -41.95848595999996],
      [-63.696226098999944, -42.86009801299997],
      [-65.05542585699993, -42.86009801299997],
      [-65.81442855899996, -44.83072924999993],
      [-67.12124841099995, -45.62501168799997],
      [-67.34560476299998, -46.16837141299993],
      [-66.89470188099995, -46.712510313999985],
      [-69.32663066999999, -51.92660948199995],
      [-69.06976531699996, -52.272705170999984],
      [-71.34310465599998, -52.27203357099995],
      [-71.37598288599997, -52.22658920899994],
      [-73.04102985799994, -49.96100403699995],
      [-71.85489504299994, -47.49116411899996],
      [-72.39709446599994, -46.806547852999984],
      [-71.28744843599998, -44.283147492999944],
      [-71.92221455099997, -43.50487459599998],
      [-71.10239861599996, -41.45097277599996],
      [-71.92879524899996, -40.47652393799996],
      [-69.34354223899999, -31.986890664999976],
      [-69.99814324999994, -31.29345163199997],
      [-68.85022902699995, -25.498282569999958],
      [-67.93690808699995, -24.804843536999954],
      [-67.30324039199996, -24.804843536999954],
      [-67.03580336699997, -22.774057797999944],
      [-66.80629436999993, -22.774057797999944],
      [-66.64952162499998, -21.511008130999983],
      [-65.39018434599996, -21.511008130999983],
      [-64.72272363699994, -22.154915803999927]]]},
   'id': 'AR'},
  {'type': 'Feature',
   'properties': {'id': 'TO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-173.73117597399997, -18.496581339999977],
      [-173.81100345, -18.766116746999955],
      [-174.13220731199996, -18.766092087999937],
      [-174.05223185599996, -18.49655187899998],
      [-173.73117597399997, -18.496581339999977]],
     [[-174.71862647199998, -21.187503042999936],
      [-174.80435740599998, -21.45703845099996],
      [-175.12709664099998, -21.45701379099995],
      [-175.04120681199998, -21.187473582999928],
      [-174.71862647199998, -21.187503042999936]]]},
   'id': 'TO'},
  {'type': 'Feature',
   'properties': {'id': 'RE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[55.792869702000075, -21.372793325999965],
      [55.20449812500004, -21.372793325999965],
      [55.15832977700006, -20.907835973999966],
      [55.746209289000035, -20.907835973999966],
      [55.792869702000075, -21.372793325999965]]]},
   'id': 'RE'},
  {'type': 'Feature',
   'properties': {'id': 'MU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[57.81321818300006, -20.528957369999944],
      [57.22573367000007, -20.528957369999944],
      [57.17922622000003, -20.064000017999945],
      [57.766233283000076, -20.064000017999945],
      [57.81321818300006, -20.528957369999944]],
     [[63.56088024600007, -19.598924631999978],
      [63.59137273700003, -19.868460039999945],
      [63.26953357500008, -19.868435378999948],
      [63.239197184000034, -19.59889517199997],
      [63.56088024600007, -19.598924631999978]]]},
   'id': 'MU'},
  {'type': 'Feature',
   'properties': {'id': 'PY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-57.930826414999956, -19.95077030599998],
      [-58.141963362999945, -21.98155604599998],
      [-56.39455490399996, -21.98155604599998],
      [-55.82163409799995, -21.98155604599998],
      [-55.90987842099997, -22.823589156999958],
      [-54.658460058999935, -24.012341784999933],
      [-54.85602011199995, -25.696408007999935],
      [-55.025762147999956, -26.93469199599997],
      [-55.57582625699996, -26.93469199599997],
      [-55.655845134999936, -27.479536949999954],
      [-58.55508776199997, -27.479536949999954],
      [-58.23599560799994, -25.30015713199998],
      [-59.524301219999984, -24.061873144999936],
      [-61.04859754299997, -24.061873144999936],
      [-62.285223213999984, -22.87312051699996],
      [-62.20106103699999, -22.154915803999927],
      [-61.872903159999964, -19.207799913999963],
      [-58.708950440999956, -19.207799913999963],
      [-57.930826414999956, -19.95077030599998]]]},
   'id': 'PY'},
  {'type': 'Feature',
   'properties': {'id': 'NU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-169.61173254699997, -18.96977276299998],
      [-169.69185323799996, -19.239308170999948],
      [-170.01332044699998, -19.23928351099994],
      [-169.93304752899996, -18.969743302999973],
      [-169.61173254699997, -18.96977276299998]]]},
   'id': 'NU'},
  {'type': 'Feature',
   'properties': {'id': 'VU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[168.4383241050001, -15.833767652999938],
      [167.88283760800005, -16.461156780999943],
      [166.6286042920001, -15.55544907899997],
      [167.1939581260001, -14.928059950999966],
      [168.4383241050001, -15.833767652999938]],
     [[168.01258470900007, -13.811762014999942],
      [167.4362159860001, -14.439151142999947],
      [166.56697451600007, -13.187008841999955],
      [166.80237304500008, -12.90605431299997],
      [168.01258470900007, -13.811762014999942]],
     [[168.66179375800004, -16.792258337999954],
      [168.73065889400004, -17.06179374499993],
      [168.41032855100002, -17.06176908499998],
      [168.34159389500007, -16.792228876999957],
      [168.66179375800004, -16.792258337999954]],
     [[169.3940140730001, -18.841251203999946],
      [169.47254221700007, -19.11078661199997],
      [169.15113264700005, -19.110761950999972],
      [169.07275300600008, -18.841221743999938],
      [169.3940140730001, -18.841251203999946]],
     [[168.57003429500003, -17.68547155999994],
      [168.64291170400008, -17.955006966999974],
      [168.32212793200006, -17.954982306999966],
      [168.24938882100003, -17.685442098999943],
      [168.57003429500003, -17.68547155999994]],
     [[169.94380372700005, -20.103175143999977],
      [170.02330738500007, -20.372710550999955],
      [169.70117734100006, -20.372685890999946],
      [169.62182382000003, -20.10314568299998],
      [169.94380372700005, -20.103175143999977]]]},
   'id': 'VU'},
  {'type': 'Feature',
   'properties': {'id': 'FJ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[179.9998633660001, -16.40008130399997],
      [177.93099224600007, -19.564602323999964],
      [177.416149839, -17.896036694999964],
      [178.7201824240001, -16.40008130399997],
      [179.9998633660001, -16.40008130399997]],
     [[177.24885664700003, -12.381996538999942],
      [177.30045238500009, -12.651531946999967],
      [176.98197429100003, -12.651507285999969],
      [176.93047122300004, -12.381967078999935],
      [177.24885664700003, -12.381996538999942]],
     [[179.8733094910001, -18.373349920999942],
      [179.95444449000001, -18.642885328999967],
      [179.63329314700002, -18.64286066799997],
      [179.5523024270001, -18.373320460999935],
      [179.8733094910001, -18.373349920999942]],
     [[-178.94861916199997, -17.336698198999954],
      [-179.02522764299997, -17.606233605999932],
      [-179.34581759599996, -17.60620894699997],
      [-179.26907150499997, -17.336668737999958],
      [-178.94861916199997, -17.336698198999954]],
     [[-179.567618779, -16.666934080999965],
      [-179.64125836599996, -16.936469487999943],
      [-179.96151407499997, -16.93644482899998],
      [-179.88774282999998, -16.66690461999997],
      [-179.567618779, -16.666934080999965]],
     [[-178.57688183699997, -18.107668927999953],
      [-178.65704501199997, -18.37720433499993],
      [-178.97803794499998, -18.37717967599997],
      [-178.89773025699998, -18.107639467999945],
      [-178.57688183699997, -18.107668927999953]]]},
   'id': 'FJ'},
  {'type': 'Feature',
   'properties': {'id': 'BW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[28.828206687000034, -21.876211258999945],
      [25.359233477000032, -25.00872962899996],
      [25.410934936000046, -25.874293914999953],
      [23.488756082000066, -25.874293914999953],
      [22.671830069000066, -25.874293914999953],
      [22.71602755500004, -26.657423507999965],
      [21.17528672700007, -26.657423507999965],
      [21.129877476000047, -25.79185922099998],
      [20.241747899000075, -25.05983862499994],
      [20.10836581700005, -21.958645952999973],
      [20.775793188000023, -21.958645952999973],
      [20.753848110000035, -21.381603095999935],
      [20.63995385900006, -18.249084725999978],
      [22.48705932000007, -18.249084725999978],
      [23.25767238900005, -18.578823501999977],
      [24.882415861000027, -17.75447656199998],
      [28.828206687000034, -21.876211258999945]]]},
   'id': 'BW'},
  {'type': 'Feature',
   'properties': {'id': 'NA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[18.81028513900003, -17.25986839799998],
      [19.913451363000036, -17.75447656199998],
      [21.94836063400004, -17.75447656199998],
      [22.925680085000067, -17.301085745999956],
      [24.01333838200003, -17.301085745999956],
      [24.882415861000027, -17.75447656199998],
      [23.25767238900005, -18.578823501999977],
      [22.48705932000007, -18.249084725999978],
      [20.63995385900006, -18.249084725999978],
      [20.753848110000035, -21.381603095999935],
      [20.775793188000023, -21.958645952999973],
      [20.10836581700005, -21.958645952999973],
      [20.241747899000075, -25.05983862499994],
      [20.423134541000024, -28.724323023999943],
      [16.650867429000073, -28.736073605999934],
      [15.218759280000029, -27.559703816999956],
      [15.06367268400004, -23.039967262999937],
      [13.259017972000038, -21.151584181999965],
      [13.222588259000077, -19.60372919699995],
      [11.807325242000047, -18.39640230899994],
      [11.787179266000066, -17.252850587999944],
      [18.81028513900003, -17.25986839799998]]]},
   'id': 'NA'},
  {'type': 'Feature',
   'properties': {'id': 'ZW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[32.56816912800008, -16.87427667399993],
      [32.78873194100004, -20.860971651999932],
      [31.67166065600003, -21.87931221799994],
      [28.828206687000034, -21.876211258999945],
      [24.882415861000027, -17.75447656199998],
      [27.201265960000057, -17.75447656199998],
      [29.272275652000076, -15.878187869999977],
      [30.287953621000042, -15.877602929999966],
      [31.404227235000064, -15.877602929999966],
      [32.56816912800008, -16.87427667399993]]]},
   'id': 'ZW'},
  {'type': 'Feature',
   'properties': {'id': 'WS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-171.50946538799997, -13.727095644999963],
      [-171.59148595199997, -14.118233330999942],
      [-171.98982903699996, -14.117314061999934],
      [-171.90762369299998, -13.726171575999956],
      [-171.50946538799997, -13.727095644999963]],
     [[-172.21210297599998, -13.425155823999944],
      [-172.29262225399998, -13.81629351],
      [-172.690822122, -13.815374240999972],
      [-172.61012240499997, -13.424231754999937],
      [-172.21210297599998, -13.425155823999944]]]},
   'id': 'WS'},
  {'type': 'Feature',
   'properties': {'id': 'YT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[45.30210314200008, -12.83458466199994],
      [45.315455031000056, -13.104120069999965],
      [44.99681877200004, -13.104095408999967],
      [44.98356368700007, -12.834555201999933],
      [45.30210314200008, -12.83458466199994]]]},
   'id': 'YT'},
  {'type': 'Feature',
   'properties': {'id': 'MG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[50.66531275800003, -14.092741753999974],
      [50.72527410400005, -15.021492534999936],
      [47.18367477700008, -25.489287802999968],
      [45.829977248000034, -26.08910601699995],
      [43.69798916700006, -25.20672157699994],
      [43.25697528100005, -19.820102437999935],
      [45.278156495000076, -15.783468402999972],
      [46.81377253000005, -15.098888433999946],
      [48.60176475000003, -12.370683012999962],
      [50.66531275800003, -14.092741753999974]]]},
   'id': 'MG'},
  {'type': 'Feature',
   'properties': {'id': 'KM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[43.61434888900004, -12.430521996999971],
      [43.626759854000056, -12.700057404999939],
      [43.30826833200007, -12.700032743999941],
      [43.29595102600007, -12.430492536999964],
      [43.61434888900004, -12.430521996999971]],
     [[44.64887533500007, -12.216684828999973],
      [44.66136022100005, -12.48622023699994],
      [44.34294332700006, -12.486195575999943],
      [44.33055043100006, -12.216655368999966],
      [44.64887533500007, -12.216684828999973]],
     [[43.60316140300006, -11.563723205999963],
      [43.61465542900004, -11.833258612999941],
      [43.29645833600006, -11.833233952999933],
      [43.28505123200006, -11.563693744999966],
      [43.60316140300006, -11.563723205999963]]]},
   'id': 'KM'},
  {'type': 'Feature',
   'properties': {'id': 'SB'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[162.38411279100012, -10.360308732999954],
      [161.62706886000012, -11.140174420999926],
      [159.81099070800008, -9.723161538999932],
      [160.58775289900007, -8.94329585099996],
      [162.38411279100012, -10.360308732999954]],
     [[159.62037630800012, -8.365125143999933],
      [158.99063161200002, -8.992514271999937],
      [157.85878825200007, -8.086806569999965],
      [158.4951423120001, -7.45941744199996],
      [159.62037630800012, -8.365125143999933]],
     [[165.96431199300002, -10.73939846899998],
      [166.00601111200012, -11.008933876999947],
      [165.6880710270001, -11.00890921599995],
      [165.64645198300002, -10.739369008999972],
      [165.96431199300002, -10.73939846899998]],
     [[160.22858485200004, -11.46434850999998],
      [160.27162867200002, -11.733883917999947],
      [159.95346101600012, -11.73385925699995],
      [159.91050286100005, -11.464319049999972],
      [160.22858485200004, -11.46434850999998]]]},
   'id': 'SB'},
  {'type': 'Feature',
   'properties': {'id': 'MZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[40.802270588000056, -14.922939958999962],
      [38.67940957700006, -16.87427667399993],
      [37.98382123300007, -16.87427667399993],
      [34.94077542600007, -19.669296522999957],
      [35.265995445000044, -24.630998425999962],
      [32.65622775200006, -25.476004425999975],
      [32.695291428000075, -25.974341298999946],
      [31.93727983100007, -25.974341298999946],
      [31.915136141000062, -25.671220994999942],
      [31.67166065600003, -21.87931221799994],
      [32.78873194100004, -20.860971651999932],
      [32.56816912800008, -16.87427667399993],
      [31.404227235000064, -15.877602929999966],
      [30.287953621000042, -15.877602929999966],
      [30.26345542200005, -15.055977949999942],
      [33.258512051000025, -14.013821701999973],
      [33.28156921100003, -14.599260517999937],
      [34.19781031900004, -14.599260517999937],
      [34.27314431600007, -16.088142922999964],
      [35.18594193200005, -17.047611238999934],
      [35.129475840000055, -15.964270211999974],
      [35.67527698300006, -15.964270211999974],
      [35.59087686600003, -14.187590927999963],
      [34.69464728000003, -13.472585850999963],
      [34.624959524000076, -11.587572464999937],
      [38.22644370100005, -11.587572464999937],
      [40.60039451000006, -10.439230975999976],
      [40.802270588000056, -14.922939958999962]]]},
   'id': 'MZ'},
  {'type': 'Feature',
   'properties': {'id': 'BO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-62.37458226499996, -13.486927890999937],
      [-60.45246675499993, -13.486927890999937],
      [-60.66653179799994, -16.186386983999967],
      [-58.68087699299997, -16.186386983999967],
      [-58.774919025999964, -17.25131121299995],
      [-57.66685268799995, -17.25131121299995],
      [-57.930826414999956, -19.95077030599998],
      [-58.708950440999956, -19.207799913999963],
      [-61.872903159999964, -19.207799913999963],
      [-62.20106103699999, -22.154915803999927],
      [-64.72272363699994, -22.154915803999927],
      [-65.39018434599996, -21.511008130999983],
      [-66.64952162499998, -21.511008130999983],
      [-66.80629436999993, -22.774057797999944],
      [-67.03580336699997, -22.774057797999944],
      [-68.61367772699998, -22.774057797999944],
      [-68.11398778899996, -18.712486318999936],
      [-69.26831110199998, -17.598030729999948],
      [-68.75180108699993, -11.852393027999938],
      [-69.73258131099993, -10.936062876999927],
      [-68.12575433899997, -10.936062876999927],
      [-67.23436569999996, -10.193092483999976],
      [-65.91033796199997, -10.193092483999976],
      [-62.37458226499996, -13.486927890999937]]]},
   'id': 'BO'},
  {'type': 'Feature',
   'properties': {'id': 'PG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[151.08843917700005, -6.37902285399997],
      [148.42595321900012, -6.37902285399997],
      [148.34363780500007, -5.316263191999951],
      [151.00464717700004, -5.316263191999951],
      [151.98721508200003, -4.386348488999943],
      [152.6317271040001, -4.917728318999934],
      [151.08843917700005, -6.37902285399997]],
     [[157.53376712400006, -7.087529293999978],
      [156.7397559420001, -7.867394981999951],
      [154.26678594100008, -5.852579790999926],
      [155.07864615500011, -5.072714102999953],
      [157.53376712400006, -7.087529293999978]],
     [[153.6650501140001, -4.342066835999958],
      [153.15139198300005, -4.829165013999955],
      [150.26841066800012, -2.41581494899998],
      [150.8021432810001, -1.928716771999973],
      [153.6650501140001, -4.342066835999958]],
     [[151.01499774900003, -9.550869512999952],
      [151.04715433600006, -9.8204049199999],
      [150.72955320200003, -9.820380259999979],
      [150.6974646660001, -9.550840051999955],
      [151.01499774900003, -9.550869512999952]],
     [[153.00550840000005, -9.13101785699996],
      [153.03683198900012, -9.400553264999928],
      [152.71933697100008, -9.40052860399993],
      [152.68807880500003, -9.130988396999953],
      [153.00550840000005, -9.13101785699996]],
     [[149.85994444000005, -1.399935427999935],
      [149.86644587400008, -1.66947083499997],
      [149.55021225500002, -1.669446174999962],
      [149.5437254730001, -1.399905967999928],
      [149.85994444000005, -1.399935427999935]],
     [[153.57828488200005, -11.291351031999966],
      [153.61888244800002, -11.560886439999933],
      [153.30077066900003, -11.560861778999936],
      [153.26025746400012, -11.291321571999958],
      [153.57828488200005, -11.291351031999966]],
     [[147.08404361500004, -2.079610835999972],
      [147.093436203, -2.34914624399994],
      [146.7771539370001, -2.349121582999942],
      [146.7677824420001, -2.079581375999965],
      [147.08404361500004, -2.079610835999972]]]},
   'id': 'PG'},
  {'type': 'Feature',
   'properties': {'id': 'MW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[34.56976974300005, -9.919227282999941],
      [34.624959524000076, -11.587572464999937],
      [34.69464728000003, -13.472585850999963],
      [35.59087686600003, -14.187590927999963],
      [35.67527698300006, -15.964270211999974],
      [35.129475840000055, -15.964270211999974],
      [35.18594193200005, -17.047611238999934],
      [34.27314431600007, -16.088142922999964],
      [34.19781031900004, -14.599260517999937],
      [33.28156921100003, -14.599260517999937],
      [33.258512051000025, -14.013821701999973],
      [33.10619365100007, -9.55089133399997],
      [33.099764710000045, -9.302268844999958],
      [34.56976974300005, -9.919227282999941]]]},
   'id': 'MW'},
  {'type': 'Feature',
   'properties': {'id': 'ID'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[134.26247504600008, -2.113832339999931],
      [135.54416045800008, -3.206721784999957],
      [137.69216153700006, -1.251024882999957],
      [138.96007400200006, -2.343914327999926],
      [139.93713338700002, -2.343914327999926],
      [142.67289966600003, -2.343914326999936],
      [147.56667886700006, -6.427869623999925],
      [147.65997569500007, -7.611819633999971],
      [149.7311322920001, -9.279914050999935],
      [149.84333382400007, -10.20024200499995],
      [148.681554064, -10.224222435999934],
      [145.6671676090001, -7.808361556999955],
      [143.25063823100004, -7.808361556999955],
      [143.3856912560001, -9.131332989999976],
      [141.55524224600003, -9.131332989999976],
      [139.99987966700007, -9.131332989999976],
      [138.64854786900003, -8.03844354499995],
      [138.51868161100003, -6.54291061899994],
      [135.67780988900006, -4.184570236999946],
      [132.20965416700005, -4.184570236999946],
      [132.14306742400004, -2.919119299999977],
      [133.38088589100005, -2.919119299999977],
      [133.3506053440001, -2.113832339999931],
      [132.11306788900004, -2.113832339999931],
      [130.98248227600004, -1.135983887999942],
      [132.0801949810001, -0.158135436999942],
      [134.2290673130001, -0.158135436999942],
      [134.26247504600008, -2.113832339999931]],
     [[116.16414036200001, -1.106092124999975],
      [116.26108570200006, -4.014069874999961],
      [115.58988023300003, -4.014069874999961],
      [114.12543193600004, -4.014069874999961],
      [114.10326971000006, -3.556332636999969],
      [111.20544529800009, -3.556332636999969],
      [109.13423051700005, -1.779235122999978],
      [109.11646935300007, 0.509451069000022],
      [111.69916784600008, 0.521051227000044],
      [113.04030006500011, 1.691229596000028],
      [115.64811161700004, 1.691229596000028],
      [115.73688252500006, 4.068734852000034],
      [117.6976665200001, 4.06364609600007],
      [117.6135261600001, 1.936514225000053],
      [118.60202063000008, 1.047965468000029],
      [116.16414036200001, -1.106092124999975]],
     [[106.06876917600005, -2.711801765999951],
      [106.20178013400005, -5.552793031999954],
      [104.29363674600006, -5.552465214999927],
      [100.17677207600008, -2.048492320999969],
      [100.16009337000008, -1.106092124999975],
      [98.47750633700008, 0.374822470000026],
      [98.48995948100008, 1.55954378000007],
      [95.43725565900007, 4.332892929000025],
      [95.49213847300007, 5.483229312000049],
      [96.89763736600008, 5.490709250000066],
      [106.06876917600005, -2.711801765999951]],
     [[125.42496757700007, 1.432147871000041],
      [124.79982887500012, 0.888258748000055],
      [124.25061433000008, 0.407378699000049],
      [121.17803310700003, 0.410252071000059],
      [120.32493422800007, -0.344535859999951],
      [120.33152206900002, -0.988959309999927],
      [122.92503971800011, -0.988959309999927],
      [122.93424236900012, -1.521421424999971],
      [121.96685796500003, -1.521421424999971],
      [121.98841191200006, -2.338688855999976],
      [122.74114277100011, -2.982596529999967],
      [122.84866245500007, -4.951468069999976],
      [121.62739827000007, -4.951468069999976],
      [121.53473072500003, -3.304550366999933],
      [120.49674573400011, -3.304550366999933],
      [120.62877521100006, -5.632524262999937],
      [119.1635501400001, -5.629613068999959],
      [118.96379319300001, -0.702206325999953],
      [121.18449981200001, 1.258183678000023],
      [124.25996077100001, 1.253225694000037],
      [124.89284780800006, 1.80187373900003],
      [125.42496757700007, 1.432147871000041]],
     [[111.33239056300005, -6.022116024999946],
      [113.27104453100003, -7.635801013999981],
      [114.33333585600008, -7.630058362999932],
      [114.43701560000011, -8.927897534999943],
      [113.0927344700001, -8.927897534999943],
      [111.71202022500006, -7.802337898999951],
      [105.88272641500004, -7.802337898999951],
      [105.76985147100004, -6.022116024999946],
      [108.46644536300005, -6.022116024999946],
      [108.93270478500006, -6.41261630799994],
      [110.30083541100004, -6.41261630799994],
      [110.72012045300005, -6.022116024999946],
      [111.33239056300005, -6.022116024999946]],
     [[128.86723161500004, -0.136766208999973],
      [127.98915915600003, -0.917612085999963],
      [127.28267682500007, -0.298320527999977],
      [127.30731139000011, 1.882662784000047],
      [128.43789048000008, 2.851988700000049],
      [128.909414695, 2.421177182000065],
      [128.86723161500004, -0.136766208999973]],
     [[123.23959752200005, -9.071519138999975],
      [119.49485545400012, -9.071519138999975],
      [119.42697440500001, -8.290606615999934],
      [123.16958921000003, -8.290606615999934],
      [123.23959752200005, -9.071519138999975]],
     [[118.87686303400005, -8.938192610999977],
      [115.45715211100003, -8.938192610999977],
      [115.39547623400006, -8.195373382999946],
      [118.8133603870001, -8.195373382999946],
      [118.87686303400005, -8.938192610999977]],
     [[130.73332809800002, -3.664035515999956],
      [128.2624438150001, -3.664035515999956],
      [128.22149239700002, -2.880043801999932],
      [130.69588263900005, -2.883189637999976],
      [130.73332809800002, -3.664035515999956]],
     [[107.30691445400004, -2.267397604999928],
      [106.77815339400007, -2.74238743899997],
      [105.08760225500004, -1.28026422399995],
      [105.62462992500008, -0.805274389999965],
      [107.30691445400004, -2.267397604999928]],
     [[124.58541764000006, -10.385737774999939],
      [123.56696742300005, -10.385737774999939],
      [123.50814565600001, -9.833385015999966],
      [123.97057892100008, -9.388156992999939],
      [124.29669283900012, -9.590499473999955],
      [124.78736851700012, -9.179722780999953],
      [125.00351051000007, -9.37341056699995],
      [124.52611105800008, -9.833385015999966],
      [124.58541764000006, -10.385737774999939]],
     [[127.29639882600009, -3.852515554999968],
      [126.1371265030001, -3.852515554999968],
      [126.11016281600007, -3.141824711999959],
      [127.26142103400002, -3.152446837999946],
      [127.29639882600009, -3.852515554999968]],
     [[108.33233280200005, -3.128965308999966],
      [107.80851542600004, -3.60395514399994],
      [107.24980364400005, -3.127788971999962],
      [107.77635819900007, -2.652799136999931],
      [108.33233280200005, -3.128965308999966]],
     [[138.116107499, -8.03954754299997],
      [137.14300840200008, -8.041565228999957],
      [138.03942931400002, -7.184466118999978],
      [138.116107499, -8.03954754299997]],
     [[120.37995184600004, -9.281032254999957],
      [120.46146908000003, -10.119084717999954],
      [119.42737949200011, -9.281032254999957],
      [120.37995184600004, -9.281032254999957]],
     [[134.6786702720001, -6.54259146499993],
      [134.1009075300001, -6.54259146499993],
      [134.066277409, -6.077634112999931],
      [134.64389095, -6.077634112999931],
      [134.6786702720001, -6.54259146499993]],
     [[113.8864539440001, -7.111271649999935],
      [113.30849635100003, -7.111271649999935],
      [113.27706433500009, -6.646314296999947],
      [113.85486160100004, -6.646314296999947],
      [113.8864539440001, -7.111271649999935]],
     [[124.12842484700002, -8.237476192999964],
      [124.151575965, -8.507011600999931],
      [123.83429369100008, -8.506986939999933],
      [123.81120252000005, -8.237446732999956],
      [124.12842484700002, -8.237476192999964]],
     [[128.16840734000004, -8.114895106999938],
      [128.1920183950001, -8.384430514999963],
      [127.87476371100001, -8.384405853999965],
      [127.85121182800003, -8.114865646999931],
      [128.16840734000004, -8.114895106999938]],
     [[132.93923479600005, -5.54468183299997],
      [132.95705987400004, -5.814217239999948],
      [132.64030495200006, -5.8141925799999],
      [132.6225231420001, -5.544652371999973],
      [132.93923479600005, -5.54468183299997]],
     [[131.7337029790001, -7.547184536999964],
      [131.75651804400002, -7.816719943999942],
      [131.43938685700004, -7.816695283999934],
      [131.41662743100005, -7.547155075999967],
      [131.7337029790001, -7.547184536999964]],
     [[127.87294567300012, -1.599848650999945],
      [127.87920037800006, -1.86938405799998],
      [127.5629542590001, -1.869359397999972],
      [127.55671610200011, -1.599819189999948],
      [127.87294567300012, -1.599848650999945]],
     [[130.52551512500008, -1.775793765999936],
      [130.5326024430001, -2.04532917399996],
      [130.21634404600002, -2.045304512999962],
      [130.20927494500006, -1.775764305999928],
      [130.52551512500008, -1.775793765999936]],
     [[130.73531545600008, 0.095971656000074],
      [130.73502604200007, -0.17356375199995],
      [130.4188418750001, -0.173539090999952],
      [130.4191317630001, 0.096001116000025],
      [130.73531545600008, 0.095971656000074]],
     [[96.21905409500005, 2.886609354000029],
      [96.21061517200008, 2.617073946000062],
      [95.89431097700003, 2.617098607000059],
      [95.90272383000007, 2.886638814000037],
      [96.21905409500005, 2.886609354000029]],
     [[129.87493079500007, -7.896532350999962],
      [129.89830634600003, -8.16606775899993],
      [129.5811000430001, -8.166043097999932],
      [129.55778230400006, -7.896502890999955],
      [129.87493079500007, -7.896532350999962]],
     [[125.82994504600003, -1.809154590999981],
      [125.83688828400011, -2.078689998999948],
      [125.52062746600006, -2.078665337999951],
      [125.5137027610001, -1.809125130999973],
      [125.82994504600003, -1.809154590999981]],
     [[126.4303526330001, -7.53602451699993],
      [126.45220371300002, -7.805559924999955],
      [126.13507496700004, -7.805535263999957],
      [126.11327947200004, -7.53599505699998],
      [126.4303526330001, -7.53602451699993]],
     [[124.96605330000011, -1.797098366999933],
      [124.97290031900002, -2.066633774999957],
      [124.65664039500007, -2.066609113999959],
      [124.64981179600011, -1.797068906999925],
      [124.96605330000011, -1.797098366999933]],
     [[99.19079499600008, -1.067090681999957],
      [99.19395159100009, -1.336626088999935],
      [98.87773601800006, -1.336601428999927],
      [98.87459091400007, -1.06706122099996],
      [99.19079499600008, -1.067090681999957]],
     [[97.55229578800004, 1.114461861000052],
      [97.54896802100006, 0.844926453000028],
      [97.23277203600009, 0.844951114000025],
      [97.23609058200003, 1.11449132100006],
      [97.55229578800004, 1.114461861000052]]]},
   'id': 'ID'},
  {'type': 'Feature',
   'properties': {'id': 'SC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[55.82314125600004, -3.755034178999949],
      [55.82925932100005, -4.024569586999974],
      [55.512788080000064, -4.024544925999976],
      [55.506707135000056, -3.755004718999942],
      [55.82314125600004, -3.755034178999949]],
     [[55.678163332000054, -4.6465986499999],
      [55.68576766600006, -4.916134057999955],
      [55.36915483000007, -4.916109396999957],
      [55.36159615400004, -4.64656919],
      [55.678163332000054, -4.6465986499999]],
     [[46.65085031600006, -9.22432630999998],
      [46.660177401000055, -9.493861717999948],
      [46.34266121200005, -9.49383705699995],
      [46.33340047200005, -9.224296849999973],
      [46.65085031600006, -9.22432630999998]]]},
   'id': 'SC'},
  {'type': 'Feature',
   'properties': {'id': 'TK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-171.58917539299998, -8.831903301999944],
      [-171.62423792799999, -9.101438708999979],
      [-171.94165375799997, -9.10141405],
      [-171.90652666899996, -8.831873840999947],
      [-171.58917539299998, -8.831903301999944]]]},
   'id': 'TK'},
  {'type': 'Feature',
   'properties': {'id': 'ZM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[31.08880582100005, -8.45691424499995],
      [33.099764710000045, -9.302268844999958],
      [33.10619365100007, -9.55089133399997],
      [33.258512051000025, -14.013821701999973],
      [30.26345542200005, -15.055977949999942],
      [30.287953621000042, -15.877602929999966],
      [29.272275652000076, -15.878187869999977],
      [27.201265960000057, -17.75447656199998],
      [24.882415861000027, -17.75447656199998],
      [24.01333838200003, -17.301085745999956],
      [22.925680085000067, -17.301085745999956],
      [21.991604192000068, -16.22943472399993],
      [21.899657838000053, -12.973264313999948],
      [23.921745101000056, -12.98847148599998],
      [23.88104288900007, -11.365787781999927],
      [24.068428010000048, -11.365787781999927],
      [27.166192485000067, -11.365787781999927],
      [28.852642745000026, -12.80839492499996],
      [29.839790079000068, -12.80839492499996],
      [29.82103726300005, -12.231352067999978],
      [28.56851599400005, -11.159701046999942],
      [28.52694860500003, -9.511007167999935],
      [29.72139118000007, -8.439356146999955],
      [31.08880582100005, -8.45691424499995]]]},
   'id': 'ZM'},
  {'type': 'Feature',
   'properties': {'id': 'TV'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[178.80810452200012, -7.294804936999981],
      [178.8383476560001, -7.564340343999959],
      [178.52126824700008, -7.564315683999951],
      [178.49107907000007, -7.294775475999927],
      [178.80810452200012, -7.294804936999981]]]},
   'id': 'TV'},
  {'type': 'Feature',
   'properties': {'id': 'IO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[72.10523245700006, -6.19046425199997],
      [72.11560669300007, -6.459999659999937],
      [71.79874138700006, -6.45997499899994],
      [71.78841453000007, -6.190434791999962],
      [72.10523245700006, -6.19046425199997]],
     [[71.34459658400004, -3.461949077999975],
      [71.35190617800004, -3.731484485999943],
      [71.03547514000007, -3.731459824999945],
      [71.02819984700005, -3.461919617999968],
      [71.34459658400004, -3.461949077999975]]]},
   'id': 'IO'},
  {'type': 'Feature',
   'properties': {'id': 'AO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[16.58728751800004, -6.089967369999954],
      [16.60596577900003, -7.944747983999946],
      [19.227016466000066, -7.944747983999946],
      [19.212063482000076, -6.708227573999977],
      [21.690771531000053, -6.708227573999977],
      [21.759043655000028, -10.91239696599996],
      [23.87023124600006, -10.91239696599996],
      [23.88104288900007, -11.365787781999927],
      [23.921745101000056, -12.98847148599998],
      [21.899657838000053, -12.973264313999948],
      [21.991604192000068, -16.22943472399993],
      [22.925680085000067, -17.301085745999956],
      [21.94836063400004, -17.75447656199998],
      [19.913451363000036, -17.75447656199998],
      [18.81028513900003, -17.25986839799998],
      [11.787179266000066, -17.252850587999944],
      [11.74166168000005, -14.632894478999958],
      [13.160331958000029, -13.344220436999933],
      [13.116333565000048, -10.046832679999966],
      [11.981846909000069, -9.057616351999968],
      [11.958856226000023, -6.089967369999954],
      [16.58728751800004, -6.089967369999954]],
     [[13.363710578000052, -4.930101316999981],
      [11.741311707000023, -5.648847814999954],
      [11.313054683000075, -4.779853734999961],
      [12.929162099000052, -4.05146902599995],
      [13.363710578000052, -4.930101316999981]]]},
   'id': 'AO'},
  {'type': 'Feature',
   'properties': {'id': 'KI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-159.48628454999997, 3.938923942000031],
      [-159.46839822899997, 3.669388534000063],
      [-159.78482200599998, 3.669413194000072],
      [-159.80274515499997, 3.938953402000038],
      [-159.48628454999997, 3.938923942000031]],
     [[-157.50260726799996, 2.092758317000062],
      [-157.49373851899998, 1.823222909000037],
      [-157.80998175499997, 1.823247569000046],
      [-157.81886949599996, 2.092787777000069],
      [-157.50260726799996, 2.092758317000062]],
     [[-154.74487082, -3.904617778999977],
      [-154.76420192699996, -4.174153185999955],
      [-155.08069251699996, -4.174128526999937],
      [-155.06132257399997, -3.904588317999981],
      [-154.74487082, -3.904617778999977]],
     [[-155.68344138999998, -5.487851392999971],
      [-155.70510596099996, -5.757386799999949],
      [-156.02184788499997, -5.75736214099993],
      [-156.00013984799998, -5.487821931999974],
      [-155.68344138999998, -5.487851392999971]],
     [[176.6404187290001, -1.257787622999956],
      [176.64740279600005, -1.52732303099998],
      [176.33117717200003, -1.527298369999926],
      [176.3242064110001, -1.257758162999949],
      [176.6404187290001, -1.257787622999956]],
     [[173.20081910900012, 1.865020271000049],
      [173.1913284640001, 1.595484864000071],
      [172.87510057500003, 1.595509524000022],
      [172.88457500200002, 1.865049732000045],
      [173.20081910900012, 1.865020271000049]],
     [[-176.30506686199996, 0.247006624000051],
      [-176.30491202199997, -0.022528783999974],
      [-176.62109559199996, -0.022504123999965],
      [-176.62125165799998, 0.247036084000058],
      [-176.30506686199996, 0.247006624000051]],
     [[-171.46307038599997, -2.728673447999938],
      [-171.47834211999998, -2.998208854999973],
      [-171.79468351399998, -2.998184195999954],
      [-171.77938429999998, -2.728643987999931],
      [-171.46307038599997, -2.728673447999938]]]},
   'id': 'KI'},
  {'type': 'Feature',
   'properties': {'id': 'BI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[31.014712274000033, -3.66223761699996],
      [30.046032824000065, -4.527801902999954],
      [29.100670965000063, -3.703454963999945],
      [29.089959087000068, -2.673021289999951],
      [31.003316287000075, -2.672984207999946],
      [31.014712274000033, -3.66223761699996]]]},
   'id': 'BI'},
  {'type': 'Feature',
   'properties': {'id': 'RW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[31.003316287000075, -2.672984207999946],
      [29.089959087000068, -2.673021289999951],
      [29.063377708000075, -1.108775063999929],
      [30.975378350000028, -1.102668386999937],
      [31.003316287000075, -2.672984207999946]]]},
   'id': 'RW'},
  {'type': 'Feature',
   'properties': {'id': 'TZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[38.22644370100005, -11.587572464999937],
      [34.624959524000076, -11.587572464999937],
      [34.56976974300005, -9.919227282999941],
      [33.099764710000045, -9.302268844999958],
      [31.08880582100005, -8.45691424499995],
      [31.053635883000027, -7.202835737999976],
      [30.08755467900005, -6.89017324699995],
      [30.046032824000065, -4.527801902999954],
      [31.014712274000033, -3.66223761699996],
      [31.003316287000075, -2.672984207999946],
      [30.975378350000028, -1.102668386999937],
      [34.04729438800007, -1.08823685699997],
      [37.63037136400004, -3.010053604999939],
      [37.63601812200005, -3.42611702499994],
      [39.43308304200008, -4.753557459999968],
      [38.898542761000044, -5.703832365999972],
      [38.91887231100003, -6.77753830499995],
      [39.64710394200006, -7.405876100999933],
      [39.71058371300006, -9.691721516999962],
      [40.60039451000006, -10.439230975999976],
      [38.22644370100005, -11.587572464999937]],
     [[39.81237546800003, -5.338192731999925],
      [39.817242788000044, -5.60772813899996],
      [39.50052256600003, -5.607703478999952],
      [39.49569741500005, -5.338163270999928],
      [39.81237546800003, -5.338192731999925]]]},
   'id': 'TZ'},
  {'type': 'Feature',
   'properties': {'id': 'EC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-78.40497467799997, -4.967534056999966],
      [-79.94911560599996, -4.967534056999966],
      [-81.23252438499998, -3.794104800999946],
      [-80.53991169099999, -3.19927258599995],
      [-80.49377832099998, 0.082179982000071],
      [-79.04999223999994, 1.363399076000064],
      [-77.04311344399997, 1.372479959000032],
      [-75.68937779, 0.183727331000057],
      [-75.69642303899997, -1.302213453999968],
      [-75.70872792599994, -2.144246565999936],
      [-76.967918, -3.23393647499995],
      [-78.34251120999994, -3.23393647499995],
      [-78.40497467799997, -4.967534056999966]],
     [[-90.85959843499995, 0.157349185000044],
      [-90.86480972699997, -1.024159552999947],
      [-91.27024558499994, -1.02275500099995],
      [-91.26086431299996, 0.157349185000044],
      [-90.85959843499995, 0.157349185000044]],
     [[-90.45608674199997, 0.643179520000047],
      [-90.45514094999999, 0.373644112000022],
      [-90.77132708799996, 0.37366877300002],
      [-90.77227783099994, 0.643208981000043],
      [-90.45608674199997, 0.643179520000047]],
     [[-91.34639381999995, -0.333647983999924],
      [-91.34812806899998, -0.603183390999959],
      [-91.66431792899994, -0.603158730999951],
      [-91.66257926199995, -0.333618522999927],
      [-91.34639381999995, -0.333647983999924]],
     [[-90.11598639699997, -0.467511993999949],
      [-90.11806744099994, -0.737047401999973],
      [-90.43426044799997, -0.737022740999976],
      [-90.43217369899997, -0.467482533999942],
      [-90.11598639699997, -0.467511993999949]],
     [[-89.34885786799998, -0.720370966999951],
      [-89.35160707799997, -0.989906374999975],
      [-89.66780775599995, -0.989881713999978],
      [-89.66505041399995, -0.720341506999944],
      [-89.34885786799998, -0.720370966999951]]]},
   'id': 'EC'},
  {'type': 'Feature',
   'properties': {'id': 'NR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[167.29725843900007, -0.760465883999927],
      [166.7207453640001, -0.760465883999927],
      [166.71616134600004, -0.295508531999928],
      [167.29265856900008, -0.295508531999928],
      [167.29725843900007, -0.760465883999927]]]},
   'id': 'NR'},
  {'type': 'Feature',
   'properties': {'id': 'PE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-72.76920256899996, -2.416669042999956],
      [-70.83405164999994, -2.416669042999956],
      [-70.86036354499998, -3.531124631999944],
      [-70.23218307899998, -4.100735265999958],
      [-70.98988191299998, -4.100735265999958],
      [-73.39538443499998, -6.156286684999941],
      [-73.52005489399994, -8.806214417999968],
      [-72.05000258099994, -10.168326804999936],
      [-70.72600370099997, -10.168326804999936],
      [-70.77560934499996, -10.936062876999927],
      [-69.73258131099993, -10.936062876999927],
      [-68.75180108699993, -11.852393027999938],
      [-69.26831110199998, -17.598030729999948],
      [-70.18394360499997, -18.306337233999955],
      [-71.65787683099995, -16.88231064699994],
      [-73.50360605799995, -16.88231064699994],
      [-76.72922911099994, -13.786600678999946],
      [-76.57719633499994, -12.022045995999974],
      [-78.52022358299996, -10.195577114999935],
      [-78.42288728799997, -8.616765030999943],
      [-81.61600290599995, -5.675840560999973],
      [-81.55052823599993, -4.066071376999957],
      [-81.23252438499998, -3.794104800999946],
      [-79.94911560599996, -4.967534056999966],
      [-78.40497467799997, -4.967534056999966],
      [-78.34251120999994, -3.23393647499995],
      [-76.967918, -3.23393647499995],
      [-75.70872792599994, -2.144246565999936],
      [-75.69642303899997, -1.302213453999968],
      [-75.68937779, 0.183727331000057],
      [-72.76920256899996, -2.416669042999956]]]},
   'id': 'PE'},
  {'type': 'Feature',
   'properties': {'id': 'ST'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[6.703365648000045, 0.19122365000004],
      [6.702911696000058, -0.078311756999938],
      [6.386728015000074, -0.078287096999929],
      [6.387181433000023, 0.191253111000037],
      [6.703365648000045, 0.19122365000004]],
     [[7.565340990000038, 1.682709331000069],
      [7.564544851000051, 1.413173924000034],
      [7.248325943000054, 1.413198584000043],
      [7.24910731600005, 1.68273879100002],
      [7.565340990000038, 1.682709331000069]]]},
   'id': 'ST'},
  {'type': 'Feature',
   'properties': {'id': 'MV'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[73.03791136900003, 0.84727919900007],
      [73.03589781200003, 0.577743791000046],
      [72.71970844600008, 0.577768452000043],
      [72.72171529000008, 0.847308659000021],
      [73.03791136900003, 0.84727919900007]],
     [[73.21115842700004, 5.503226992000066],
      [73.20110003800005, 5.233691584000042],
      [72.88443933600007, 5.233716245000039],
      [72.89445634000003, 5.503256452000073],
      [73.21115842700004, 5.503226992000066]],
     [[73.44674634400008, 3.344488155000022],
      [73.43918319400007, 3.074952747000054],
      [73.12283273700007, 3.074977408000052],
      [73.13036540000007, 3.344517615000029],
      [73.44674634400008, 3.344488155000022]]]},
   'id': 'MV'},
  {'type': 'Feature',
   'properties': {'id': 'GQ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[11.297624058000054, 1.091654509000023],
      [9.445735055000057, 1.091654509000023],
      [9.448732674000041, 2.213546430000065],
      [11.299970680000058, 2.213546430000065],
      [11.297624058000054, 1.091654509000023]],
     [[8.843952756000022, 3.916285114000061],
      [8.842499553000039, 3.646749706000037],
      [8.526080420000028, 3.646774367000035],
      [8.527497495000034, 3.916314574000069],
      [8.843952756000022, 3.916285114000061]]]},
   'id': 'GQ'},
  {'type': 'Feature',
   'properties': {'id': 'GA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[13.299734363000027, 2.212298247000035],
      [13.293952597000043, 1.120710193000036],
      [14.469115121000073, 1.120710193000036],
      [14.469355227000051, -1.245911263999972],
      [14.47125047700007, -1.972505570999942],
      [11.180309803000057, -1.972505570999942],
      [10.639655264000055, -1.972505570999942],
      [10.642388422000067, -3.417497383999944],
      [9.017336992000025, -1.78566703499996],
      [9.01574081800004, -0.166399721999937],
      [9.443940974000043, 0.456395398000041],
      [9.445735055000057, 1.091654509000023],
      [11.297624058000054, 1.091654509000023],
      [11.299970680000058, 2.213546430000065],
      [13.299734363000027, 2.212298247000035]]]},
   'id': 'GA'},
  {'type': 'Feature',
   'properties': {'id': 'CG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[17.841678655000067, 2.470091915000069],
      [17.831457691000026, -0.873766667999973],
      [16.19721042900005, -2.328748769999947],
      [16.19919874800007, -4.131528655999944],
      [13.363710578000052, -4.930101316999981],
      [12.929162099000052, -4.05146902599995],
      [11.313054683000075, -4.779853734999961],
      [10.642388422000067, -3.417497383999944],
      [10.639655264000055, -1.972505570999942],
      [11.180309803000057, -1.972505570999942],
      [14.47125047700007, -1.972505570999942],
      [14.469355227000051, -1.245911263999972],
      [14.469115121000073, 1.120710193000036],
      [13.293952597000043, 1.120710193000036],
      [13.299734363000027, 2.212298247000035],
      [16.13500900100007, 2.210528565000061],
      [17.055198276000056, 3.468648217000066],
      [18.514078854000047, 3.468648217000066],
      [17.841678655000067, 2.470091915000069]]]},
   'id': 'CG'},
  {'type': 'Feature',
   'properties': {'id': 'UG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[34.90329727300008, 1.744956907000073],
      [34.04504883800007, 0.080703228000061],
      [34.04729438800007, -1.08823685699997],
      [30.975378350000028, -1.102668386999937],
      [29.063377708000075, -1.108775063999929],
      [29.079040939000038, 0.665583815000048],
      [30.510064337000074, 1.411589779000053],
      [30.54591234700007, 3.607336024000062],
      [33.44138841700004, 3.607336024000062],
      [33.789395383000056, 3.991071232000024],
      [34.90329727300008, 1.744956907000073]]]},
   'id': 'UG'},
  {'type': 'Feature',
   'properties': {'id': 'KE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[37.45889622000004, 4.271056242000043],
      [38.067031678000035, 3.726211287000069],
      [39.86276348300004, 3.726211287000069],
      [40.31618329300005, 3.983774356000026],
      [41.910118999000076, 3.982319],
      [40.97630848000006, 3.171460060000072],
      [40.95473623600003, -0.810861242999977],
      [41.56450025200007, -1.664949852999939],
      [39.98663230300008, -3.010053604999939],
      [40.016980957000044, -4.753557459999968],
      [39.43308304200008, -4.753557459999968],
      [37.63601812200005, -3.42611702499994],
      [37.63037136400004, -3.010053604999939],
      [34.04729438800007, -1.08823685699997],
      [34.04504883800007, 0.080703228000061],
      [34.90329727300008, 1.744956907000073],
      [33.789395383000056, 3.991071232000024],
      [34.304759303000026, 4.558338126000024],
      [35.27482926700003, 4.558338126000024],
      [35.99474909200006, 4.558338126000024],
      [37.138621096000065, 4.558338126000024],
      [37.45889622000004, 4.271056242000043]]]},
   'id': 'KE'},
  {'type': 'Feature',
   'properties': {'id': 'II'}, // Ilemi Triangle
   'geometry': {'type': 'Polygon',
    'coordinates': [[[35.27482926700003, 4.558338126000024],
      [34.304759303000026, 4.558338126000024],
      [34.87080583900007, 4.909270509000066],
      [35.27482926700003, 4.558338126000024]]]},
   'id': 'II'},
  {'type': 'Feature',
   'properties': {'id': 'BR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-59.38012177999997, 4.393892889000028],
      [-59.681095580999965, 4.121470411000075],
      [-59.635974990999955, 1.867793554000059],
      [-57.252407423999955, 1.867793554000059],
      [-56.192438477999985, 1.867793554000059],
      [-54.25191648499998, 1.867793554000059],
      [-53.97149676999993, 1.867793554000059],
      [-52.20485257399997, 1.867793554000059],
      [-52.24257352899997, 4.047173372000032],
      [-51.640442391999954, 4.591109738000057],
      [-51.254463606999934, 4.257990758000062],
      [-51.228637007999964, 3.029613052000059],
      [-49.481525928999986, 1.504047179000054],
      [-51.583972753999944, -0.358331937999935],
      [-51.02495419599995, -0.853645532999963],
      [-48.91731513499997, 1.008733584000026],
      [-45.293284538999956, -2.200898510999934],
      [-39.932138934999955, -2.201779361999968],
      [-36.30099065199994, -5.469968237999979],
      [-36.43436764299997, -10.759917432999941],
      [-39.87212147099996, -13.672361371999955],
      [-40.42049819499994, -22.271005380999952],
      [-42.62999157899998, -24.05413432299997],
      [-46.50342845199998, -24.06101571299996],
      [-48.32250136699997, -25.50045002],
      [-48.922723305999966, -30.01771000699995],
      [-51.70536331799997, -32.05840201799998],
      [-52.598235950999936, -32.05847049899995],
      [-52.764981509999984, -32.95326668399997],
      [-54.67206711499995, -31.045794833999935],
      [-55.88587368299994, -31.033411993999948],
      [-57.17168979099995, -29.745935908999968],
      [-54.11565010399994, -27.45477127099997],
      [-53.874731285999985, -25.696408007999935],
      [-54.85602011199995, -25.696408007999935],
      [-54.658460058999935, -24.012341784999933],
      [-55.90987842099997, -22.823589156999958],
      [-55.82163409799995, -21.98155604599998],
      [-56.39455490399996, -21.98155604599998],
      [-58.141963362999945, -21.98155604599998],
      [-57.930826414999956, -19.95077030599998],
      [-57.66685268799995, -17.25131121299995],
      [-58.774919025999964, -17.25131121299995],
      [-58.68087699299997, -16.186386983999967],
      [-60.66653179799994, -16.186386983999967],
      [-60.45246675499993, -13.486927890999937],
      [-62.37458226499996, -13.486927890999937],
      [-65.91033796199997, -10.193092483999976],
      [-67.23436569999996, -10.193092483999976],
      [-68.12575433899997, -10.936062876999927],
      [-69.73258131099993, -10.936062876999927],
      [-70.77560934499996, -10.936062876999927],
      [-70.72600370099997, -10.168326804999936],
      [-72.05000258099994, -10.168326804999936],
      [-73.52005489399994, -8.806214417999968],
      [-73.39538443499998, -6.156286684999941],
      [-70.98988191299998, -4.100735265999958],
      [-70.23218307899998, -4.100735265999958],
      [-69.39029548599996, -4.100735265999958],
      [-69.3276361, -0.831665538999971],
      [-70.13805966699994, -0.113460825999937],
      [-70.15245093599998, 1.917324914000062],
      [-67.71277380499998, 1.917324914000062],
      [-67.14570783399995, 1.422011319000035],
      [-66.53826824399994, 0.889549203000058],
      [-64.09898526399996, 0.889549203000058],
      [-64.15144261399996, 3.923344973000042],
      [-62.67825686499998, 3.923344973000042],
      [-62.22702111399997, 4.331978689000039],
      [-60.72585652599997, 4.344361529000025],
      [-60.75107653799995, 5.161628961000076],
      [-60.273975674999974, 5.161628961000076],
      [-59.38012177999997, 4.393892889000028]]]},
   'id': 'BR'},
  {'type': 'Feature',
   'properties': {'id': 'CD'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[27.72817784800003, 4.439462864000063],
      [29.614311892000046, 4.439462864000063],
      [30.54591234700007, 3.607336024000062],
      [30.510064337000074, 1.411589779000053],
      [29.079040939000038, 0.665583815000048],
      [29.063377708000075, -1.108775063999929],
      [29.089959087000068, -2.673021289999951],
      [29.100670965000063, -3.703454963999945],
      [30.046032824000065, -4.527801902999954],
      [30.08755467900005, -6.89017324699995],
      [31.053635883000027, -7.202835737999976],
      [31.08880582100005, -8.45691424499995],
      [29.72139118000007, -8.439356146999955],
      [28.52694860500003, -9.511007167999935],
      [28.56851599400005, -11.159701046999942],
      [29.82103726300005, -12.231352067999978],
      [29.839790079000068, -12.80839492499996],
      [28.852642745000026, -12.80839492499996],
      [27.166192485000067, -11.365787781999927],
      [24.068428010000048, -11.365787781999927],
      [23.88104288900007, -11.365787781999927],
      [23.87023124600006, -10.91239696599996],
      [21.759043655000028, -10.91239696599996],
      [21.690771531000053, -6.708227573999977],
      [19.212063482000076, -6.708227573999977],
      [19.227016466000066, -7.944747983999946],
      [16.60596577900003, -7.944747983999946],
      [16.58728751800004, -6.089967369999954],
      [11.958856226000023, -6.089967369999954],
      [11.741311707000023, -5.648847814999954],
      [13.363710578000052, -4.930101316999981],
      [16.19919874800007, -4.131528655999944],
      [16.19721042900005, -2.328748769999947],
      [17.831457691000026, -0.873766667999973],
      [17.841678655000067, 2.470091915000069],
      [18.514078854000047, 3.468648217000066],
      [18.521865138000067, 4.419650320000073],
      [19.532577504000074, 5.115319247000059],
      [20.553992850000043, 4.419650320000073],
      [22.99016253600007, 4.419650320000073],
      [23.69584447400007, 5.212152072000038],
      [27.739161245000048, 5.212152072000038],
      [27.72817784800003, 4.439462864000063]]]},
   'id': 'CD'},
  {'type': 'Feature',
   'properties': {'id': 'FM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[151.79313604900005, 7.461963221000076],
      [151.76695024600008, 7.192427814000041],
      [151.4499506290001, 7.192452474000049],
      [151.47608320200004, 7.461992682000073],
      [151.79313604900005, 7.461963221000076]],
     [[138.24500604700006, 9.586895878000064],
      [138.21535832200004, 9.31736047000004],
      [137.89788939800007, 9.317385131000037],
      [137.92747063600007, 9.586925338000071],
      [138.24500604700006, 9.586895878000064]],
     [[158.35280771700002, 7.118322118000037],
      [158.32657372300002, 6.848786711000059],
      [158.00964022400012, 6.848811371000068],
      [158.0358231350001, 7.118351579000034],
      [158.35280771700002, 7.118322118000037]],
     [[163.16596790300002, 5.406287114000065],
      [163.14440370800003, 5.13675170700003],
      [162.82775858900004, 5.136776367000039],
      [162.84928225200008, 5.406316574000073],
      [163.16596790300002, 5.406287114000065]]]},
   'id': 'FM'},
  {'type': 'Feature',
   'properties': {'id': 'BN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[114.78533073200003, 3.548655576000044],
      [113.691135873, 3.548655576000044],
      [113.73804909800003, 4.476467781000053],
      [114.8873463860001, 5.442133530000035],
      [114.78533073200003, 3.548655576000044]]]},
   'id': 'BN'},
  {'type': 'Feature',
   'properties': {'id': 'CR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-82.63460028399999, 9.450765128000057],
      [-83.68750383299994, 8.47060800600002],
      [-86.08239802499997, 10.459237949000055],
      [-85.27859622499994, 11.219171921000054],
      [-84.44686419799996, 11.219171921000054],
      [-84.09058499299994, 10.926971151000032],
      [-83.21022228599998, 10.926935800000024],
      [-83.13374018199994, 9.865913705000025],
      [-82.63460028399999, 9.450765128000057]],
     [[-86.91908368499998, 5.640789030000064],
      [-86.90787822499999, 5.37125362300003],
      [-87.22456185399994, 5.371278284000027],
      [-87.23581001499997, 5.640818492000051],
      [-86.91908368499998, 5.640789030000064]]]},
   'id': 'CR'},
  {'type': 'Feature',
   'properties': {'id': 'SR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-53.97149676999993, 1.867793554000059],
      [-54.25191648499998, 1.867793554000059],
      [-56.192438477999985, 1.867793554000059],
      [-56.37061593399994, 2.023464459000024],
      [-57.052461920999974, 2.617840773000069],
      [-57.13400427999994, 5.837379141000042],
      [-54.05918448099993, 5.841648005000025],
      [-53.97149676999993, 1.867793554000059]]]},
   'id': 'SR'},
  {'type': 'Feature',
   'properties': {'id': 'GF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-51.640442391999954, 4.591109738000057],
      [-52.24257352899997, 4.047173372000032],
      [-52.20485257399997, 1.867793554000059],
      [-53.97149676999993, 1.867793554000059],
      [-54.05918448099993, 5.841648005000025],
      [-53.09292296999996, 5.842989491000026],
      [-51.640442391999954, 4.591109738000057]]]},
   'id': 'GF'},
  {'type': 'Feature',
   'properties': {'id': 'PH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[122.54088240500005, 18.578877738000074],
      [121.77100352200011, 14.30160550200003],
      [124.46446492400003, 14.30160550200003],
      [124.25894649200006, 12.90952739900007],
      [123.36260852500004, 12.90952739900007],
      [123.4569586560001, 13.571887142000037],
      [119.49724061900008, 13.571887142000037],
      [119.93015799400007, 16.311137603000077],
      [120.16165683200006, 16.311137603000077],
      [120.5919107310001, 18.578877738000074],
      [122.54088240500005, 18.578877738000074]],
     [[126.91804989500008, 9.87528401700007],
      [126.60389768800007, 6.244227223000053],
      [126.16043242500007, 6.244227223000053],
      [126.19120711200003, 6.67491826600002],
      [125.61982437800009, 6.67491826600002],
      [125.52138930300009, 5.190690672000073],
      [123.900175364, 5.939430485000059],
      [124.00941849300011, 7.450162144000046],
      [123.04663446100005, 7.450162144000046],
      [122.44476320900003, 6.953210940000076],
      [122.18051664600011, 6.734361301000035],
      [122.33800381200001, 8.700010167000073],
      [124.195088284, 8.700010167000073],
      [125.64463298100009, 9.87528401700007],
      [126.91804989500008, 9.87528401700007]],
     [[120.62757311000007, 11.012259662000076],
      [117.43860254100002, 8.430179310000028],
      [117.13165156700006, 8.722066655000049],
      [120.32927598300012, 11.30414700700004],
      [120.62757311000007, 11.012259662000076]],
     [[122.99641636100012, 8.892962751000027],
      [122.18510343000003, 8.890463199000067],
      [122.34758295200004, 10.518296465000049],
      [123.16510103500002, 10.518296465000049],
      [122.99641636100012, 8.892962751000027]],
     [[123.84411508100004, 9.62268111000003],
      [123.26513353200005, 9.62268111000003],
      [123.42745103800007, 11.143637843000022],
      [124.00721594000004, 11.143637843000022],
      [123.84411508100004, 9.62268111000003]],
     [[124.81788879700002, 9.849576346000049],
      [124.23880154900007, 9.849576346000049],
      [124.40728236900009, 11.37053307900004],
      [124.98717570500003, 11.37053307900004],
      [124.81788879700002, 9.849576346000049]],
     [[122.90689759300005, 11.777618933000042],
      [122.78713027800006, 10.83468089300004],
      [121.972847365, 10.834746546000076],
      [122.08377079500008, 11.777618933000042],
      [122.90689759300005, 11.777618933000042]],
     [[121.46287891100008, 13.16284827100003],
      [121.34521906100008, 12.330093365000039],
      [120.63314062000006, 12.330159018000074],
      [120.74203835100002, 13.16284827100003],
      [121.46287891100008, 13.16284827100003]],
     [[125.2056724790001, 11.62807166500005],
      [124.62563009000007, 11.62807166500005],
      [124.74918393100006, 12.590984065000043],
      [125.32981453100001, 12.590984065000043],
      [125.2056724790001, 11.62807166500005]],
     [[123.96862130700003, 12.426708027000075],
      [123.86806913400005, 11.698518297000021],
      [123.29607600100007, 11.698583950000057],
      [123.38809451700001, 12.426708027000075],
      [123.96862130700003, 12.426708027000075]],
     [[121.42026936100001, 5.99966493900007],
      [121.40270355700011, 5.730129531000046],
      [121.0859656240001, 5.730154192000043],
      [121.10348712500002, 5.99969439900002],
      [121.42026936100001, 5.99966493900007]],
     [[120.08013725400008, 5.205737722000038],
      [120.0638625360001, 4.93620231400007],
      [119.74724857600006, 4.936226975000068],
      [119.7634815890001, 5.205767182000045],
      [120.08013725400008, 5.205737722000038]]]},
   'id': 'PH'},
  {'type': 'Feature',
   'properties': {'id': 'MY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[119.09462404300007, 5.234914912000022],
      [117.6976665200001, 4.06364609600007],
      [115.73688252500006, 4.068734852000034],
      [115.64811161700004, 1.691229596000028],
      [113.04030006500011, 1.691229596000028],
      [111.69916784600008, 0.521051227000044],
      [109.11646935300007, 0.509451069000022],
      [113.73804909800003, 4.476467781000053],
      [113.691135873, 3.548655576000044],
      [114.78533073200003, 3.548655576000044],
      [114.8873463860001, 5.442133530000035],
      [116.992218922, 7.200492465000025],
      [119.09462404300007, 5.234914912000022]]]},
   'id': 'MY'},
  {'type': 'Feature',
   'properties': {'id': 'IN'}, // India
   'geometry': {'type': 'Polygon',
    'coordinates': [[[79.71606454100004, 29.51820234300004],
      [82.72688369000008, 26.751423239000076],
      [84.00040999800007, 26.751423239000076],
      [87.78833440300008, 26.751423239000076],
      [88.05659352500004, 27.897263353000028],
      [89.40199693900007, 27.90841622000005],
      [89.13219966400004, 26.77459628200006],
      [92.27086877200009, 26.770054567000045],
      [92.34449949000003, 27.081788002000053],
      [94.88992803000008, 27.082016167000063],
      [94.89009365800007, 27.082016182000075],
      [94.25368953800006, 24.217188298000053],
      [93.45000535200006, 24.221962518000055],
      [93.06745525300005, 22.097981231000063],
      [92.30000359100006, 23.46232844900004],
      [92.58809381500004, 25.026280946000043],
      [90.27441971500008, 25.026280946000043],
      [90.42580997200008, 25.741230659000053],
      [87.95201623400004, 25.741230659000053],
      [87.74459159100007, 24.691148267000074],
      [89.06318448500008, 21.46937351300005],
      [87.29749205300004, 21.46937351300005],
      [87.12112512800007, 20.336496389000047],
      [80.56359114300005, 15.477712277000023],
      [80.11327192500005, 10.543403026000021],
      [77.71798200400008, 7.874848022000037],
      [75.46271046400005, 9.964376940000022],
      [75.57800727000006, 11.600755008000021],
      [74.27021748500005, 12.834332321000034],
      [74.48857247900008, 15.225961805000054],
      [72.65733648000008, 16.988215110000056],
      [73.26071438100007, 21.796649126000034],
      [72.76488962300004, 22.269260248000023],
      [70.46748003000005, 20.481831897000063],
      [69.09397411600008, 21.811581080000053],
      [69.67646806300007, 22.26473192900005],
      [67.79669605300006, 24.116468461000068],
      [71.11961855800007, 24.116468461000068],
      [71.36284715300008, 25.701471965000053],
      [69.98715839700003, 27.086790402000076],
      [74.42078162400003, 30.08587202800004],
      [74.95884843000005, 32.23891058900006],
      [77.32744738500008, 33.838015186000064],
      [80.65437257900004, 30.173522580000053],
      [79.71606454100004, 29.51820234300004]],
     [[93.04496147100008, 13.344274253000037],
      [92.86348224800008, 11.44097363800006],
      [92.54541459600006, 11.440998299000057],
      [92.72624143400003, 13.344303713000045],
      [93.04496147100008, 13.344274253000037]],
     [[92.92630396700008, 9.259205818000055],
      [92.90682775600004, 8.98967041000003],
      [92.58943717900007, 8.989695071000028],
      [92.60884876000006, 9.259235278000062],
      [92.92630396700008, 9.259205818000055]],
     [[93.81598481200007, 7.392352318000064],
      [93.79975893600005, 7.12281691000004],
      [93.48277203500004, 7.122841571000038],
      [93.49894490600008, 7.392381778000072],
      [93.81598481200007, 7.392352318000064]],
     [[93.34180925400005, 8.346286211000063],
      [93.32391967900008, 8.076750804000028],
      [93.00673661100006, 8.076775464000036],
      [93.02456725100006, 8.34631567200006],
      [93.34180925400005, 8.346286211000063]],
     [[72.59351820900008, 11.001207897000029],
      [72.57465751600006, 10.731672489000061],
      [72.25680598400004, 10.731697150000059],
      [72.27558639500006, 11.001237357000036],
      [72.59351820900008, 11.001207897000029]],
     [[92.63587537900008, 10.654488380000032],
      [92.61270344900004, 10.384952972000065],
      [92.29495299400008, 10.384977633000062],
      [92.31804741200006, 10.65451784000004],
      [92.63587537900008, 10.654488380000032]],
     [[72.31614727100003, 12.586211401000071],
      [72.29458972100008, 12.316675993000047],
      [71.97623415100003, 12.316700654000044],
      [71.99769915400003, 12.586240861000022],
      [72.31614727100003, 12.586211401000071]]]},
   'id': 'IN'},
  {'type': 'Feature',
   'properties': {'id': 'PW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[134.7151858410001, 7.491177530000073],
      [134.69181923600001, 7.221642122000048],
      [134.37481361800008, 7.221666783000046],
      [134.39812675000007, 7.491206990000023],
      [134.7151858410001, 7.491177530000073]]]},
   'id': 'PW'},
  {'type': 'Feature',
   'properties': {'id': 'GY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-57.13400427999994, 5.837379141000042],
      [-57.052461920999974, 2.617840773000069],
      [-56.37061593399994, 2.023464459000024],
      [-56.192438477999985, 1.867793554000059],
      [-57.252407423999955, 1.867793554000059],
      [-59.635974990999955, 1.867793554000059],
      [-59.681095580999965, 4.121470411000075],
      [-59.38012177999997, 4.393892889000028],
      [-60.273975674999974, 5.161628961000076],
      [-60.75107653799995, 5.161628961000076],
      [-60.82055252499998, 7.241946060000032],
      [-59.83085060399998, 8.145047265000073],
      [-57.13400427999994, 5.837379141000042]]]},
   'id': 'GY'},
  {'type': 'Feature',
   'properties': {'id': 'LR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-8.615711148999935, 7.820173041000032],
      [-8.924210653999978, 7.547130971000058],
      [-7.896767953999927, 6.645939100000021],
      [-7.8879214899999, 4.503309448000039],
      [-12.053995418999932, 7.055263125000067],
      [-10.09050342699993, 8.803259808000064],
      [-8.615711148999935, 7.820173041000032]]]},
   'id': 'LR'},
  {'type': 'Feature',
   'properties': {'id': 'PA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-78.25640816099997, 9.518221147000077],
      [-76.96654797299993, 8.438437509000039],
      [-77.97688337199997, 7.511685546000024],
      [-78.16072936199998, 7.66666940500005],
      [-78.75337099799998, 8.165418115000023],
      [-79.45455765799994, 8.167854712000064],
      [-79.98836988799997, 7.66666940500005],
      [-82.72983067599995, 7.66666940500005],
      [-83.68750383299994, 8.47060800600002],
      [-82.63460028399999, 9.450765128000057],
      [-82.13359680699995, 9.032813823000026],
      [-80.72644510899994, 9.042298896000034],
      [-80.20536926899996, 9.528127418000054],
      [-78.25640816099997, 9.518221147000077]]]},
   'id': 'PA'},
  {'type': 'Feature',
   'properties': {'id': 'MH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[168.97809482000002, 9.790333751000048],
      [168.94127922300004, 9.520798343000024],
      [168.62376047500004, 9.520823004000022],
      [168.66050844900008, 9.790363211000056],
      [168.97809482000002, 9.790333751000048]],
     [[-177.70191762899998, 28.357259210000052],
      [-177.56793505299999, 28.087723802000028],
      [-177.89545587399996, 28.087748462000036],
      [-178.02968903899998, 28.35728867000006],
      [-177.70191762899998, 28.357259210000052]],
     [[-169.38688571799997, 16.783968482000034],
      [-169.31901238099996, 16.514433075000056],
      [-169.63907779999997, 16.514457734000075],
      [-169.70708162799997, 16.78399794300003],
      [-169.38688571799997, 16.783968482000034]]]},
   'id': 'MH'},
  {'type': 'Feature',
   'properties': {'id': 'LK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[81.65786187600008, 8.735629048000021],
      [81.54665082500009, 6.658499985000049],
      [80.55096348200004, 5.813953004000041],
      [79.76349632500006, 6.167749712000045],
      [79.96264904600008, 9.842670362000035],
      [80.46879597400005, 9.842670362000035],
      [81.65786187600008, 8.735629048000021]]]},
   'id': 'LK'},
  {'type': 'Feature',
   'properties': {'id': 'SL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-10.09050342699993, 8.803259808000064],
      [-12.053995418999932, 7.055263125000067],
      [-13.934612890999972, 8.202940069000022],
      [-11.906664002999946, 10.01057822000007],
      [-10.09050342699993, 8.803259808000064]]]},
   'id': 'SL'},
  {'type': 'Feature',
   'properties': {'id': 'CI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-5.280662284999948, 10.177139900000043],
      [-2.934160720999955, 10.177008408000063],
      [-2.921091327999932, 5.053655500000048],
      [-6.660009147999972, 5.045863737000047],
      [-7.8879214899999, 4.503309448000039],
      [-7.896767953999927, 6.645939100000021],
      [-8.924210653999978, 7.547130971000058],
      [-8.615711148999935, 7.820173041000032],
      [-7.905956749999973, 8.448322842000039],
      [-7.920277877999979, 10.692106683000077],
      [-6.233309997999925, 10.699999999000056],
      [-5.280662284999948, 10.177139900000043]]]},
   'id': 'CI'},
  {'type': 'Feature',
   'properties': {'id': 'TT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-61.06965238, 10.740501509000069],
      [-61.02999978299994, 10.036492825000039],
      [-61.532067799999936, 10.036517486000037],
      [-61.57203849999996, 10.740530969000076],
      [-61.06965238, 10.740501509000069]],
     [[-60.45605392799996, 11.354191426000057],
      [-60.44064806999995, 11.084656018000032],
      [-60.75860874699998, 11.08468067900003],
      [-60.774098315999936, 11.354220886000064],
      [-60.45605392799996, 11.354191426000057]]]},
   'id': 'TT'},
  {'type': 'Feature',
   'properties': {'id': 'CF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[23.272940050000045, 8.659290828000053],
      [23.880031975000065, 8.659404284000061],
      [27.739161245000048, 5.212152072000038],
      [23.69584447400007, 5.212152072000038],
      [22.99016253600007, 4.419650320000073],
      [20.553992850000043, 4.419650320000073],
      [19.532577504000074, 5.115319247000059],
      [18.521865138000067, 4.419650320000073],
      [18.514078854000047, 3.468648217000066],
      [17.055198276000056, 3.468648217000066],
      [16.13500900100007, 2.210528565000061],
      [16.136191507000035, 2.840840618000072],
      [14.828832969000075, 3.997538500000076],
      [14.851787002000037, 6.958597505000057],
      [15.507479998000065, 7.52747],
      [17.109659435000026, 7.52875390500003],
      [19.166471873000035, 9.319683782000027],
      [20.29705264000006, 9.319683782000027],
      [22.004499899000052, 10.797420805000058],
      [23.319811507000054, 10.797721182000032],
      [23.272940050000045, 8.659290828000053]]]},
   'id': 'CF'},
  {'type': 'Feature',
   'properties': {'id': 'GH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-0.133892226999933, 5.457199332000073],
      [-1.926540211999964, 4.604463638000027],
      [-2.921091327999932, 5.053655500000048],
      [-2.934160720999955, 10.177008408000063],
      [-2.940202183999929, 11.13350678300003],
      [-0.134432653999966, 11.13350678300003],
      [-0.133892226999933, 5.457199332000073]]]},
   'id': 'GH'},
  {'type': 'Feature',
   'properties': {'id': 'TG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[0.971532065000019, 5.74474723000003],
      [0.470953782000038, 5.74474723000003],
      [-0.133892226999933, 5.457199332000073],
      [-0.134432653999966, 11.13350678300003],
      [0.975312012000074, 11.13350678300003],
      [0.971532065000019, 5.74474723000003]]]},
   'id': 'TG'},
  {'type': 'Feature',
   'properties': {'id': 'SO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[51.04249912500006, 9.896286047000046],
      [46.82701821900008, 3.287310370000057],
      [41.56450025200007, -1.664949852999939],
      [40.95473623600003, -0.810861242999977],
      [40.97630848000006, 3.171460060000072],
      [41.910118999000076, 3.982319],
      [42.69579276500008, 3.983774356000026],
      [44.874197465000066, 4.934711016000051],
      [47.92192557800007, 8.045345835000035],
      [46.076948136000055, 8.045345835000035],
      [43.19247300500007, 9.333161182000026],
      [43.253141208000045, 10.954482658000074],
      [43.25345809400005, 10.962172395000039],
      [44.06838862200004, 10.964640688000031],
      [44.64237767000003, 10.441131002000077],
      [47.537396880000074, 11.433290825000029],
      [51.143583797000076, 11.440440662000071],
      [51.04249912500006, 9.896286047000046]]]},
   'id': 'SO'},
  {'type': 'Feature',
   'properties': {'id': 'VE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-69.73619965899996, 11.727319780000073],
      [-68.27984191399997, 10.518754608000052],
      [-62.64403759099997, 10.518754608000052],
      [-59.83085060399998, 8.145047265000073],
      [-60.82055252499998, 7.241946060000032],
      [-60.75107653799995, 5.161628961000076],
      [-60.72585652599997, 4.344361529000025],
      [-62.22702111399997, 4.331978689000039],
      [-62.67825686499998, 3.923344973000042],
      [-64.15144261399996, 3.923344973000042],
      [-64.09898526399996, 0.889549203000058],
      [-66.53826824399994, 0.889549203000058],
      [-67.14570783399995, 1.422011319000035],
      [-67.26666121199997, 6.028427752000027],
      [-69.79477719599998, 6.028427752000027],
      [-69.83848832699994, 7.118117661000042],
      [-73.15520517999994, 7.118117661000042],
      [-73.28431644699998, 9.619451316000038],
      [-71.44500274399996, 11.328799193000066],
      [-71.38312637499996, 10.399879345000045],
      [-72.27909070099997, 9.567752506000033],
      [-71.61771219699995, 9.013001279000036],
      [-70.97487416799999, 9.607377593000024],
      [-71.03011442399998, 10.518754608000052],
      [-69.73619965899996, 11.727319780000073]],
     [[-63.88594005099998, 10.921597363000046],
      [-64.39802617599997, 10.92041187500007],
      [-64.41421523299994, 11.189952082000048],
      [-63.902134355999976, 11.186147256000027],
      [-63.88594005099998, 10.921597363000046]]]},
   'id': 'VE'},
  {'type': 'Feature',
   'properties': {'id': 'SS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[33.20956840500003, 11.943175918000065],
      [33.16009299600006, 10.482075404000057],
      [33.78866988800007, 10.482288723000067],
      [33.76042111700008, 9.49166153300007],
      [34.11653516800004, 9.498845731000074],
      [34.096889771000065, 8.560471974000052],
      [33.60808084700005, 7.686813550000068],
      [35.947699999000065, 4.62],
      [35.99474909200006, 4.558338126000024],
      [35.27482926700003, 4.558338126000024],
      [34.87080583900007, 4.909270509000066],
      [34.304759303000026, 4.558338126000024],
      [33.789395383000056, 3.991071232000024],
      [33.44138841700004, 3.607336024000062],
      [30.54591234700007, 3.607336024000062],
      [29.614311892000046, 4.439462864000063],
      [27.72817784800003, 4.439462864000063],
      [27.739161245000048, 5.212152072000038],
      [23.880031975000065, 8.659404284000061],
      [24.577831995000054, 8.659534693000069],
      [24.607347666000067, 10.185100566000074],
      [25.666562399000043, 10.185100566000074],
      [26.515793795000036, 9.532147284000075],
      [29.526901941000062, 9.53128662000006],
      [29.54065010000005, 10.07823684400006],
      [30.491143717000057, 10.093099814000027],
      [30.792877196000063, 9.748537063000072],
      [31.62716112800007, 9.749224602000027],
      [32.44499391700003, 10.779476880000061],
      [32.48290624100002, 11.946616303000042],
      [33.20956840500003, 11.943175918000065]]]},
   'id': 'SS'},
  {'type': 'Feature',
   'properties': {'id': 'BQ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-68.06936372999996, 12.23645010000007],
      [-68.05051267699997, 11.966914693000035],
      [-68.36875439599999, 11.966939353000043],
      [-68.38769608099994, 12.236479561000067],
      [-68.06936372999996, 12.23645010000007]]]},
   'id': 'BQ'},
  {'type': 'Feature',
   'properties': {'id': 'CM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[14.883496153000067, 9.956439850000038],
      [14.173690441000076, 9.954332971000042],
      [14.163691203000042, 8.724181162000036],
      [15.507479998000065, 7.52747],
      [14.851787002000037, 6.958597505000057],
      [14.828832969000075, 3.997538500000076],
      [16.136191507000035, 2.840840618000072],
      [16.13500900100007, 2.210528565000061],
      [13.299734363000027, 2.212298247000035],
      [11.299970680000058, 2.213546430000065],
      [9.448732674000041, 2.213546430000065],
      [9.453834762000042, 4.346980246000044],
      [8.912030413000025, 4.34641835900004],
      [8.919067195000025, 5.928663938000057],
      [10.470886531000076, 7.289647580000064],
      [11.03119993200005, 6.793072467000059],
      [13.049746172000027, 8.558672867000041],
      [13.071909556000037, 10.655323341000042],
      [14.916449538000052, 12.255398703000026],
      [14.883496153000067, 9.956439850000038]]]},
   'id': 'CM'},
  {'type': 'Feature',
   'properties': {'id': 'GD'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-61.56187010399998, 12.256506942000044],
      [-61.54483397699994, 11.986971534000077],
      [-61.86308217399994, 11.986996195000074],
      [-61.88020905299999, 12.256536402000052],
      [-61.56187010399998, 12.256506942000044]]]},
   'id': 'GD'},
  {'type': 'Feature',
   'properties': {'id': 'GW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-12.535033790999933, 12.36891977700003],
      [-12.51422978499994, 10.710461172000066],
      [-15.110065916999929, 10.714581690000045],
      [-16.300208304999956, 11.509158315000036],
      [-16.314100536999945, 12.36891977700003],
      [-12.535033790999933, 12.36891977700003]],
     [[-16.23967198699995, 10.880572847000053],
      [-16.23604422099993, 10.611037440000075],
      [-16.55386236099997, 10.611062100000026],
      [-16.557569934999947, 10.88060230800005],
      [-16.23967198699995, 10.880572847000053]]]},
   'id': 'GW'},
  {'type': 'Feature',
   'properties': {'id': 'GN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-7.920277877999979, 10.692106683000077],
      [-7.905956749999973, 8.448322842000039],
      [-8.615711148999935, 7.820173041000032],
      [-10.09050342699993, 8.803259808000064],
      [-11.906664002999946, 10.01057822000007],
      [-13.934612890999972, 8.202940069000022],
      [-13.955757154999958, 9.94183300900005],
      [-15.110065916999929, 10.714581690000045],
      [-12.51422978499994, 10.710461172000066],
      [-12.535033790999933, 12.36891977700003],
      [-11.333774450999954, 12.36891977700003],
      [-9.462960725999949, 12.36891977700003],
      [-7.920277877999979, 10.692106683000077]]]},
   'id': 'GN'},
  {'type': 'Feature',
   'properties': {'id': 'CW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-68.89528813799996, 12.400194870000064],
      [-68.87593030999994, 12.130659463000029],
      [-69.19422664499996, 12.130684123000037],
      [-69.21367639199997, 12.40022433100006],
      [-68.89528813799996, 12.400194870000064]]]},
   'id': 'CW'},
  {'type': 'Feature',
   'properties': {'id': 'DJ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[42.41576507700006, 12.443290777000072],
      [43.32398168900005, 12.439969553000026],
      [43.862478132000035, 11.976603146000059],
      [42.95946625800008, 11.976603146000059],
      [44.06838862200004, 10.964640688000031],
      [43.25345809400005, 10.962172395000039],
      [41.80969655400003, 10.957789774000048],
      [41.872863780000046, 12.443730559000073],
      [42.41576507700006, 12.443290777000072]]]},
   'id': 'DJ'},
  {'type': 'Feature',
   'properties': {'id': 'CO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-71.44500274399996, 11.328799193000066],
      [-73.28431644699998, 9.619451316000038],
      [-73.15520517999994, 7.118117661000042],
      [-69.83848832699994, 7.118117661000042],
      [-69.79477719599998, 6.028427752000027],
      [-67.26666121199997, 6.028427752000027],
      [-67.14570783399995, 1.422011319000035],
      [-67.71277380499998, 1.917324914000062],
      [-70.15245093599998, 1.917324914000062],
      [-70.13805966699994, -0.113460825999937],
      [-69.3276361, -0.831665538999971],
      [-69.39029548599996, -4.100735265999958],
      [-70.23218307899998, -4.100735265999958],
      [-70.86036354499998, -3.531124631999944],
      [-70.83405164999994, -2.416669042999956],
      [-72.76920256899996, -2.416669042999956],
      [-75.68937779, 0.183727331000057],
      [-77.04311344399997, 1.372479959000032],
      [-79.04999223999994, 1.363399076000064],
      [-76.86176439699994, 3.332675449000021],
      [-76.98888520899999, 6.676042215000052],
      [-77.97688337199997, 7.511685546000024],
      [-76.96654797299993, 8.438437509000039],
      [-75.89732555099994, 9.429064699000037],
      [-75.93111600299994, 9.983815926000034],
      [-74.80824364199998, 11.033880747000069],
      [-73.16179744699997, 11.033880747000069],
      [-71.53686379799996, 12.559446620000074],
      [-71.44500274399996, 11.328799193000066]]]},
   'id': 'CO'},
  {'type': 'Feature',
   'properties': {'id': 'YE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[46.27488726900003, 12.818636258000026],
      [44.91913886700007, 12.818636258000026],
      [43.031010379000065, 14.552233840000042],
      [43.15771730900008, 16.561356984000042],
      [51.55852332900008, 18.923080837000043],
      [52.59105095400008, 16.781145018000075],
      [52.51500839100004, 15.790517828000077],
      [46.27488726900003, 12.818636258000026]],
     [[54.30574489800006, 12.669344799000044],
      [54.284300966000046, 12.305845684000076],
      [53.457871186000034, 12.30588148000004],
      [53.47841942200006, 12.667277010000078],
      [54.30574489800006, 12.669344799000044]]]},
   'id': 'YE'},
  {'type': 'Feature',
   'properties': {'id': 'AW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-69.84262709999996, 12.695807069000068],
      [-69.82249763299995, 12.426271662000033],
      [-70.14089452199994, 12.426296322000042],
      [-70.16111822899995, 12.695836530000065],
      [-69.84262709999996, 12.695807069000068]]]},
   'id': 'AW'},
  {'type': 'Feature',
   'properties': {'id': 'BJ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[3.839202305000072, 9.772523142000068],
      [3.021901764000063, 9.055247979000058],
      [3.016143921000037, 5.74474723000003],
      [0.971532065000019, 5.74474723000003],
      [0.975312012000074, 11.13350678300003],
      [1.603469369000038, 11.13350678300003],
      [2.083946455000046, 11.500150974000064],
      [3.85735719500002, 12.851689793000048],
      [3.839202305000072, 9.772523142000068]]]},
   'id': 'BJ'},
  {'type': 'Feature',
   'properties': {'id': 'BB'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-59.468563174999986, 13.285859023000057],
      [-59.45064000299993, 13.016323615000033],
      [-59.76924483199997, 13.01634827600003],
      [-59.78726681599994, 13.285888483000065],
      [-59.468563174999986, 13.285859023000057]]]},
   'id': 'BB'},
  {'type': 'Feature',
   'properties': {'id': 'VC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-61.09547827499995, 13.413807503000044],
      [-61.07686302199994, 13.144272096000066],
      [-61.39551438199999, 13.144296756000074],
      [-61.41422946399996, 13.41383696400004],
      [-61.09547827499995, 13.413807503000044]]]},
   'id': 'VC'},
  {'type': 'Feature',
   'properties': {'id': 'GU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[145.00642611400008, 13.538278166000055],
      [144.9603013950001, 13.26874275800003],
      [144.64161023400004, 13.268767419000028],
      [144.68763543700004, 13.538307626000062],
      [145.00642611400008, 13.538278166000055]]]},
   'id': 'GU'},
  {'type': 'Feature',
   'properties': {'id': 'GM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-12.582073052999931, 12.921739312000057],
      [-16.32399212599995, 12.921739312000057],
      [-16.336368315999948, 13.560936900000058],
      [-12.591359889999978, 13.560936900000058],
      [-12.582073052999931, 12.921739312000057]]]},
   'id': 'GM'},
  {'type': 'Feature',
   'properties': {'id': 'NG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[14.916449538000052, 12.255398703000026],
      [13.071909556000037, 10.655323341000042],
      [13.049746172000027, 8.558672867000041],
      [11.03119993200005, 6.793072467000059],
      [10.470886531000076, 7.289647580000064],
      [8.919067195000025, 5.928663938000057],
      [8.912030413000025, 4.34641835900004],
      [6.008339583000065, 4.343407038000066],
      [3.912429474000021, 5.74474723000003],
      [3.016143921000037, 5.74474723000003],
      [3.021901764000063, 9.055247979000058],
      [3.839202305000072, 9.772523142000068],
      [3.85735719500002, 12.851689793000048],
      [5.068166345000066, 13.772663365000028],
      [13.484058437000044, 13.77284362100005],
      [14.916449538000052, 12.255398703000026]]]},
   'id': 'NG'},
  {'type': 'Feature',
   'properties': {'id': 'LC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-60.86596228399998, 14.055771378000031],
      [-60.84646992299997, 13.786235970000064],
      [-61.16536170499995, 13.786260631000061],
      [-61.18495896199994, 14.055800838000039],
      [-60.86596228399998, 14.055771378000031]]]},
   'id': 'LC'},
  {'type': 'Feature',
   'properties': {'id': 'ET'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[42.41576507700006, 12.443290777000072],
      [41.872863780000046, 12.443730559000073],
      [41.80969655400003, 10.957789774000048],
      [43.25345809400005, 10.962172395000039],
      [43.253141208000045, 10.954482658000074],
      [43.19247300500007, 9.333161182000026],
      [46.076948136000055, 8.045345835000035],
      [47.92192557800007, 8.045345835000035],
      [44.874197465000066, 4.934711016000051],
      [42.69579276500008, 3.983774356000026],
      [41.910118999000076, 3.982319],
      [40.31618329300005, 3.983774356000026],
      [39.86276348300004, 3.726211287000069],
      [38.067031678000035, 3.726211287000069],
      [37.45889622000004, 4.271056242000043],
      [37.138621096000065, 4.558338126000024],
      [35.99474909200006, 4.558338126000024],
      [35.947699999000065, 4.62],
      [33.60808084700005, 7.686813550000068],
      [34.096889771000065, 8.560471974000052],
      [34.11653516800004, 9.498845731000074],
      [34.158059096000045, 10.759664336000071],
      [36.065819489000035, 12.384292928000036],
      [36.114328089000026, 13.573045556000068],
      [36.91344122700008, 14.246672045000025],
      [39.493709575000025, 14.246672045000025],
      [40.31703989500005, 14.246672045000025],
      [42.41576507700006, 12.443290777000072]]]},
   'id': 'ET'},
  {'type': 'Feature',
   'properties': {'id': 'SV'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-87.20210896599997, 13.548518346000037],
      [-89.97696692799997, 13.548518346000037],
      [-89.14859128699999, 14.34661618900003],
      [-87.28304782899994, 14.35140408500007],
      [-87.20210896599997, 13.548518346000037]]]},
   'id': 'SV'},
  {'type': 'Feature',
   'properties': {'id': 'KH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[108.32290007100005, 12.514660972000058],
      [104.85417773500006, 10.144949799000074],
      [102.80784389300004, 11.687716948000059],
      [102.84817229500004, 12.06781740100007],
      [103.15043570000006, 14.592483575000074],
      [104.86127582000006, 14.592483575000074],
      [107.05727955700007, 14.592483575000074],
      [108.58937518600004, 14.592483575000074],
      [108.32290007100005, 12.514660972000058]]]},
   'id': 'KH'},
  {'type': 'Feature',
   'properties': {'id': 'NI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-83.21022228599998, 10.926935800000024],
      [-84.09058499299994, 10.926971151000032],
      [-84.44686419799996, 11.219171921000054],
      [-85.27859622499994, 11.219171921000054],
      [-86.08239802499997, 10.459237949000055],
      [-86.98158522499995, 11.195778769000071],
      [-87.17452979599994, 13.280810678000023],
      [-86.35521856199995, 13.280810678000023],
      [-84.92356405799995, 14.660647643000061],
      [-83.55744112599996, 14.660912719000066],
      [-83.21022228599998, 10.926935800000024]]]},
   'id': 'NI'},
  {'type': 'Feature',
   'properties': {'id': 'MQ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-60.89086126899997, 14.81093495600004],
      [-60.85593043399996, 14.411949184000036],
      [-61.17506815099995, 14.411973845000034],
      [-61.210162185999934, 14.810964417000037],
      [-60.89086126899997, 14.81093495600004]]]},
   'id': 'MQ'},
  {'type': 'Feature',
   'properties': {'id': 'CV'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-24.555305677999968, 14.945852493000075],
      [-24.547176242999967, 14.67631708600004],
      [-24.86642017099996, 14.676341746000048],
      [-24.87466131599996, 14.945881954000072],
      [-24.555305677999968, 14.945852493000075]],
     [[-24.74515883099997, 16.949523164000027],
      [-24.735516272999973, 16.67998775700005],
      [-25.055655456999943, 16.680012417000057],
      [-25.06542881599995, 16.949552624000034],
      [-24.74515883099997, 16.949523164000027]],
     [[-22.700960170999963, 16.12481715900003],
      [-22.692651689999934, 15.855281751000064],
      [-23.01240581899998, 15.855306412000061],
      [-23.020837854999968, 16.12484661900004],
      [-22.700960170999963, 16.12481715900003]],
     [[-23.384577684999954, 15.046005060000027],
      [-23.37677812299995, 14.77646965300005],
      [-23.696063213999935, 14.776494313000057],
      [-23.70397558899998, 15.046034521000024],
      [-23.384577684999954, 15.046005060000027]]]},
   'id': 'CV'},
  {'type': 'Feature',
   'properties': {'id': 'BF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[0.229350001000057, 14.98967],
      [2.088009731000056, 12.758573816000023],
      [2.083946455000046, 11.500150974000064],
      [1.603469369000038, 11.13350678300003],
      [0.975312012000074, 11.13350678300003],
      [-0.134432653999966, 11.13350678300003],
      [-2.940202183999929, 11.13350678300003],
      [-2.934160720999955, 10.177008408000063],
      [-5.280662284999948, 10.177139900000043],
      [-5.289205271999947, 11.869173616000069],
      [-1.629391878999968, 14.989752451000072],
      [0.229350001000057, 14.98967]]]},
   'id': 'BF'},
  {'type': 'Feature',
   'properties': {'id': 'MP'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[145.9085078170001, 15.256017575000044],
      [145.8552024290001, 14.986482168000066],
      [145.53583545800007, 14.986506828000074],
      [145.589026224, 15.25604703600004],
      [145.9085078170001, 15.256017575000044]],
     [[145.91653722900003, 18.191298260000053],
      [145.85171435300003, 17.92176285200003],
      [145.53096049300007, 17.921787513000027],
      [145.59564305100002, 18.19132772000006],
      [145.91653722900003, 18.191298260000053]],
     [[145.87549401900003, 18.89494299000006],
      [145.80791600600003, 18.625407582000037],
      [145.4867877680001, 18.625432243000034],
      [145.5542192370001, 18.89497245000007],
      [145.87549401900003, 18.89494299000006]]]},
   'id': 'MP'},
  {'type': 'Feature',
   'properties': {'id': 'DM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-61.19766022399995, 15.57301569200007],
      [-61.17540388599997, 15.303480285000035],
      [-61.49491401199998, 15.303504945000043],
      [-61.51728937799999, 15.573045153000066],
      [-61.19766022399995, 15.57301569200007]]]},
   'id': 'DM'},
  {'type': 'Feature',
   'properties': {'id': 'HN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-83.64739253299996, 15.452078014000051],
      [-83.55744112599996, 14.660912719000066],
      [-84.92356405799995, 14.660647643000061],
      [-86.35521856199995, 13.280810678000023],
      [-87.17452979599994, 13.280810678000023],
      [-87.20210896599997, 13.548518346000037],
      [-87.28304782899994, 14.35140408500007],
      [-89.14859128699999, 14.34661618900003],
      [-87.97099200299994, 15.48890152000007],
      [-87.55617899899994, 15.893746216000068],
      [-84.18731925299994, 15.897857788000067],
      [-83.64739253299996, 15.452078014000051]]]},
   'id': 'HN'},
  {'type': 'Feature',
   'properties': {'id': 'GP'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-61.30552067799994, 16.417726155000025],
      [-61.26975946399995, 16.055933108000033],
      [-61.69111438599998, 16.05932837900002],
      [-61.72710556099997, 16.42112622600007],
      [-61.30552067799994, 16.417726155000025]]]},
   'id': 'GP'},
  {'type': 'Feature',
   'properties': {'id': 'SN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-12.544363708999981, 15.514133005000076],
      [-11.362022316999969, 14.493819866000024],
      [-11.333774450999954, 12.36891977700003],
      [-12.535033790999933, 12.36891977700003],
      [-16.314100536999945, 12.36891977700003],
      [-16.32399212599995, 12.921739312000057],
      [-12.582073052999931, 12.921739312000057],
      [-12.591359889999978, 13.560936900000058],
      [-16.336368315999948, 13.560936900000058],
      [-16.343843766999953, 13.92381209000007],
      [-17.468045906999976, 14.889673601000027],
      [-16.38537169999995, 15.855535111000052],
      [-16.398549799999955, 16.480515069000035],
      [-13.66967882299997, 16.480515069000035],
      [-12.544363708999981, 15.514133005000076]]]},
   'id': 'SN'},
  {'type': 'Feature',
   'properties': {'id': 'AG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-61.61263005999996, 17.140680793000058],
      [-61.587637850999954, 16.871145385000034],
      [-61.90787080599995, 16.87117004600003],
      [-61.93299579799998, 17.140710253000066],
      [-61.61263005999996, 17.140680793000058]],
     [[-61.607587803999934, 17.68882930600006],
      [-61.58169073799996, 17.419293899000024],
      [-61.90219528899996, 17.419318559000033],
      [-61.92822998999998, 17.688858767000056],
      [-61.607587803999934, 17.68882930600006]]]},
   'id': 'AG'},
  {'type': 'Feature',
   'properties': {'id': 'VI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-64.71304352699997, 17.829266284000028],
      [-64.68557398899998, 17.55973087700005],
      [-65.00614982899998, 17.559755537000058],
      [-65.03375827399998, 17.829295745000024],
      [-64.71304352699997, 17.829266284000028]],
     [[-64.70587304899993, 18.46355258500006],
      [-64.67730055199996, 18.194017178000024],
      [-64.99820589599994, 18.194041838000032],
      [-65.02692295599996, 18.463582046000056],
      [-64.70587304899993, 18.46355258500006]]]},
   'id': 'VI'},
  {'type': 'Feature',
   'properties': {'id': 'GT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-88.98151415299998, 16.283985248000022],
      [-88.48615793099998, 15.895168799000032],
      [-87.97099200299994, 15.48890152000007],
      [-89.14859128699999, 14.34661618900003],
      [-89.97696692799997, 13.548518346000037],
      [-91.05368630299995, 13.548518346000037],
      [-91.96305735099997, 14.274887561000071],
      [-92.17403272599995, 15.959317727000041],
      [-90.07363860499999, 15.959317727000041],
      [-90.52930234299998, 16.316452],
      [-90.74700218299995, 17.874856100000045],
      [-89.19901115299996, 17.874886273000072],
      [-88.98151415299998, 16.283985248000022]]]},
   'id': 'GT'},
  {'type': 'Feature',
   'properties': {'id': 'ER'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[38.98711878100005, 17.30432737600006],
      [38.92381783700006, 16.22702030800002],
      [43.32398168900005, 12.439969553000026],
      [42.41576507700006, 12.443290777000072],
      [40.31703989500005, 14.246672045000025],
      [39.493709575000025, 14.246672045000025],
      [36.91344122700008, 14.246672045000025],
      [37.01875717300004, 16.346801688000028],
      [37.05281434700004, 16.960990545000072],
      [38.26740938000006, 17.96726312000004],
      [38.98711878100005, 17.30432737600006]]]},
   'id': 'ER'},
  {'type': 'Feature',
   'properties': {'id': 'AI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-62.929954788999964, 18.410106640000038],
      [-62.902239444999964, 18.14057123200007],
      [-62.98059958399995, 18.14057725500004],
      [-63.22311644399997, 18.140595893000068],
      [-63.24012469499996, 18.305782842000042],
      [-63.25097585799995, 18.410136100000045],
      [-62.929954788999964, 18.410106640000038]]]},
   'id': 'AI'},
  {'type': 'Feature',
   'properties': {'id': 'JM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-76.06725646399997, 17.942759763000026],
      [-76.24748540999997, 17.76557970500005],
      [-77.87321168999995, 17.765887646000067],
      [-78.38897609399999, 18.17016676800006],
      [-78.43853388799994, 18.549178445000052],
      [-76.14368911999998, 18.549178445000052],
      [-76.06725646399997, 17.942759763000026]]]},
   'id': 'JM'},
  {'type': 'Feature',
   'properties': {'id': 'PR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-65.70729173799998, 17.942759763000026],
      [-67.33238424299998, 17.942759763000026],
      [-67.40291445399998, 18.57444589100004],
      [-65.77611967499996, 18.57444589100004],
      [-65.70729173799998, 17.942759763000026]]]},
   'id': 'PR'},
  {'type': 'Feature',
   'properties': {'id': 'BZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-87.55617899899994, 15.893746216000068],
      [-87.97099200299994, 15.48890152000007],
      [-88.48615793099998, 15.895168799000032],
      [-88.98151415299998, 16.283985248000022],
      [-89.19901115299996, 17.874886273000072],
      [-89.32489869299997, 18.718991655000025],
      [-87.94224143399998, 18.719117679000078],
      [-87.55617899899994, 15.893746216000068]]]},
   'id': 'BZ'},
  {'type': 'Feature',
   'properties': {'id': 'VG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-64.13631118299998, 18.838472311000032],
      [-64.10734453099997, 18.568936904000054],
      [-64.42845085899995, 18.568961564000062],
      [-64.45756542799995, 18.83850177200003],
      [-64.13631118299998, 18.838472311000032]]]},
   'id': 'VG'},
  // // CHINA
  {'type': 'Feature',
   'properties': {'id': 'CN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[125.53731599100001, 53.44138382300008],
      [130.60945537700002, 47.954667836000056],
      [133.49013385800004, 47.954667836000056],
      [134.97834295400003, 48.651551881000046],
      [135.23638585800006, 47.954667836000056],
      [132.68242232000011, 44.89772897900008],
      [131.86282199700008, 45.39184513400005],
      [130.86688208200007, 44.902758369000026],
      [131.53558623700008, 43.44094969200006],
      [130.90429307300008, 42.598606345000064],
      [130.90327097700003, 42.59721228300003],
      [129.36317229200006, 42.598606344000075],
      [124.4761504710001, 40.02859605500004],
      [124.24866228700012, 39.66024906300004],
      [123.6291075790001, 39.66024906300004],
      [121.82704205900006, 38.66534520000005],
      [121.06538126700002, 38.66534520000005],
      [121.93327677100001, 40.128395762000025],
      [122.25837229500007, 40.647615366000025],
      [121.50141500600012, 40.647615366000025],
      [120.16283488300007, 39.91902917300007],
      [117.909929411, 38.66534520000005],
      [117.44092264100004, 37.81024038800007],
      [122.58275604300002, 37.81024038800007],
      [121.9149075900001, 36.58806365800007],
      [120.53764928800001, 36.58806365800007],
      [119.73588120000011, 35.02945182900004],
      [122.13151765200007, 31.760334319000037],
      [121.20062527900006, 29.422444360000043],
      [121.67140015900009, 29.42245415000008],
      [120.38615213600008, 25.45994539000003],
      [114.64016023900001, 22.330414878000056],
      [114.47201346700001, 22.50649425200004],
      [114.172280397, 22.34092620000007],
      [114.34067666800001, 22.164967534000027],
      [113.98770741800001, 21.969726454000067],
      [113.81920890300012, 22.145654523000076],
      [113.53351479500009, 21.98743520000005],
      [113.70214798500001, 21.811577922000026],
      [113.29644524600008, 21.586593077000032],
      [110.67092791000005, 21.58558545300008],
      [110.44518642500009, 20.446134348000044],
      [109.59473226700004, 20.446134348000044],
      [109.72981197100006, 21.138741882000033],
      [108.10421652600007, 21.138741882000033],
      [108.28080811100006, 22.032429023000077],
      [106.70424771100005, 22.032429023000077],
      [106.92487216100005, 23.12719577100006],
      [102.39260127500006, 23.12719577200005],
      [102.01468438400008, 21.138741882000033],
      [100.64711996100004, 21.138741882000033],
      [98.10876661600008, 23.752776769000036],
      [99.11305434000008, 28.04247504700004],
      [96.96472553200005, 28.044801559000064],
      [97.24801729300003, 29.03832464000004],
      [92.84466460900006, 29.03832464000004],
      [92.62123876800007, 28.199906730000066],
      [89.47418951700007, 28.199906730000066],
      [89.40199693900007, 27.90841622000005],
      [88.05659352500004, 27.897263353000028],
      [88.12468950000004, 28.176733686000034],
      [84.97784460400004, 28.176733686000034],
      [83.69943886500005, 28.176733686000034],
      [81.17414708900003, 30.53318858700004],
      [80.65437257900004, 30.173522580000053],
      [77.32744738500008, 33.838015186000064],
       [77.34434763400003, 33.849263731000065], // bottom left (empty space, disputed area KX)
       [78.82680356300006, 34.82818244200007], // bottom right (empty space, disputed area KX)
       [78.01915864200004, 35.74987240000007], // top right    (empty space, disputed area KX)
       [76.53634769000007, 34.77723909100007], // top left     (empty space, disputed area KX)
      [76.50790894800008, 34.75849543500004],
      [75.97410127300003, 35.35980254000003],
      [76.49860638300004, 36.929242833000046],
      [74.37910726300004, 36.92462402000007],
      [74.55264213300006, 37.44628019500004],
      [74.89941522400005, 38.450542926000026],
      [73.88980737900005, 39.62150836500007],
      [74.27986390100006, 40.66250478500007],
      [77.55226002400008, 40.66250478500007],
      [79.14832855100008, 41.634842252000055],
      [79.87193411900006, 43.232430805000035],
      [80.41758852600003, 44.423894776000054],
      [84.04270423600008, 47.16188564300006],
      [85.58760551800003, 47.158613417000026],
      [86.77689983400006, 49.26812114200004],
      [87.21742925900008, 49.26812114200004],
      [88.06631598400008, 49.268133885000054],
      [87.60743088200007, 48.48357156800006],
      [91.33136132700008, 47.041003690000025],
      [89.95680457800006, 44.57593414100006],
      [94.79949945700008, 44.57593414100006],
      [96.51308064200003, 42.067722944000025],
      [108.10144061400007, 42.067722944000025],
      [117.693798291, 47.08156415800005],
      [117.25891271800003, 47.954667836000056],
      [115.27047978400003, 47.954667836000056],
      [116.76726626200002, 49.89081036600004],
      [117.5936263540001, 49.89081036600004],
      [120.76373162100003, 53.44138382300008],
      [125.53731599100001, 53.44138382300008]],
     [[110.71919111600005, 19.818564925000032],
      [110.46649890000003, 18.511753319000036],
      [108.90277730800005, 18.51253047000006],
      [109.15106803700007, 19.81512208500004],
      [110.71919111600005, 19.818564925000032]]]},
   'id': 'CN'},
  // CHINA AND TAIWAN TOGETHER (BAD SOLUTION - MAKES TAIWAN LABELED AS CHINA DURING HOVER)
  // INSTEAD: - ADDED LOGIC TO ENG.JS, ETC, TO SELECT TW WITH CN
  //          - REPLACED "CN," WITH "CN,TW," IN DATA FILES (EnglishData.js, DataENG.ja, etc)
  //          - solution completed 1-30-24
  // {'type': 'Feature',
  //  'properties': {'id': 'CN'}, // CN, TW
  //  'geometry': {'type': 'Polygon',
  //   'coordinates': [[[125.53731599100001, 53.44138382300008],
  //     [130.60945537700002, 47.954667836000056],
  //     [133.49013385800004, 47.954667836000056],
  //     [134.97834295400003, 48.651551881000046],
  //     [135.23638585800006, 47.954667836000056],
  //     [132.68242232000011, 44.89772897900008],
  //     [131.86282199700008, 45.39184513400005],
  //     [130.86688208200007, 44.902758369000026],
  //     [131.53558623700008, 43.44094969200006],
  //     [130.90429307300008, 42.598606345000064],
  //     [130.90327097700003, 42.59721228300003],
  //     [129.36317229200006, 42.598606344000075],
  //     [124.4761504710001, 40.02859605500004],
  //     [124.24866228700012, 39.66024906300004],
  //     [123.6291075790001, 39.66024906300004],
  //     [121.82704205900006, 38.66534520000005],
  //     [121.06538126700002, 38.66534520000005],
  //     [121.93327677100001, 40.128395762000025],
  //     [122.25837229500007, 40.647615366000025],
  //     [121.50141500600012, 40.647615366000025],
  //     [120.16283488300007, 39.91902917300007],
  //     [117.909929411, 38.66534520000005],
  //     [117.44092264100004, 37.81024038800007],
  //     [122.58275604300002, 37.81024038800007],
  //     [121.9149075900001, 36.58806365800007],
  //     [120.53764928800001, 36.58806365800007],
  //     [119.73588120000011, 35.02945182900004],
  //     [122.13151765200007, 31.760334319000037],
  //     [121.20062527900006, 29.422444360000043],
  //     [121.67140015900009, 29.42245415000008],
  //     [120.38615213600008, 25.45994539000003],
  //     [114.64016023900001, 22.330414878000056],
  //     [114.47201346700001, 22.50649425200004],
  //     [114.172280397, 22.34092620000007],
  //     [114.34067666800001, 22.164967534000027],
  //     [113.98770741800001, 21.969726454000067],
  //     [113.81920890300012, 22.145654523000076],
  //     [113.53351479500009, 21.98743520000005],
  //     [113.70214798500001, 21.811577922000026],
  //     [113.29644524600008, 21.586593077000032],
  //     [110.67092791000005, 21.58558545300008],
  //     [110.44518642500009, 20.446134348000044],
  //     [109.59473226700004, 20.446134348000044],
  //     [109.72981197100006, 21.138741882000033],
  //     [108.10421652600007, 21.138741882000033],
  //     [108.28080811100006, 22.032429023000077],
  //     [106.70424771100005, 22.032429023000077],
  //     [106.92487216100005, 23.12719577100006],
  //     [102.39260127500006, 23.12719577200005],
  //     [102.01468438400008, 21.138741882000033],
  //     [100.64711996100004, 21.138741882000033],
  //     [98.10876661600008, 23.752776769000036],
  //     [99.11305434000008, 28.04247504700004],
  //     [96.96472553200005, 28.044801559000064],
  //     [97.24801729300003, 29.03832464000004],
  //     [92.84466460900006, 29.03832464000004],
  //     [92.62123876800007, 28.199906730000066],
  //     [89.47418951700007, 28.199906730000066],
  //     [89.40199693900007, 27.90841622000005],
  //     [88.05659352500004, 27.897263353000028],
  //     [88.12468950000004, 28.176733686000034],
  //     [84.97784460400004, 28.176733686000034],
  //     [83.69943886500005, 28.176733686000034],
  //     [81.17414708900003, 30.53318858700004],
  //     [80.65437257900004, 30.173522580000053],
  //     [77.32744738500008, 33.838015186000064],
  //     [77.34434763400003, 33.849263731000065],
  //     [78.82680356300006, 34.82818244200007],
  //     [78.01915864200004, 35.74987240000007],
  //     [76.53634769000007, 34.77723909100007],
  //     [76.50790894800008, 34.75849543500004],
  //     [75.97410127300003, 35.35980254000003],
  //     [76.49860638300004, 36.929242833000046],
  //     [74.37910726300004, 36.92462402000007],
  //     [74.55264213300006, 37.44628019500004],
  //     [74.89941522400005, 38.450542926000026],
  //     [73.88980737900005, 39.62150836500007],
  //     [74.27986390100006, 40.66250478500007],
  //     [77.55226002400008, 40.66250478500007],
  //     [79.14832855100008, 41.634842252000055],
  //     [79.87193411900006, 43.232430805000035],
  //     [80.41758852600003, 44.423894776000054],
  //     [84.04270423600008, 47.16188564300006],
  //     [85.58760551800003, 47.158613417000026],
  //     [86.77689983400006, 49.26812114200004],
  //     [87.21742925900008, 49.26812114200004],
  //     [88.06631598400008, 49.268133885000054],
  //     [87.60743088200007, 48.48357156800006],
  //     [91.33136132700008, 47.041003690000025],
  //     [89.95680457800006, 44.57593414100006],
  //     [94.79949945700008, 44.57593414100006],
  //     [96.51308064200003, 42.067722944000025],
  //     [108.10144061400007, 42.067722944000025],
  //     [117.693798291, 47.08156415800005],
  //     [117.25891271800003, 47.954667836000056],
  //     [115.27047978400003, 47.954667836000056],
  //     [116.76726626200002, 49.89081036600004],
  //     [117.5936263540001, 49.89081036600004],
  //     [120.76373162100003, 53.44138382300008],
  //     [125.53731599100001, 53.44138382300008]],
  //    [[110.71919111600005, 19.818564925000032],
  //     [110.46649890000003, 18.511753319000036],
  //     [108.90277730800005, 18.51253047000006],
  //     [109.15106803700007, 19.81512208500004],
  //     [110.71919111600005, 19.818564925000032]],
  //     // TAIWAN START
  //     [[121.12987942400002, 21.49308184800003],
  //     [119.90896617700002, 22.801901413000053],
  //     [120.32189863100007, 24.56129820700005],
  //     [122.2012671650001, 25.87011777300006],
  //     [121.12987942400002, 21.49308184800003]]
  //     // TAIWAN END
  //   ]},
  //  'id': 'CN'},
  {'type': 'Feature',
   'properties': {'id': 'KY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-81.21279526999996, 19.471305259000076],
      [-81.17460441199995, 19.20176985200004],
      [-81.49606133799995, 19.20179451200005],
      [-81.53440596799999, 19.471334720000073],
      [-81.21279526999996, 19.471305259000076]],
     [[-79.72897798499997, 19.83085865000004],
      [-79.69071464599995, 19.56132324200007],
      [-80.01237624399994, 19.56134790300007],
      [-80.05079659699999, 19.830888110000046],
      [-79.72897798499997, 19.83085865000004]]]},
   'id': 'KY'},
  {'type': 'Feature',
   'properties': {'id': 'HT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-71.48312597599994, 18.119781330000023],
      [-74.08632676099995, 18.119631879000053],
      [-74.16476224399997, 18.751318007000066],
      [-72.76994789799994, 18.751318007000066],
      [-72.84340151699996, 19.332469245000027],
      [-73.45424875799995, 19.332469245000027],
      [-73.54437842399994, 20.014690263000034],
      [-71.75085025099997, 20.014690263000034],
      [-71.48312597599994, 18.119781330000023]]]},
   'id': 'HT'},
  {'type': 'Feature',
   'properties': {'id': 'US'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-91.45100532699996, 48.811287598000035],
      [-89.13996402599997, 47.55878553900004],
      [-86.82266537699996, 47.55878553900004],
      [-82.83748994099994, 45.31467656700005],
      [-81.38517425099997, 42.296673105000025],
      [-79.97560836099996, 44.12498991100006],
      [-76.35787345999995, 44.12498991100006],
      [-75.54361272199998, 45.16553994000003],
      [-71.53283833999996, 45.16553994000003],
      [-70.88816703399993, 45.96161224000008],
      [-70.16322838199994, 46.85919350700004],
      [-68.23033298699994, 46.85919350700004],
      [-67.09429509799998, 44.14122049200006],
      [-70.20650356999994, 44.14121233700007],
      [-71.10010913399998, 43.05718208600007],
      [-70.30080476199998, 40.99582629500003],
      [-74.29587325999995, 41.014771737000046],
      [-73.93670156599995, 40.07594229100005],
      [-75.77951177599994, 37.92698726100008],
      [-76.30600295499994, 39.41316919500008],
      [-76.70579102699998, 39.418869519000054],
      [-75.50257265399995, 35.98521703000006],
      [-77.37691619899994, 33.87774374800006],
      [-78.71464701399998, 33.88534043300007],
      [-81.32305680199994, 30.965299810000033],
      [-79.99292151499998, 25.041349214000036],
      [-81.21477107499999, 25.041349214000036],
      [-81.32762909999997, 25.635725528000023],
      [-82.22035532599995, 26.289539473000048],
      [-82.92064058399995, 29.37983550200005],
      [-83.97222301299996, 30.11290139700003],
      [-90.14237955899995, 30.11297942500005],
      [-88.70592315799996, 29.122733236000045],
      [-95.45456517299999, 29.132639509000057],
      [-98.03626405099999, 26.289539473000048],
      [-99.07358384499997, 27.034203443000024],
      [-99.72677396699999, 29.376575356000046],
      [-102.25399477899998, 29.376575355000057],
      [-103.10861945299996, 28.400587058000042],
      [-104.47875686199995, 29.327775940000038],
      [-104.97818729299996, 30.840557801000045],
      [-106.40991015699996, 31.76774668300004],
      [-108.03070122199995, 31.76774668300004],
      [-107.84915661499997, 31.279752535000057],
      [-112.52999427999998, 31.279752535000057],
      [-114.62161994999997, 32.597336735000056],
      [-117.22039619399999, 32.612127110000074],
      [-121.87259440699995, 35.404936743000064],
      [-124.28397182499998, 39.722076740000034],
      [-123.282469231, 41.438143181000044],
      [-124.94110387399996, 43.818247023000026],
      [-123.70978620499994, 46.33784160600004],
      [-125.45729160099995, 48.52481260300004],
      [-124.45776018899994, 48.52481260300004],
      [-123.23860370499995, 47.00097085900006],
      [-122.76878449799995, 48.01618208000008],
      [-123.37227822699998, 48.811287598000035],
      [-121.38140391999997, 48.811287598000035],
      [-91.45100532699996, 48.811287598000035]],
     [[-140.23530617699998, 67.86879291500003],
      [-139.20128368999997, 59.94670579500007],
      [-137.82115760599999, 58.88671590700005],
      [-136.38358522699997, 58.88671590700005],
      [-132.81211977699996, 55.89962720500006],
      [-131.21220344299996, 55.89962720500006],
      [-129.73930947199995, 54.55464808600004],
      [-129.89934526999997, 53.68649159800003],
      [-131.40135423899994, 55.07509059000006],
      [-133.62719473699997, 55.07509059000006],
      [-137.63991690499995, 58.46447408600005],
      [-138.715745804, 58.462382536000064],
      [-140.81371380299998, 60.066910402000076],
      [-148.41342273999996, 60.066910402000076],
      [-148.31758010699997, 59.12432492900007],
      [-152.15146068799996, 59.12432492900007],
      [-152.42445085699998, 60.98428345800005],
      [-153.66082452499998, 60.98428345800005],
      [-153.36620344699998, 59.12432492900007],
      [-155.02006281699997, 59.12432492900007],
      [-154.73582416999997, 56.12845347400008],
      [-163.59160501399998, 56.12845347400008],
      [-163.64980014699998, 56.88934611700006],
      [-156.35624494699996, 56.88934611700006],
      [-156.60876495699998, 58.990109303000054],
      [-161.51726102099997, 58.973339432000046],
      [-161.81828633799998, 60.30417655000008],
      [-163.57869821799997, 60.30417655000008],
      [-164.77614022699998, 64.01664429400006],
      [-160.43851762199998, 64.01664429400006],
      [-160.76984670099998, 64.92542965300004],
      [-167.26917787799997, 64.92542965300004],
      [-168.00389727499999, 66.45045868200003],
      [-165.66128765199997, 66.45045868200003],
      [-161.86626006199998, 66.45045868200003],
      [-162.40787257799997, 67.59981944300006],
      [-166.53588761999998, 67.59981944300006],
      [-167.66630375999998, 69.53128692900003],
      [-159.22679274099997, 69.53128692900003],
      [-160.13686865599996, 71.02016786800004],
      [-145.51983836599996, 71.02016786800004],
      [-140.68808181599996, 69.42985604100005],
      [-140.23530617699998, 67.86879291500003]],
     [[-154.81789802599997, 19.08145044200006],
      [-155.84626827599996, 19.08145044200006],
      [-156.11286266399998, 20.061786393000034],
      [-155.09484634599997, 20.061756932000037],
      [-154.81789802599997, 19.08145044200006]],
     [[-163.19740277599996, 54.57065351000006],
      [-164.68255793299997, 54.57065351000006],
      [-165.12214824199998, 54.890181779000045],
      [-163.62916394699997, 54.88698777500008],
      [-163.19740277599996, 54.57065351000006]],
     [[-166.03610597399998, 53.67009229900003],
      [-167.14343876099997, 53.66935408400008],
      [-167.52641772799998, 53.95267004100003],
      [-166.41277613999998, 53.95022728500004],
      [-166.03610597399998, 53.67009229900003]],
     [[173.50726181800007, 52.99453248000003],
      [172.9212568910001, 52.560774894000076],
      [172.3987749480001, 52.56230676800004],
      [172.9770342370001, 52.99164607900008],
      [173.50726181800007, 52.99453248000003]],
     [[174.22652458100004, 52.35986870700003],
      [173.65271424700006, 51.92722270100006],
      [173.1327267040001, 51.928750656000034],
      [173.69896813600008, 52.356989716000044],
      [174.22652458100004, 52.35986870700003]],
     [[177.85954070700006, 52.13992512400006],
      [177.27887908900004, 51.70766301100008],
      [176.7597785490001, 51.709189612000046],
      [177.33281902400006, 52.137048692000064],
      [177.85954070700006, 52.13992512400006]],
     [[179.89829270200005, 51.584787548000065],
      [179.3238957970001, 51.15349136000003],
      [178.806915214, 51.155014556000026],
      [179.37379903700003, 51.581917555000075],
      [179.89829270200005, 51.584787548000065]],
     [[-160.08864946899996, 21.942848394000066],
      [-160.00973336399997, 21.67331298600004],
      [-160.33261511599997, 21.67333764600005],
      [-160.41169286499996, 21.942877854000074],
      [-160.08864946899996, 21.942848394000066]],
     [[-156.26873672199997, 20.987653038000076],
      [-156.19414370999996, 20.71811763000005],
      [-156.51646954799998, 20.71814229000006],
      [-156.59121883099996, 20.987682498000026],
      [-156.26873672199997, 20.987653038000076]],
     [[-156.93911015099997, 21.206249652000054],
      [-156.86363797199996, 20.93671424400003],
      [-157.18608936899997, 20.936738904000038],
      [-157.26171904399996, 21.20627911200006],
      [-156.93911015099997, 21.206249652000054]],
     [[-156.53802707, 20.53401503400005],
      [-156.46445615999997, 20.26447962700007],
      [-156.78652461799996, 20.264504286000033],
      [-156.86024928599997, 20.534044495000046],
      [-156.53802707, 20.53401503400005]],
     [[-159.42588548299997, 22.21669656000006],
      [-159.34658508699997, 21.947161152000035],
      [-159.66962960199996, 21.947185812000043],
      [-159.74909317499998, 22.216726020000067],
      [-159.42588548299997, 22.21669656000006]],
     [[-157.83801635899997, 21.580159818000027],
      [-157.76114919299997, 21.31062441100005],
      [-158.08381761999996, 21.310649070000068],
      [-158.16084437599997, 21.580189278000034],
      [-157.83801635899997, 21.580159818000027]],
     [[-165.68284789199998, 54.378258765000055],
      [-165.29775401399996, 54.09445669200005],
      [-165.673616701, 54.09448264200006],
      [-166.05959474599996, 54.37828980300003],
      [-165.68284789199998, 54.378258765000055]],
     [[-170.06966560799998, 53.004510382000035],
      [-169.69509894899997, 52.722287625000035],
      [-170.06686983699998, 52.72231343000004],
      [-170.44226536999997, 53.00454124700008],
      [-170.06966560799998, 53.004510382000035]],
     [[-176.38214016399996, 51.897306007000054],
      [-176.01040252499996, 51.616343407000045],
      [-176.37904858099998, 51.616369098000064],
      [-176.75157296399996, 51.89733673400008],
      [-176.38214016399996, 51.897306007000054]],
     [[-171.268234526, 52.59259550500008],
      [-170.89713294799998, 52.31084288300008],
      [-171.2677235, 52.310868646000074],
      [-171.63963799699997, 52.59262631900003],
      [-171.268234526, 52.59259550500008]],
     [[-174.417722724, 52.30518098500005],
      [-174.044086745, 52.02375547500003],
      [-174.41386656499998, 52.02378120800006],
      [-174.78830459499997, 52.305211763000045],
      [-174.417722724, 52.30518098500005]],
     [[-173.21378149999998, 52.19762188200008],
      [-172.84431747799997, 51.91631859200004],
      [-173.21379602799996, 51.91634431300008],
      [-173.58405796699998, 52.19765264600005],
      [-173.21378149999998, 52.19762188200008]],
     [[-177.87770331899998, 51.951176485000076],
      [-177.50199904099998, 51.67015283300003],
      [-177.87079402599997, 51.670178529000054],
      [-178.24728712599997, 51.951207218000036],
      [-177.87770331899998, 51.951176485000076]]]},
   'id': 'US'},
  {'type': 'Feature',
   'properties': {'id': 'TH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[101.49583359700006, 19.552447207000057],
      [101.18626538300003, 17.77554368600005],
      [103.98446303500003, 17.765072925000027],
      [105.15100737500006, 16.580937463000055],
      [104.86127582000006, 14.592483575000074],
      [103.15043570000006, 14.592483575000074],
      [102.84817229500004, 12.06781740100007],
      [102.80784389300004, 11.687716948000059],
      [100.48215133000008, 13.45303247000004],
      [100.24828551400009, 13.631441075000055],
      [99.75808460200005, 8.470726658000046],
      [103.89703811100009, 4.622168111000065],
      [103.78454437000005, 0.591943051000044],
      [100.47434269500008, 3.577789561000031],
      [100.60223606000005, 6.16948227000006],
      [98.70918566900008, 7.979198731000054],
      [98.86189725800006, 10.034679155000049],
      [99.28998940800005, 14.145640004000029],
      [98.85775131400004, 14.570141396000054],
      [99.06552582600006, 16.111751714000036],
      [97.79447841100006, 17.385255890000053],
      [98.15479862200004, 19.574789386000077],
      [100.53903637200006, 20.535503062000032],
      [101.49583359700006, 19.552447207000057]]]},
   'id': 'TH'},
  {'type': 'Feature',
   'properties': {'id': 'BS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-77.80604158899996, 24.304924198000037],
      [-77.76490188199995, 24.03538879100006],
      [-78.08923515699996, 24.035413451000068],
      [-78.13054911899997, 24.304953659000034],
      [-77.80604158899996, 24.304924198000037]],
     [[-74.16012257299997, 22.772523447000026],
      [-74.12280188999995, 22.502988040000048],
      [-74.44617764399999, 22.503012700000056],
      [-74.48366383099994, 22.772552908000023],
      [-74.16012257299997, 22.772523447000026]],
     [[-76.07256532399998, 25.269718855000065],
      [-76.02580528199996, 25.00018344800003],
      [-76.35076713599994, 25.000208108000038],
      [-76.39772992699994, 25.26974831600006],
      [-76.07256532399998, 25.269718855000065]],
     [[-77.72990398299999, 24.99931745500004],
      [-77.68791109799997, 24.72978204800006],
      [-78.01269449599994, 24.72980670800007],
      [-78.05486563199997, 24.999346916000036],
      [-77.72990398299999, 24.99931745500004]],
     [[-73.02859474399997, 21.27968806000007],
      [-72.99362936199998, 21.010152652000045],
      [-73.31611944499997, 21.010177313000042],
      [-73.35124196799995, 21.279717520000077],
      [-73.02859474399997, 21.27968806000007]],
     [[-74.67910926699994, 23.784533279000073],
      [-74.64028247299996, 23.514997872000038],
      [-74.96428495799995, 23.515022532000046],
      [-75.00328299899996, 23.78456274000007],
      [-74.67910926699994, 23.784533279000073]],
     [[-77.15263325899997, 26.537804393000044],
      [-77.10092725599998, 26.268268985000077],
      [-77.42687354999998, 26.268293646000075],
      [-77.47880109599998, 26.537833853000052],
      [-77.15263325899997, 26.537804393000044]]]},
   'id': 'BS'},
  {'type': 'Feature',
   'properties': {'id': 'CU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-78.93816859799995, 23.097318571000073],
      [-76.63488134799996, 21.328597411000032],
      [-75.78832753399996, 21.328597411000032],
      [-74.29202253799997, 20.166294935000053],
      [-78.07909443599993, 20.166294935000053],
      [-78.18354343899995, 20.92431828900004],
      [-79.62799359199994, 22.036085875000026],
      [-83.86625303599999, 22.036085875000026],
      [-84.72128641899997, 22.036085875000026],
      [-83.65352581099995, 23.097318571000073],
      [-78.93816859799995, 23.097318571000073]],
     [[-82.74711976699996, 21.596249786000044],
      [-82.70701506099994, 21.326714378000077],
      [-83.02968953899995, 21.326739039000074],
      [-83.06995323499996, 21.59627924600005],
      [-82.74711976699996, 21.596249786000044]]]},
   'id': 'CU'},
  {'type': 'Feature',
   'properties': {'id': 'SD'}, // North Sudan
   'geometry': {'type': 'Polygon',
    'coordinates': [[[33.22915268500003, 21.77351397600006],
      [33.65787875700005, 21.46895494300003],
      [34.03209388700003, 21.564382333000026],
      [34.08820519500006, 21.773535855000034],
      [37.06164721400006, 21.77361158800005],
      [36.88880462900005, 19.236050397000042],
      [38.26740938000006, 17.96726312000004],
      [37.05281434700004, 16.960990545000072],
      [37.01875717300004, 16.346801688000028],
      [36.91344122700008, 14.246672045000025],
      [36.114328089000026, 13.573045556000068],
      [36.065819489000035, 12.384292928000036],
      [34.158059096000045, 10.759664336000071],
      [34.11653516800004, 9.498845731000074],
      [33.76042111700008, 9.49166153300007],
      [33.78866988800007, 10.482288723000067],
      [33.16009299600006, 10.482075404000057],
      [33.20956840500003, 11.943175918000065],
      [32.48290624100002, 11.946616303000042],
      [32.44499391700003, 10.779476880000061],
      [31.62716112800007, 9.749224602000027],
      [30.792877196000063, 9.748537063000072],
      [30.491143717000057, 10.093099814000027],
      [29.54065010000005, 10.07823684400006],
      [29.526901941000062, 9.53128662000006],
      [26.515793795000036, 9.532147284000075],
      [25.666562399000043, 10.185100566000074],
      [24.607347666000067, 10.185100566000074],
      [24.577831995000054, 8.659534693000069],
      [23.880031975000065, 8.659404284000061],
      [23.272940050000045, 8.659290828000053],
      [23.319811507000054, 10.797721182000032],
      [23.32866586800003, 11.196244940000042],
      [22.232789970000056, 12.182790706000048],
      [22.291816616000062, 14.465163454000049],
      [23.957584718000078, 15.884711655000046],
      [24.08339525300005, 19.208184637000045],
      [24.105704584000023, 19.950702986000067],
      [24.786406356000043, 19.950702986000067],
      [24.87893627400007, 21.773301297000046],
      [33.22915268500003, 21.77351397600006]]]},
   'id': 'SD'},
  {'type': 'Feature',
   'properties': {'id': 'TC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-72.00582322199995, 21.93664163400007],
      [-71.97058369499996, 21.667106226000044],
      [-72.29345779999994, 21.66713088700004],
      [-72.32885811699998, 21.936671094000076],
      [-72.00582322199995, 21.93664163400007]]]},
   'id': 'TC'},
  {'type': 'Feature',
   'properties': {'id': 'TD'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[24.08339525300005, 19.208184637000045],
      [23.957584718000078, 15.884711655000046],
      [22.291816616000062, 14.465163454000049],
      [22.232789970000056, 12.182790706000048],
      [23.32866586800003, 11.196244940000042],
      [23.319811507000054, 10.797721182000032],
      [22.004499899000052, 10.797420805000058],
      [20.29705264000006, 9.319683782000027],
      [19.166471873000035, 9.319683782000027],
      [17.109659435000026, 7.52875390500003],
      [15.507479998000065, 7.52747],
      [14.163691203000042, 8.724181162000036],
      [14.173690441000076, 9.954332971000042],
      [14.883496153000067, 9.956439850000038],
      [14.916449538000052, 12.255398703000026],
      [13.484058437000044, 13.77284362100005],
      [13.515648892000058, 15.31648834200007],
      [15.072396296000022, 16.652135267000062],
      [15.141231161000064, 19.408685280000043],
      [16.192558576000067, 20.228654364000022],
      [15.18766819700005, 21.113766362000035],
      [15.256689695000034, 23.514240017000077],
      [15.943928534000065, 23.51456569100003],
      [24.08339525300005, 19.208184637000045]]]},
   'id': 'TD'},
  {'type': 'Feature',
   'properties': {'id': 'NE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[11.998500001000025, 23.512695998000027],
      [15.256689695000034, 23.514240017000077],
      [15.18766819700005, 21.113766362000035],
      [16.192558576000067, 20.228654364000022],
      [15.141231161000064, 19.408685280000043],
      [15.072396296000022, 16.652135267000062],
      [13.515648892000058, 15.31648834200007],
      [13.484058437000044, 13.77284362100005],
      [5.068166345000066, 13.772663365000028],
      [3.85735719500002, 12.851689793000048],
      [2.083946455000046, 11.500150974000064],
      [2.088009731000056, 12.758573816000023],
      [0.229350001000057, 14.98967],
      [4.138196511000046, 14.99248009300004],
      [4.163981045000071, 19.042580179000026],
      [11.559930670000028, 23.89601299000003],
      [11.998500001000025, 23.512695998000027]]]},
   'id': 'NE'},
  {'type': 'Feature',
   'properties': {'id': 'JP'}, // Japan
   'geometry': {'type': 'Polygon',
    'coordinates': [[[139.57481915000005, 35.39171301600004],
      [134.98107196800004, 33.069503060000045],
      [135.83152186100006, 34.67848332300008],
      [134.37733759500009, 35.09237284500006],
      [131.4486598730001, 33.78011248100006],
      [131.01203944100007, 34.42370458600004],
      [138.27379409900004, 37.74239508200003],
      [140.15840355000012, 39.49621189800007],
      [139.41814306600008, 40.88474646900005],
      [141.45911516800004, 41.91742714000003],
      [142.42919905700012, 39.84259555400007],
      [139.57481915000005, 35.39171301600004]],
     [[142.97945542000002, 45.70528471100005],
      [143.80325453600005, 43.54830067600005],
      [145.9762098010001, 44.582573472000036],
      [146.46053495, 43.289285059000065],
      [144.85574231100009, 42.509972065000056],
      [141.19315978200007, 42.509972065000056],
      [141.38005503600004, 42.09164564100007],
      [140.1175487590001, 41.45324491800005],
      [139.52322815600007, 42.78901502000008],
      [141.61778568500006, 43.813261606000026],
      [141.2062958250001, 44.86256354300008],
      [142.97945542000002, 45.70528471100005]],
     [[130.53742913300005, 33.82802232700004],
      [131.56785862200002, 32.35695465800006],
      [130.81926295000005, 30.70200353000007],
      [129.5967599270001, 30.70200353000007],
      [130.4471390440001, 32.58680898100005],
      [129.89384960900009, 32.25352021300006],
      [129.29428739900004, 33.092488493000076],
      [130.53742913300005, 33.82802232700004]],
     [[134.17817358600007, 33.161444790000075],
      [132.67149156000005, 32.26501292800003],
      [132.0769795980001, 33.08305079500008],
      [133.61605892700004, 33.988920353000026],
      [134.17817358600007, 33.161444790000075]],
     [[128.208314061, 26.21502903700008],
      [127.61410659300009, 26.21502903700008],
      [127.76350864200003, 26.679986389000078],
      [128.3584117690001, 26.679986389000078],
      [128.208314061, 26.21502903700008]],
     [[124.44720355700008, 24.636494801000026],
      [124.37953910300007, 24.36695939300006],
      [124.05500212200002, 24.366984054000056],
      [124.12249245700002, 24.636524261000034],
      [124.44720355700008, 24.636494801000026]],
     [[142.43571377600006, 27.17681770200005],
      [142.33495069100002, 26.907282294000026],
      [142.00848889000008, 26.907306955000024],
      [142.10902386500004, 27.17684716200006],
      [142.43571377600006, 27.17681770200005]],
     [[125.62860494600011, 24.852886612000077],
      [125.55985148600007, 24.583351204000053],
      [125.23517393300006, 24.58337586500005],
      [125.30375205300004, 24.852916072000028],
      [125.62860494600011, 24.852886612000077]],
     [[139.53222644700008, 34.54312911200003],
      [139.38107163200004, 34.27359370500005],
      [139.0466694800001, 34.27361836500006],
      [139.19746564800005, 34.54315857300003],
      [139.53222644700008, 34.54312911200003]],
     [[141.53445483100006, 24.90770726100004],
      [141.45692521400008, 24.638171853000074],
      [141.1322126650001, 24.63819651400007],
      [141.20956679000005, 24.90773672100005],
      [141.53445483100006, 24.90770726100004]],
     [[129.5608691760001, 28.271901998000033],
      [129.462883658, 28.002366590000065],
      [129.13546155100005, 28.002391251000063],
      [129.2332023040001, 28.27193145800004],
      [129.5608691760001, 28.271901998000033]],
     [[130.74538547200007, 30.36938890400006],
      [130.63217948300007, 30.099853496000037],
      [130.30272767000008, 30.099878157000035],
      [130.41565150400004, 30.36941836400007],
      [130.74538547200007, 30.36938890400006]],
     [[140.0080730190001, 33.281635347000076],
      [139.86575887000004, 33.01209993900005],
      [139.53297951600007, 33.01212460000005],
      [139.6749588890001, 33.28166480700003],
      [140.0080730190001, 33.281635347000076]]]},
   'id': 'JP'},
  {'type': 'Feature',
   'properties': {'id': 'OM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[54.12419102300004, 16.781145018000075],
      [52.59105095400008, 16.781145018000075],
      [51.55852332900008, 18.923080837000043],
      [53.514167291000035, 18.92475646200006],
      [55.45563425300003, 20.480041151000023],
      [55.616464920000055, 21.99551084500007],
      [54.92992523100003, 22.64951469700003],
      [54.930164707000074, 22.651809857000046],
      [54.93016639200005, 22.651826003000053],
      [55.08819597000007, 24.135455482000054],
      [56.373968234000074, 24.980152644000043],
      [56.374247628000035, 24.98033575000005],
      [58.35947953400006, 23.765066707000074],
      [59.717017558000066, 22.491357738000033],
      [59.51222323300004, 20.694122418000063],
      [54.12419102300004, 16.781145018000075]],
     [[56.48374643300008, 25.780739349000044],
      [56.483625826000036, 25.779878979000046],
      [56.48362554900007, 25.779878979000046],
      [56.09390859600006, 25.779896585000074],
      [56.09390844900008, 25.779896585000074],
      [56.09321126200007, 25.779896617000077],
      [56.175070996000045, 26.37363863400003],
      [56.17507102400003, 26.37363883100005],
      [56.17515991000005, 26.374272931000064],
      [56.56832768800007, 26.374272931000064],
      [56.483746659000076, 25.780740955000056],
      [56.48374643300008, 25.780739349000044]]]},
   'id': 'OM'},
  {'type': 'Feature',
   'properties': {'id': 'ML'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[4.163981045000071, 19.042580179000026],
      [4.138196511000046, 14.99248009300004],
      [0.229350001000057, 14.98967],
      [-1.629391878999968, 14.989752451000072],
      [-5.289205271999947, 11.869173616000069],
      [-5.280662284999948, 10.177139900000043],
      [-6.233309997999925, 10.699999999000056],
      [-7.920277877999979, 10.692106683000077],
      [-9.462960725999949, 12.36891977700003],
      [-11.333774450999954, 12.36891977700003],
      [-11.362022316999969, 14.493819866000024],
      [-12.544363708999981, 15.514133005000076],
      [-6.914051532999963, 15.498742604000029],
      [-5.417510614999969, 15.498742604000029],
      [-5.476802883999937, 22.037966701000073],
      [-5.49882215699995, 25.223583553000026],
      [4.163981045000071, 19.042580179000026]]]},
   'id': 'ML'},
  {'type': 'Feature',
   'properties': {'id': 'BD'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[90.27441971500008, 25.026280946000043],
      [92.58809381500004, 25.026280946000043],
      [92.30000359100006, 23.46232844900004],
      [93.06745525300005, 22.097981231000063],
      [92.77562324000007, 20.379554202000065],
      [91.73468663400007, 22.21038658200007],
      [90.03215847700005, 21.46937351300005],
      [89.06318448500008, 21.46937351300005],
      [87.74459159100007, 24.691148267000074],
      [87.95201623400004, 25.741230659000053],
      [90.42580997200008, 25.741230659000053],
      [90.27441971500008, 25.026280946000043]]]},
   'id': 'BD'},
  // // TAIWAN ALONE 
  {'type': 'Feature',
   'properties': {'id': 'TW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[121.12987942400002, 21.49308184800003],
      [119.90896617700002, 22.801901413000053],
      [120.32189863100007, 24.56129820700005],
      [122.2012671650001, 25.87011777300006],
      [121.12987942400002, 21.49308184800003]]]},
   'id': 'TW'},
  {'type': 'Feature',
   'properties': {'id': 'QA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[51.56417093400006, 24.551518901000065],
      [50.83175733500008, 25.063928764000025],
      [50.98954224100004, 26.334647843000027],
      [51.77579986500007, 26.334647843000027],
      [51.56417093400006, 24.551518901000065]]]},
   'id': 'QA'},
  {'type': 'Feature',
   'properties': {'id': 'MR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-5.49882215699995, 25.223583553000026],
      [-5.476802883999937, 22.037966701000073],
      [-5.417510614999969, 15.498742604000029],
      [-6.914051532999963, 15.498742604000029],
      [-12.544363708999981, 15.514133005000076],
      [-13.66967882299997, 16.480515069000035],
      [-16.398549799999955, 16.480515069000035],
      [-16.532859008999935, 21.336369732000037],
      [-12.91652980899994, 21.325495770000032],
      [-12.960780941999928, 23.158156072000054],
      [-11.98465177099996, 23.158156072000054],
      [-12.035002568999971, 25.238473171000066],
      [-12.05051532799996, 25.78331812500005],
      [-8.47095027399996, 25.78331812500005],
      [-8.498244299999953, 27.10007997400004],
      [-5.49882215699995, 25.223583553000026]]]},
   'id': 'MR'},
  {'type': 'Feature',
   'properties': {'id': 'BH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[51.02013679700008, 26.750711263000028],
      [50.51084562400007, 26.750711263000028],
      [50.57080068100004, 27.206399771000065],
      [51.080696369000066, 27.206399771000065],
      [51.02013679700008, 26.750711263000028]]]},
   'id': 'BH'},
  {'type': 'Feature',
   'properties': {'id': 'EH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-8.498244299999953, 27.10007997400004],
      [-8.47095027399996, 25.78331812500005],
      [-12.05051532799996, 25.78331812500005],
      [-12.035002568999971, 25.238473171000066],
      [-11.98465177099996, 23.158156072000054],
      [-12.960780941999928, 23.158156072000054],
      [-12.91652980899994, 21.325495770000032],
      [-16.532859008999935, 21.336369732000037],
      [-16.57902856499993, 22.765159762000053],
      [-11.689831400999935, 27.807198366000023],
      [-8.515346287999932, 27.81410386500005],
      [-8.498244299999953, 27.10007997400004]]]},
   'id': 'EH'},
  {'type': 'Feature',
   'properties': {'id': 'MM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[99.11305434000008, 28.04247504700004],
      [98.10876661600008, 23.752776769000036],
      [100.64711996100004, 21.138741882000033],
      [100.53903637200006, 20.535503062000032],
      [98.15479862200004, 19.574789386000077],
      [97.79447841100006, 17.385255890000053],
      [99.06552582600006, 16.111751714000036],
      [98.85775131400004, 14.570141396000054],
      [99.28998940800005, 14.145640004000029],
      [98.86189725800006, 10.034679155000049],
      [98.03877565700009, 10.503864904000068],
      [98.29453078000006, 13.050873256000045],
      [97.29549174400006, 14.324377431000073],
      [97.48056201000009, 15.754276857000036],
      [96.89645130800005, 16.335173499000064],
      [96.15067089500008, 15.754276858000026],
      [94.05353490500005, 15.754276858000026],
      [94.32337348000004, 17.667941384000073],
      [92.77562324000007, 20.379554202000065],
      [93.06745525300005, 22.097981231000063],
      [93.45000535200006, 24.221962518000055],
      [94.25368953800006, 24.217188298000053],
      [94.89009365800007, 27.082016182000075],
      [96.96472553200005, 28.044801559000064],
      [99.11305434000008, 28.04247504700004]]]},
   'id': 'MM'},
  {'type': 'Feature',
   'properties': {'id': 'BT'}, // Bhutan
   'geometry': {'type': 'Polygon',
    'coordinates': [[[92.34449949000003, 27.081788002000053],
      [92.27086877200009, 26.770054567000045],
      [89.13219966400004, 26.77459628200006],
      [89.40199693900007, 27.90841622000005],
      [89.47418951700007, 28.199906730000066],
      [92.62123876800007, 28.199906730000066],
      [92.34449949000003, 27.081788002000053]]]},
   'id': 'BT'},
  {'type': 'Feature',
   'properties': {'id': 'AP'}, // Arunachal Pradesh
   'geometry': {'type': 'Polygon',
    'coordinates': [[[96.96472553200005, 28.044801559000064],
      [94.89009365800007, 27.082016182000075],
      [94.88992803000008, 27.082016167000063],
      [92.34449949000003, 27.081788002000053],
      [92.62123876800007, 28.199906730000066],
      [92.84466460900006, 29.03832464000004],
      [97.24801729300003, 29.03832464000004],
      [96.96472553200005, 28.044801559000064]]]},
   'id': 'AP'},
  {'type': 'Feature',
   'properties': {'id': 'KW'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[48.484323276000055, 29.978726987000073],
      [48.30586540000007, 28.766637595000077],
      [48.276143423000065, 28.556129317000057],
      [48.26204189300006, 28.556129317000057],
      [47.54960280800003, 28.556129317000057],
      [46.462489309000034, 29.224802671000077],
      [47.27008553200005, 29.980155903000025],
      [48.484323276000055, 29.978726987000073]]]},
   'id': 'KW'},
  {'type': 'Feature',
   'properties': {'id': 'NP'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[83.69943886500005, 28.176733686000034],
      [84.97784460400004, 28.176733686000034],
      [88.12468950000004, 28.176733686000034],
      [88.05659352500004, 27.897263353000028],
      [87.78833440300008, 26.751423239000076],
      [84.00040999800007, 26.751423239000076],
      [82.72688369000008, 26.751423239000076],
      [79.71606454100004, 29.51820234300004],
      [80.65437257900004, 30.173522580000053],
      [81.17414708900003, 30.53318858700004],
      [83.69943886500005, 28.176733686000034]]]},
   'id': 'NP'},
  {'type': 'Feature',
   'properties': {'id': 'BM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-64.66089097799994, 32.40358234200005],
      [-64.59881554499998, 32.13404693500007],
      [-64.93054885599997, 32.13407159500008],
      [-64.99294666199995, 32.40361180300005],
      [-64.66089097799994, 32.40358234200005]]]},
   'id': 'BM'},
  {'type': 'Feature',
   'properties': {'id': 'SA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[39.22405776700003, 32.455621475000044],
      [39.49843310000006, 31.861243830000035],
      [40.40885041700005, 32.04809016200005],
      [44.75889236300003, 29.219751334000023],
      [46.462489309000034, 29.224802671000077],
      [47.54960280800003, 28.556129317000057],
      [48.26204189300006, 28.556129317000057],
      [48.276143423000065, 28.556129317000057],
      [50.23300992000003, 26.92902415700007],
      [50.06745723000006, 25.601583723000033],
      [50.83175733500008, 25.063928764000025],
      [51.56417093400006, 24.551518901000065],
      [51.59238075800005, 24.25337661700007],
      [51.591452135000054, 24.122818779000056],
      [51.62480774100004, 24.08291849400007],
      [52.58316856600004, 22.93576997100007],
      [52.58335223100005, 22.935747761000073],
      [53.93684321200004, 22.772025040000074],
      [54.930164707000074, 22.651809857000046],
      [54.92992523100003, 22.64951469700003],
      [55.616464920000055, 21.99551084500007],
      [55.45563425300003, 20.480041151000023],
      [53.514167291000035, 18.92475646200006],
      [51.55852332900008, 18.923080837000043],
      [43.15771730900008, 16.561356984000042],
      [38.093387893000056, 21.242070457000068],
      [38.20173218000008, 22.525044181000055],
      [35.848613441000055, 24.67526071900005],
      [36.01577124900007, 26.782549542000027],
      [34.59670778000003, 27.79587040900003],
      [35.35869539200007, 28.395795879000048],
      [34.920045266000045, 28.804429595000045],
      [34.918059767000045, 28.80287345200003],
      [34.91836188800005, 28.805597211000077],
      [34.91898299300004, 28.80442953200003],
      [36.168512226000075, 28.80571542000007],
      [38.22316925800004, 30.397330861000057],
      [37.11916488800006, 31.44149525200004],
      [39.22405776700003, 32.455621475000044]]]},
   'id': 'SA'},
  {'type': 'Feature',
   'properties': {'id': 'MX'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-114.62161994999997, 32.597336735000056],
      [-112.52999427999998, 31.279752535000057],
      [-107.84915661499997, 31.279752535000057],
      [-108.03070122199995, 31.76774668300004],
      [-106.40991015699996, 31.76774668300004],
      [-104.97818729299996, 30.840557801000045],
      [-104.47875686199995, 29.327775940000038],
      [-103.10861945299996, 28.400587058000042],
      [-102.25399477899998, 29.376575355000057],
      [-99.72677396699999, 29.376575356000046],
      [-99.07358384499997, 27.034203443000024],
      [-98.03626405099999, 26.289539473000048],
      [-96.84443763699994, 20.147650895000027],
      [-95.29898783099998, 18.979287662000047],
      [-91.99366235199994, 18.97871081100004],
      [-89.79337202599999, 21.19771571600006],
      [-86.97863459799999, 21.19771571600006],
      [-86.83199865599994, 20.246713614000043],
      [-87.99700852099994, 19.07777353000006],
      [-87.94224143399998, 18.719117679000078],
      [-89.32489869299997, 18.718991655000025],
      [-89.19901115299996, 17.874886273000072],
      [-90.74700218299995, 17.874856100000045],
      [-90.52930234299998, 16.316452],
      [-90.07363860499999, 15.959317727000041],
      [-92.17403272599995, 15.959317727000041],
      [-91.96305735099997, 14.274887561000071],
      [-94.62091537999999, 16.365614417000074],
      [-95.12033691999994, 15.870300822000047],
      [-98.23923651799998, 15.870300822000047],
      [-100.24323791299997, 17.418155806000073],
      [-102.44573964299997, 17.418155806000073],
      [-105.96542380099999, 20.095941543000038],
      [-105.45799245099994, 20.622000980000053],
      [-105.88442786799999, 22.742776953000032],
      [-109.81990774499997, 25.590830118000042],
      [-110.30020003299995, 27.32471047000007],
      [-111.57530564599995, 28.191011745000026],
      [-112.22487313799996, 30.187959428000056],
      [-113.83633609099996, 31.225022268000032],
      [-112.47329428199998, 27.20059930800005],
      [-110.80977779899996, 26.05518661900004],
      [-110.39607601199998, 24.383503236000024],
      [-109.71275549899997, 23.888189641000054],
      [-110.32774332699995, 23.23809054800006],
      [-111.73548301899996, 24.259674838000024],
      [-112.12271103299997, 25.838486921000026],
      [-115.24910953999995, 27.974526800000035],
      [-114.41445173299996, 27.974526800000035],
      [-115.74340969599996, 31.689378763000036],
      [-117.22039619399999, 32.612127110000074],
      [-114.62161994999997, 32.597336735000056]],
     [[-110.82976672599995, 18.840386094000053],
      [-110.77937842299997, 18.570850687000075],
      [-111.10048773299997, 18.570875347000026],
      [-111.15102438599996, 18.84041555500005],
      [-110.82976672599995, 18.840386094000053]]]},
   'id': 'MX'},
  {'type': 'Feature',
   'properties': {'id': 'LY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[15.984957656000063, 31.69943765800008],
      [17.306599293000033, 31.69943765800008],
      [18.766452918000027, 30.399239472000033],
      [19.859238849000064, 30.417754804000026],
      [20.03652891200005, 32.695794256000056],
      [22.91030798500003, 32.695794256000056],
      [24.949470618000078, 31.495061874000044],
      [25.485203096000077, 31.495061874000044],
      [24.87893627400007, 21.773301297000046],
      [24.786406356000043, 19.950702986000067],
      [24.105704584000023, 19.950702986000067],
      [24.08339525300005, 19.208184637000045],
      [15.943928534000065, 23.51456569100003],
      [15.256689695000034, 23.514240017000077],
      [11.998500001000025, 23.512695998000027],
      [11.559930670000028, 23.89601299000003],
      [9.379402475000063, 25.79284193500007],
      [9.500044359000071, 30.827342419000047],
      [11.455462724000029, 33.092448217000026],
      [14.422377555000025, 33.092448217000026],
      [15.984957656000063, 31.69943765800008]]]},
   'id': 'LY'},
  {'type': 'Feature',
   'properties': {'id': 'IL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[35.45279791000007, 33.33529581600004],
      [35.35439556600005, 32.565606141000046],
      [35.351428705000046, 32.56560747300006],
      [34.91898512600005, 32.56560804900005],
      [34.77144968300007, 31.360340413000074],
      [35.20657243900007, 31.359974088000058],
      [34.91898299300004, 28.80442953200003],
      [34.91836188800005, 28.805597211000077],
      [33.703737010000054, 31.09450617600004],
      [34.167815716000064, 31.094942442000047],
      [34.21522278400005, 31.495205810000073],
      [34.44559954600004, 33.336550610000074],
      [35.45279791000007, 33.33529581600004]]]},
   'id': 'IL'},
  {'type': 'Feature',
   'properties': {'id': 'JO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[39.22405776700003, 32.455621475000044],
      [37.11916488800006, 31.44149525200004],
      [38.22316925800004, 30.397330861000057],
      [36.168512226000075, 28.80571542000007],
      [34.91898299300004, 28.80442953200003],
      [35.20657243900007, 31.359974088000058],
      [35.35439556600005, 32.565606141000046],
      [36.519393861000026, 32.56508317500004],
      [38.69640226400003, 33.60674834400004],
      [39.22405776700003, 32.455621475000044]]]},
   'id': 'JO'},
  {'type': 'Feature',
   'properties': {'id': 'KR'}, // Korea
   'geometry': {'type': 'Polygon',
    'coordinates': [[[128.826084798, 34.25671483800005],
      [126.40654837200009, 34.25671483800005],
      [125.67626606800002, 36.17095625600007],
      [126.47218487600003, 37.598921810000036],
      [128.88444918100004, 38.93461545300005],
      [130.20148381900003, 36.79665956800005],
      [128.826084798, 34.25671483800005]],
     [[126.8117595760001, 33.20192280600003],
      [126.20534012900009, 33.20191996600005],
      [126.45757532300001, 33.725705445000074],
      [127.06601018000003, 33.725869018000026],
      [126.8117595760001, 33.20192280600003]]]},
   'id': 'KR'},
  {'type': 'Feature',
   'properties': {'id': 'xJK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[76.53634769000007, 34.77723909100007],
      [77.34434763400003, 33.849263731000065],
      [77.32744738500008, 33.838015186000064],
      [74.95884843000005, 32.23891058900006],
      [73.94501508600007, 33.33628818400007],
      [73.15015482300004, 34.20072874300007],
      [73.98930670400006, 36.92462402000007],
      [74.37910726300004, 36.92462402000007],
      [76.49860638300004, 36.929242833000046],
      [75.97410127300003, 35.35980254000003],
      [76.50790894800008, 34.75849543500004],
      [76.53634769000007, 34.77723909100007]]]},
   'id': 'xJK'},
  {'type': 'Feature',
   'properties': {'id': 'LB'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[36.65143814100003, 34.765923007000026],
      [36.511157025000045, 33.79819819800008],
      [35.89529856900003, 33.798338639000065],
      [35.45279791000007, 33.33529581600004],
      [34.44559954600004, 33.336550610000074],
      [35.81683971800004, 34.76717780100006],
      [36.65143814100003, 34.765923007000026]]]},
   'id': 'LB'},
  {'type': 'Feature',
   'properties': {'id': 'GR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[27.009038316000044, 41.78595609200005],
      [26.866595656000072, 40.79232587300004],
      [24.378484091000075, 40.79232587300004],
      [24.302121571000043, 40.13549459600006],
      [23.541061424000077, 40.13549459600006],
      [23.175363318000052, 36.809933640000054],
      [21.152422134000062, 36.809933640000054],
      [21.259127797000076, 37.927901030000044],
      [21.936843173000057, 37.927901030000044],
      [21.978002507000042, 38.331810390000044],
      [20.12865696500006, 38.31712584500008],
      [20.178966083000034, 38.84546945200003],
      [19.43102151000005, 39.51195356200003],
      [20.737151367000024, 40.50878769600007],
      [21.086460205000037, 40.77394046000006],
      [21.670960517000026, 40.77394046000006],
      [22.435206136000033, 41.34414419500007],
      [22.9482, 41.349859999000046],
      [25.87769742300003, 41.34557373100006],
      [26.481576622000034, 41.78652849100007],
      [27.009038316000044, 41.78595609200005]],
     [[26.46624938100007, 34.97732436600006],
      [23.477442858000074, 34.97732436600006],
      [23.52358735200005, 35.45456523000007],
      [26.51826832100005, 35.45456523000007],
      [26.46624938100007, 34.97732436600006]]]},
   'id': 'GR'},
  {'type': 'Feature',
   'properties': {'id': 'CY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[33.268249610000055, 34.491326540000045],
      [32.332992954000076, 34.67876367700006],
      [32.38390339100005, 35.058400187000075],
      [34.65581650300004, 35.73592542600005],
      [33.268249610000055, 34.491326540000045]]]},
   'id': 'CY'},
  {'type': 'Feature',
   'properties': {'id': 'MA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-4.7902782099999, 35.24748127600003],
      [-1.431205488999979, 35.24748127600003],
      [-1.418379835999929, 32.964799225000036],
      [-4.788473130999932, 30.095978331000026],
      [-7.426046409999969, 30.095978331000026],
      [-8.545374021999976, 29.125641852000058],
      [-8.515346287999932, 27.81410386500005],
      [-11.689831400999935, 27.807198366000023],
      [-10.259965837999971, 29.27837601500005],
      [-10.32271136199995, 31.75510151000003],
      [-5.541286716999934, 35.86164216700007],
      [-4.7902782099999, 35.24748127600003]]]},
   'id': 'MA'},
  {'type': 'Feature',
   'properties': {'id': 'TN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[11.084572038000033, 36.73410622100005],
      [10.967642302000058, 34.129432576000056],
      [10.326555829000029, 33.61117606700003],
      [10.924484965000033, 33.092448217000026],
      [11.455462724000029, 33.092448217000026],
      [9.500044359000071, 30.827342419000047],
      [9.078937096000061, 31.19288043800003],
      [7.320054322000033, 32.711667970000065],
      [7.356559460000028, 34.01951278900003],
      [8.394225345000052, 34.863283641000066],
      [8.460759869000071, 36.73479961000004],
      [11.084572038000033, 36.73410622100005]]]},
   'id': 'TN'},
  {'type': 'Feature',
   'properties': {'id': 'DZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[8.460759869000071, 36.73479961000004],
      [8.394225345000052, 34.863283641000066],
      [7.356559460000028, 34.01951278900003],
      [7.320054322000033, 32.711667970000065],
      [9.078937096000061, 31.19288043800003],
      [9.500044359000071, 30.827342419000047],
      [9.379402475000063, 25.79284193500007],
      [11.559930670000028, 23.89601299000003],
      [4.163981045000071, 19.042580179000026],
      [-5.49882215699995, 25.223583553000026],
      [-8.498244299999953, 27.10007997400004],
      [-8.515346287999932, 27.81410386500005],
      [-8.545374021999976, 29.125641852000058],
      [-7.426046409999969, 30.095978331000026],
      [-4.788473130999932, 30.095978331000026],
      [-1.418379835999929, 32.964799225000036],
      [-1.431205488999979, 35.24748127600003],
      [-0.81587776799995, 35.24748127600003],
      [0.976532661000022, 36.73677742600006],
      [8.460759869000071, 36.73479961000004]]]},
   'id': 'DZ'},
  {'type': 'Feature',
   'properties': {'id': 'PK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[73.15015482300004, 34.20072874300007],
      [73.94501508600007, 33.33628818400007],
      [74.95884843000005, 32.23891058900006],
      [74.42078162400003, 30.08587202800004],
      [69.98715839700003, 27.086790402000076],
      [71.36284715300008, 25.701471965000053],
      [71.11961855800007, 24.116468461000068],
      [67.79669605300006, 24.116468461000068],
      [67.35161114300007, 24.116468461000068],
      [65.75976316900005, 25.676706285000023],
      [62.18111379700008, 25.676706285000023],
      [62.61411119100006, 28.340589047000037],
      [61.016838515000074, 29.96004428400005],
      [65.63172124100004, 29.961168882000038],
      [70.78377197800006, 33.57695812500003],
      [71.38029972200007, 35.658477153000035],
      [71.47755272800003, 35.98112203200003],
      [72.90985900100003, 36.92462402000007],
      [73.98930670400006, 36.92462402000007],
      [73.15015482300004, 34.20072874300007]]]},
   'id': 'PK'},
  {'type': 'Feature',
   'properties': {'id': 'SY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[41.52509440700004, 34.94249245800006],
      [38.69640226400003, 33.60674834400004],
      [36.519393861000026, 32.56508317500004],
      [35.35439556600005, 32.565606141000046],
      [35.45279791000007, 33.33529581600004],
      [35.89529856900003, 33.798338639000065],
      [36.511157025000045, 33.79819819800008],
      [36.65143814100003, 34.765923007000026],
      [35.81683971800004, 34.76717780100006],
      [36.07058692900006, 36.478161433000025],
      [37.540409203000024, 37.54275692700003],
      [41.990434151000045, 37.54275692700003],
      [41.52509440700004, 34.94249245800006]]]},
   'id': 'SY'},
  {'type': 'Feature',
   'properties': {'id': 'IQ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[46.13576744400007, 35.732927690000054],
      [45.701262134000046, 33.378832687000056],
      [46.49911312000006, 33.378832687000056],
      [47.65737884200007, 32.23961141900003],
      [48.035403072000065, 31.868126223000047],
      [47.81461736800003, 30.50601383600008],
      [48.484323276000055, 29.978726987000073],
      [47.27008553200005, 29.980155903000025],
      [46.462489309000034, 29.224802671000077],
      [44.75889236300003, 29.219751334000023],
      [40.40885041700005, 32.04809016200005],
      [39.49843310000006, 31.861243830000035],
      [39.22405776700003, 32.455621475000044],
      [38.69640226400003, 33.60674834400004],
      [41.52509440700004, 34.94249245800006],
      [41.990434151000045, 37.54275692700003],
      [43.94673707700008, 37.544490729000074],
      [44.307423011000026, 37.54481038900008],
      [46.13576744400007, 35.732927690000054]]]},
   'id': 'IQ'},
  {'type': 'Feature',
   'properties': {'id': 'AF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[70.85592436300004, 37.44628019500004],
      [74.55264213300006, 37.44628019500004],
      [74.37910726300004, 36.92462402000007],
      [73.98930670400006, 36.92462402000007],
      [72.90985900100003, 36.92462402000007],
      [71.47755272800003, 35.98112203200003],
      [71.38029972200007, 35.658477153000035],
      [70.78377197800006, 33.57695812500003],
      [65.63172124100004, 29.961168882000038],
      [61.016838515000074, 29.96004428400005],
      [60.529530676000036, 30.456482477000066],
      [61.66030294900003, 35.45855205300006],
      [63.33560202700005, 35.459959903000026],
      [65.54083080600003, 36.949460798000075],
      [67.32206481200006, 36.949460798000075],
      [69.07940911000003, 36.949460798000075],
      [71.13142842700006, 38.291240007000056],
      [70.85592436300004, 37.44628019500004]]]},
   'id': 'AF'},
   {'type': 'Feature',
   'properties': {'id': 'IR'}, // IRAN WITH CASPIAN SEA
   'geometry': {'type': 'Polygon',
    'coordinates': [[[45.53420520900005, 38.937697839000066],
      [46.56317748200007, 38.937697839000066],
      [48.941809241000044, 38.95013237400008], //B
      [49.159694076161045, 38.72114187168905], // intersection point
      //[49.876202695000075, 37.96811255500006], //BB IRAN OLD
      //[50.99087447100004, 37.96811255500006], //IRAN OLD
      //[52.75326092900008, 37.96811255500006], //A IRAN OLD
      [49.004869843496685, 37.858027179508184], // B
      [50.964722024414513, 36.795115346864819],
      [53.557207278796938, 36.795908257366662], // AA

      [53.79437423369363, 37.96811255500003], // intersection point
      [54.18425848000004, 37.96811255500006], //AA
      [55.06035512300008, 38.56470836400007],
      [61.66030294900003, 35.45855205300006],
      [60.529530676000036, 30.456482477000066],
      [61.016838515000074, 29.96004428400005],
      [62.61411119100006, 28.340589047000037],
      [62.18111379700008, 25.676706285000023],
      [58.34272374600005, 25.676706285000023],
      [56.99971630300007, 26.989287312000044],
      [53.69873529000006, 26.98834690700005],
      [50.626065459000074, 29.984994156000027],
      [48.484323276000055, 29.978726987000073],
      [47.81461736800003, 30.50601383600008],
      [48.035403072000065, 31.868126223000047],
      [47.65737884200007, 32.23961141900003],
      [46.49911312000006, 33.378832687000056],
      [45.701262134000046, 33.378832687000056],
      [46.13576744400007, 35.732927690000054],
      [44.307423011000026, 37.54481038900008],
      [43.94673707700008, 37.544490729000074],
      [44.46494916300003, 40.007452346000036],
      [45.53420520900005, 38.937697839000066]]]},
   'id': 'IR'},

  // {'type': 'Feature',
  //  'properties': {'id': 'IR'}, // IRAN ORIGINAL
  //  'geometry': {'type': 'Polygon',
  //   'coordinates': [[[45.53420520900005, 38.937697839000066],
  //     [46.56317748200007, 38.937697839000066],
  //     [48.941809241000044, 38.95013237400008],
  //     [49.876202695000075, 37.96811255500006],
  //     [50.99087447100004, 37.96811255500006], // c
  //     [52.75326092900008, 37.96811255500006],
  //     [54.18425848000004, 37.96811255500006],
  //     [55.06035512300008, 38.56470836400007],
  //     [61.66030294900003, 35.45855205300006],
  //     [60.529530676000036, 30.456482477000066],
  //     [61.016838515000074, 29.96004428400005],
  //     [62.61411119100006, 28.340589047000037],
  //     [62.18111379700008, 25.676706285000023],
  //     [58.34272374600005, 25.676706285000023],
  //     [56.99971630300007, 26.989287312000044],
  //     [53.69873529000006, 26.98834690700005],
  //     [50.626065459000074, 29.984994156000027],
  //     [48.484323276000055, 29.978726987000073],
  //     [47.81461736800003, 30.50601383600008],
  //     [48.035403072000065, 31.868126223000047],
  //     [47.65737884200007, 32.23961141900003],
  //     [46.49911312000006, 33.378832687000056],
  //     [45.701262134000046, 33.378832687000056],
  //     [46.13576744400007, 35.732927690000054],
  //     [44.307423011000026, 37.54481038900008],
  //     [43.94673707700008, 37.544490729000074],
  //     [44.46494916300003, 40.007452346000036],
  //     [45.53420520900005, 38.937697839000066]]]},
  //  'id': 'IR'},
  {'type': 'Feature',
   'properties': {'id': 'TJ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[69.96363774200006, 39.963495383000065],
      [69.43777457700008, 39.629905561000044],
      [73.88980737900005, 39.62150836500007],
      [74.89941522400005, 38.450542926000026],
      [74.55264213300006, 37.44628019500004],
      [70.85592436300004, 37.44628019500004],
      [71.13142842700006, 38.291240007000056],
      [69.07940911000003, 36.949460798000075],
      [67.32206481200006, 36.949460798000075],
      [68.17008660100004, 39.62925876400004],
      [68.16950206500007, 39.63035085300004],
      [69.29505458100004, 40.41942333900005],
      [69.96363774200006, 39.963495383000065]]]},
   'id': 'TJ'},
  {'type': 'Feature',
   'properties': {'id': 'AM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[45.499320486000045, 40.007452346000036],
      [46.56317748200007, 38.937697839000066],
      [45.53420520900005, 38.937697839000066],
      [44.46494916300003, 40.007452346000036],
      [43.46100052700007, 40.007452347000026],
      [43.71984229900005, 41.15608829900003],
      [45.77030193200005, 41.15608829900003],
      [45.499320486000045, 40.007452346000036]]]},
   'id': 'AM'},
  {'type': 'Feature',
   'properties': {'id': 'IT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[13.53042153000007, 46.54744123900008],
      [13.45220786300007, 45.53919217300006],
      [12.780458893000059, 45.53919217300006],
      [12.675830529000052, 44.17988008400005],
      [12.733352986000057, 44.13052880200007],
      [12.229323188000023, 44.13052880200007],
      [12.22631444600006, 43.71540959500004],
      [12.771083015000045, 43.71540959500004],
      [12.775116307000076, 44.09468282100005],
      [14.824681743000042, 42.32023529400004],
      [16.431639716000063, 42.31644214900007],
      [18.807408059000068, 40.21659471300006],
      [18.169245054000044, 39.730774745000076],
      [17.45027686000003, 40.366346097000076],
      [16.960807156000044, 39.992055281000034],
      [17.723406386000022, 39.32028042300004],
      [15.792539516000033, 37.82849338600005],
      [15.069102043000044, 38.462326767000036],
      [16.03194569900006, 39.208346376000065],
      [14.835865741000077, 40.254029142000036],
      [14.873121250000054, 40.740884150000056],
      [13.315720992000024, 40.740884150000056],
      [12.197797034000075, 41.70767525200006],
      [12.19828540800006, 41.70767525200006],
      [12.697420897000029, 41.70767525200006],
      [12.701258170000074, 42.121435673000065],
      [12.161398477000034, 42.121435673000065],
      [12.15896054500007, 41.74154930800006],
      [10.82998354600005, 42.88012344300006],
      [10.853271492000033, 43.25619928800006],
      [9.076253554000061, 44.762818442000025],
      [7.522594050000066, 43.55722637200006],
      [6.931710883000051, 43.55722637200006],
      [6.948941836000074, 43.964274085000056],
      [6.948942036000062, 43.96427878800006],
      [6.948984773000063, 43.96529024600005],
      [7.044637422000051, 46.23799328200005],
      [7.268402190000074, 46.051724156000034],
      [8.149016523000057, 46.051724156000034],
      [8.535531203000062, 46.34959180100003],
      [8.875816343000054, 46.06413064000003],
      [9.27990350400006, 46.37442466500005],
      [10.193240526000068, 46.37442466500005],
      [10.21463174400003, 46.70982761600004],
      [13.317186738000032, 46.70982761600004],
      [13.53042153000007, 46.54744123900008]],
     [[9.39778642400006, 39.07577280000004],
      [8.261409038000068, 39.07577280000004],
      [8.349602546000028, 41.176999573000046],
      [9.498111169000026, 41.176999573000046],
      [9.39778642400006, 39.07577280000004]],
     [[15.270795485000065, 38.03605631700003],
      [15.230647834000024, 36.508240013000034],
      [12.366461815000036, 37.99875185700006],
      [15.270795485000065, 38.03605631700003]]]},
   'id': 'IT'},
  {'type': 'Feature',
   'properties': {'id': 'TR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[35.10791877100007, 41.581128068000055],
      [35.54860764600005, 41.15608829900003],
      [41.54696716700005, 41.15608829900003],
      [42.31206404500006, 41.15608829900003],
      [43.71984229900005, 41.15608829900003],
      [43.46100052700007, 40.007452347000026],
      [44.46494916300003, 40.007452346000036],
      [43.94673707700008, 37.544490729000074],
      [41.990434151000045, 37.54275692700003],
      [37.540409203000024, 37.54275692700003],
      [36.07058692900006, 36.478161433000025],
      [36.125039929000025, 36.832675890000075],
      [28.021947667000063, 36.836051601000065],
      [27.190075685000068, 37.60264850300007],
      [27.557678499000076, 40.393659435000075],
      [28.601527996000073, 41.15608830000008],
      [31.29466900700004, 41.15608829900003],
      [31.88721170200006, 41.581128068000055],
      [35.10791877100007, 41.581128068000055]],
     [[27.03147051700006, 40.79232587300004],
      [26.866595656000072, 40.79232587300004],
      [27.009038316000044, 41.78595609200005],
      [28.264021082000056, 42.69843618400006],
      [28.87441685500005, 42.12866350000007],
      [27.03147051700006, 40.79232587300004]]]},
   'id': 'TR'},
  {'type': 'Feature',
   'properties': {'id': 'MK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[22.36161050100003, 42.31304949300005],
      [22.994800440000063, 41.736850176000075],
      [22.9482, 41.349859999000046],
      [22.435206136000033, 41.34414419500007],
      [21.670960517000026, 40.77394046000006],
      [21.086460205000037, 40.77394046000006],
      [20.737151367000024, 40.50878769600007],
      [20.806852367000033, 41.10537608800007],
      [20.39636018500005, 41.473387424000066],
      [20.451588726000068, 41.970347340000046],
      [20.921799648000047, 42.31409305500006],
      [21.284483358000045, 42.31409305500006],
      [22.36161050100003, 42.31304949300005]]]},
   'id': 'MK'},
  {'type': 'Feature',
   'properties': {'id': 'AL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[20.333313780000026, 42.45671178900005],
      [20.506235274000062, 42.45583102900008],
      [20.451588726000068, 41.970347340000046],
      [20.39636018500005, 41.473387424000066],
      [20.806852367000033, 41.10537608800007],
      [20.737151367000024, 40.50878769600007],
      [19.43102151000005, 39.51195356200003],
      [19.23621549300003, 39.684975301000065],
      [19.449591525000073, 41.807302040000025],
      [19.32964581300007, 41.91449249600004],
      [19.38116999600004, 42.461561320000044],
      [20.333313780000026, 42.45671178900005]]]},
   'id': 'AL'},
  {'type': 'Feature',
   'properties': {'id': 'KP'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[130.90327097700003, 42.59721228300003],
      [130.6748644930001, 42.283614131000036],
      [129.35500416600007, 40.377965869000036],
      [128.34687672600012, 39.839399901000036],
      [128.88444918100004, 38.93461545300005],
      [126.47218487600003, 37.598921810000036],
      [124.19842939800003, 37.60150762200004],
      [125.41488291300004, 39.66024906300004],
      [124.24866228700012, 39.66024906300004],
      [124.4761504710001, 40.02859605500004],
      [129.36317229200006, 42.598606344000075],
      [130.90327097700003, 42.59721228300003]]]},
   'id': 'KP'},
  // {'type': 'Feature',
  //  'properties': {'id': 'AZ'}, // AZERBAIJAN ORIGINAL
  //  'geometry': {'type': 'Polygon',
  //   'coordinates': [[[51.67723816700004, 40.70636648100003], // b
  //     [50.99087447100004, 37.96811255500006],  // c
  //     [49.876202695000075, 37.96811255500006],// d A
  //     [48.941809241000044, 38.95013237400008],// e AA
  //     [46.56317748200007, 38.937697839000066], // e
  //     [45.499320486000045, 40.007452346000036], // f
  //     [45.77030193200005, 41.15608829900003],  // g
  //     [46.230154251000044, 41.15608829900003],  // h
  //     [46.41807813400004, 41.905639301000065], //  i
  //     [47.75974155100005, 41.22719661800005], //k B
  //     [49.84433246200007, 42.63053591900007], // a BB
  //     [51.67723816700004, 40.70636648100003]]]},
  //  'id': 'AZ'},

  {'type': 'Feature',
   'properties': {'id': 'AZ'}, // AZERBAIJAN WITH CASPIAN SEA
   'geometry': {'type': 'Polygon',
    'coordinates': [[
      [46.230154251000044, 41.15608829900003],  // h
      [46.41807813400004, 41.905639301000065], //  i
      [47.75974155100005, 41.22719661800005], //k B

      [48.6554833937001, 41.83020688959725], // intersection point

      // [49.84433246200007, 42.63053591900007], // a BB
      // [51.67723816700004, 40.70636648100003], // b
      // [50.99087447100004, 37.96811255500006],  // c
      // [49.876202695000075, 37.96811255500006],// d A
      [49.938099994305524, 40.281100022360881], // AzB
      [49.295937582530662, 39.480672663723809], // IrBB // AzAA

      [49.159694076161045, 38.72114187168905], // intersection point

      [48.941809241000044, 38.95013237400008],// e AA
      [46.56317748200007, 38.937697839000066], // e
      [45.499320486000045, 40.007452346000036], // f
      [45.77030193200005, 41.15608829900003],  // g
      [46.230154251000044, 41.15608829900003]]]},  // h
   'id': 'AZ'},
  // {'type': 'Feature',
  //  'properties': {'id': 'TM'}, // TURKMENISTAN ORIGINAL
  //  'geometry': {'type': 'Polygon',
  //   'coordinates': [[[54.91084330900003, 42.158516906000045],
  //     [55.66999143100003, 41.33924339400005],
  //     [56.98361715100003, 41.33924339400005],
  //     [57.290784845000076, 42.32749269800007],
  //     [59.72366572100003, 42.32749269800007],
  //     [62.45357166000008, 39.312700402000075],
  //     [65.08802515100007, 39.312700402000075],
  //     [66.10600123800003, 38.83524946500006],
  //     [65.54083080600003, 36.949460798000075],
  //     [63.33560202700005, 35.459959903000026],
  //     [61.66030294900003, 35.45855205300006],
  //     [55.06035512300008, 38.56470836400007],
  //     [54.18425848000004, 37.96811255500006],
  //     [52.75326092900008, 37.96811255500006],
  //     [50.99087447100004, 37.96811255500006], // c
  //     [51.67723816700004, 40.70636648100003],
  //     [53.53665959400007, 40.96866421300007],
  //     [54.54184105200005, 40.96866421300007],
  //     [54.78980103200007, 41.856310680000036],
  //     [53.25667494100003, 41.85053755000007],
  //     [52.994309283000064, 42.13079279600004],
  //     [54.20412027700007, 42.92120754600006],
  //     [54.91084330900003, 42.158516906000045]]]},
  //  'id': 'TM'},


  {'type': 'Feature',
   'properties': {'id': 'TM'}, // TURKMENISTAN WITH CASPIAN SEA
   'geometry': {'type': 'Polygon',
    'coordinates': [[
      [54.91084330900003, 42.158516906000045], //a
      [55.66999143100003, 41.33924339400005],  //b
      [56.98361715100003, 41.33924339400005],  //c
      [57.290784845000076, 42.32749269800007], //d
      [59.72366572100003, 42.32749269800007],  //e
      [62.45357166000008, 39.312700402000075],  //f
      [65.08802515100007, 39.312700402000075], //g
      [66.10600123800003, 38.83524946500006], //h
      [65.54083080600003, 36.949460798000075], //i
      [63.33560202700005, 35.459959903000026], //j
      [61.66030294900003, 35.45855205300006], //k
      [55.06035512300008, 38.56470836400007], //l
      [54.18425848000004, 37.96811255500006],//m // A
      [53.79437423369363, 37.96811255500003],// intersection - here?

      // [52.75326092900008, 37.96811255500006],//n // AA delete
      // [50.99087447100004, 37.96811255500006],//o // c  delete

      
        
        [53.982635146166089, 38.898597372216713], //CS1?
        [53.180474644602079, 39.288899061243541], // CS22?
        [52.887392013181461, 40.877153820696194], // CS21?

      // [51.67723816700004, 40.70636648100003],//p // D // F delete

      [53.53665959400007, 40.96866421300007],//q, // DD // E // FF start again
      [54.54184105200005, 40.96866421300007],//r // EE
      [54.78980103200007, 41.856310680000036],//s // C
      [53.25667494100003, 41.85053755000007], //t// B // CC
      [52.994309283000064, 42.13079279600004],//u //BB
      [54.20412027700007, 42.92120754600006],//v
      [54.91084330900003, 42.158516906000045]]]}, //a
   'id': 'TM'},
  {'type': 'Feature',
   'properties': {'id': 'GE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[46.41807813400004, 41.905639301000065],
      [46.230154251000044, 41.15608829900003],
      [45.77030193200005, 41.15608829900003],
      [43.71984229900005, 41.15608829900003],
      [42.31206404500006, 41.15608829900003],
      [41.54696716700005, 41.15608829900003],
      [41.83590964500007, 42.432091644000025],
      [40.47997428200006, 42.432091644000025],
      [39.44869865100003, 43.21096179800003],
      [43.58761868400006, 43.21384556000004],
      [46.41807813400004, 41.905639301000065]]]},
   'id': 'GE'},
  {'type': 'Feature',
   'properties': {'id': 'KG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[79.14832855100008, 41.634842252000055],
      [77.55226002400008, 40.66250478500007],
      [74.27986390100006, 40.66250478500007],
      [73.88980737900005, 39.62150836500007],
      [69.43777457700008, 39.629905561000044],
      [69.96363774200006, 39.963495383000065],
      [71.48086416800004, 40.91619443700006],
      [70.83623035500005, 41.677892487000065],
      [69.42925571700005, 40.79704415200007],
      [69.95033354500003, 42.20353949400004],
      [70.65513096800004, 42.63841445700007],
      [73.85818596400003, 42.63841445700007],
      [75.57511015700004, 43.232430805000035],
      [79.87193411900006, 43.232430805000035],
      [79.14832855100008, 41.634842252000055]]]},
   'id': 'KG'},
  {'type': 'Feature',
   'properties': {'id': 'ME'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[19.235138263000067, 43.52612004400004],
      [19.903685101000065, 42.94107836300003],
      [20.38896854500007, 42.94107836300003],
      [20.333313780000026, 42.45671178900005],
      [19.38116999600004, 42.461561320000044],
      [19.32964581300007, 41.91449249600004],
      [18.501661804000037, 42.651946063000025],
      [18.601889666000034, 43.53176898500004],
      [19.235800419000043, 43.53176898500004],
      [19.235138263000067, 43.52612004400004]]]},
   'id': 'ME'},
  {'type': 'Feature',
   'properties': {'id': 'BG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[28.47859659100004, 44.012074263000045],
      [28.264021082000056, 42.69843618400006],
      [27.009038316000044, 41.78595609200005],
      [26.481576622000034, 41.78652849100007],
      [25.87769742300003, 41.34557373100006],
      [22.9482, 41.349859999000046],
      [22.994800440000063, 41.736850176000075],
      [22.36161050100003, 42.31304949300005],
      [22.425300890000074, 42.854983565000055],
      [22.743523442000026, 43.08869760500005],
      [22.294761066000035, 43.494834119000075],
      [22.362503163000042, 44.01212526300003],
      [28.47859659100004, 44.012074263000045]]]},
   'id': 'BG'},
  {'type': 'Feature',
   'properties': {'id': 'BA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[18.94958444200006, 44.86291204500003],
      [19.394386678000046, 44.86291204500003],
      [19.235800419000043, 43.53176898500004],
      [18.601889666000034, 43.53176898500004],
      [18.501661804000037, 42.651946063000025],
      [17.734265460000074, 43.331442182000046],
      [16.953940273000057, 43.33057564200004],
      [15.561462773000073, 44.55534183800006],
      [15.61979126600005, 45.17189781800005],
      [18.985216517000026, 45.171903902000054],
      [18.94958444200006, 44.86291204500003]]]},
   'id': 'BA'},
  {'type': 'Feature',
   'properties': {'id': 'UZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[61.96403186600003, 43.70516003000006],
      [64.47953536700004, 43.70516003000006],
      [68.24334961000005, 41.13716841200005],
      [69.95033354500003, 42.20353949400004],
      [69.42925571700005, 40.79704415200007],
      [70.83623035500005, 41.677892487000065],
      [71.48086416800004, 40.91619443700006],
      [69.96363774200006, 39.963495383000065],
      [69.29505458100004, 40.41942333900005],
      [68.16950206500007, 39.63035085300004],
      [68.17008660100004, 39.62925876400004],
      [67.32206481200006, 36.949460798000075],
      [65.54083080600003, 36.949460798000075],
      [66.10600123800003, 38.83524946500006],
      [65.08802515100007, 39.312700402000075],
      [62.45357166000008, 39.312700402000075],
      [59.72366572100003, 42.32749269800007],
      [57.290784845000076, 42.32749269800007],
      [56.98361715100003, 41.33924339400005],
      [55.66999143100003, 41.33924339400005],
      [54.91084330900003, 42.158516906000045],
      [55.91011356000007, 45.24568751000004],
      [59.83450467800003, 45.24568751000004],
      [61.96403186600003, 43.70516003000006]]]},
   'id': 'UZ'},
  {'type': 'Feature',
   'properties': {'id': 'RU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[180.0000000000001, 65.23696790600007], // RUSSIA WITH CASPIAN SEA
      [179.86317334900002, 65.14678686100007],
      [177.2714055660001, 65.14678686100007],
      [175.86526378400004, 64.38875836700004],
      [179.49641497000005, 64.36834773800007],
      [178.63879116300006, 62.72503788000006],
      [172.1145497880001, 60.56370801500003],
      [165.87570931300002, 60.56370801500003],
      [162.3479513430001, 58.272485105000044],
      [163.00771168500012, 55.74298282600006],
      [156.77831126700005, 50.807322363000026],
      [154.824343687, 55.16645987800007],
      [166.2016366370001, 62.84609782500007],
      [164.54072645700012, 62.84609782500007],
      [161.29885410100007, 60.822113252000065],
      [159.2313163120001, 60.822113252000065],
      [161.0375446390001, 61.980818542000065],
      [157.32603606200007, 61.980818542000065],
      [153.44384663900007, 59.37905583100007],
      [141.9977517520001, 59.37905583100007],
      [135.84371445500005, 54.32607200400008],
      [140.2822578350001, 54.32607200400008],
      [141.08460076400002, 50.16947663800005],
      [134.5501052830001, 42.59391118100007],
      [130.90327097700003, 42.59721228300003],
      [130.90429307300008, 42.598606345000064],
      [131.53558623700008, 43.44094969200006],
      [130.86688208200007, 44.902758369000026],
      [131.86282199700008, 45.39184513400005],
      [132.68242232000011, 44.89772897900008],
      [135.23638585800006, 47.954667836000056],
      [134.97834295400003, 48.651551881000046],
      [133.49013385800004, 47.954667836000056],
      [130.60945537700002, 47.954667836000056],
      [125.53731599100001, 53.44138382300008],
      [120.76373162100003, 53.44138382300008],
      [117.5936263540001, 49.89081036600004],
      [116.76726626200002, 49.89081036600004],
      [117.17276665100007, 50.38289494800006],
      [113.70036681600004, 50.38289494800006],
      [112.10705166600007, 49.60485777300005],
      [108.88536256300006, 49.60485777300005],
      [108.51173645600005, 50.34182103400008],
      [102.24252655600009, 50.34182103400008],
      [101.55899795800008, 51.659561437000036],
      [99.38798382300007, 51.659561437000036],
      [97.97236145200009, 49.66611502000006],
      [95.36815369600004, 49.66611502000006],
      [94.79587645300006, 50.629480743000045],
      [90.56449726600005, 50.629480743000045],
      [89.97844813300009, 49.706958729000064],
      [88.32779875300008, 49.706958729000064],
      [88.06631598400008, 49.268133885000054],
      [87.21742925900008, 49.26812114200004],
      [86.77689983400006, 49.26812114200004],
      [87.18981298200003, 49.969996421000076],
      [84.30410106000005, 49.97244245500008],
      [83.43246863500008, 51.297644621000074],
      [80.22947685600008, 51.297644621000074],
      [76.04308119500007, 54.06565208100005],
      [73.98026837900005, 53.49040647100003],
      [71.74074137100007, 53.49040647100003],
      [70.47237495500008, 55.31781807100003],
      [67.49617706400005, 55.31781807100003],
      [65.72569658700007, 54.35378090200004],
      [61.54316870900004, 54.35378090200004],
      [60.746045914000035, 53.90572652700007],
      [61.097575852000034, 53.45848780400007],
      [60.07661615100005, 51.266007811000065],
      [60.648995599000045, 50.571014880000064],
      [54.91410493500007, 50.571014880000064],
      [54.339914950000036, 51.234375029000034],
      [51.098401144000036, 51.234375029000034],
      [47.211713675000055, 48.813640133000035], //B

      // [49.893029916000046, 45.96451887100005], //BB OLD
      // [47.90102398400006, 44.673726560000034], // OLD
      // [49.84433246200007, 42.63053591900007], //A OLD

        //-1 [50.930674236525832, 47.007581521722848],#6@@ want # CSBB # DELETE
      [49.48049063711397, 46.40287612737734],// # 3 intersect with RU

      [48.1114860731184, 45.832021205926374], // 1#@ # delete #CS B
      [47.541751851703722, 43.175339315881153], // 2#CS AA 

      [48.6554833937001, 41.83020688959725],//# 0 intersect with RU 


      // 4 [49.938099994305524, 40.281100022360881], #CS A # DELETE

      [47.75974155100005, 41.22719661800005], //AA
      [46.41807813400004, 41.905639301000065],
      [43.58761868400006, 43.21384556000004],
      [39.44869865100003, 43.21096179800003],
      [36.82706319500005, 45.17511142800004],
      [39.158956371000045, 46.758075846000054],
      [37.65685433800007, 46.758075846000054],
      [39.79814206400005, 48.18557788500004],
      [40.35814697300003, 50.25801270300008],
      [36.59210374500003, 50.27096080900003],
      [34.75659174200007, 52.09307307800003],
      [31.84530638600006, 52.09307307800003],
      [32.06121881200005, 52.96707802700007],
      [30.595377176000056, 54.398057848000064],
      [31.054729226000063, 56.17070381000008],
      [27.23985323100004, 56.17070381000008],
      [27.68106943300006, 57.96293586300004],
      [28.116871097000057, 59.65141374600006],
      [29.950870757000075, 59.67161437900006],
      [30.17280242700008, 60.44943256300007],
      [28.357460770000046, 60.44943256300007],
      [30.791105998000035, 61.99797712900005],
      [31.27200649200006, 63.541016712000044],
      [29.313017222000042, 63.541016712000044],
      [29.971691811000028, 65.66525544300004],
      [27.984472466000057, 67.64925724500006],
      [28.181588867000073, 68.27430917300006],
      [31.13963281100007, 70.05638835000008],
      [41.83948069100006, 67.90451479700005],
      [41.21791092900003, 66.55015464300004],
      [38.487400672000035, 65.82362913200006],
      [32.178972188000046, 66.88713771400006],
      [34.695525033000024, 64.25060996600007],
      [38.42784151300003, 64.25060996600007],
      [41.68975862000008, 66.13040756800007],
      [43.593431456000076, 66.13040756800007],
      [44.782820954000044, 68.55964974100004],
      [46.700825079000026, 68.55964974100004],
      [45.70971503900006, 66.63430116100005],
      [47.43977509300004, 66.63430116100005],
      [47.868589513000074, 67.42608130000008],
      [53.539655492000065, 68.30280853400006],
      [59.68940835600006, 68.30280853400006],
      [60.21779851800005, 69.07522007100005],
      [66.83812587000006, 69.07522007100005],
      [68.07143091400008, 67.81823912300007],
      [69.14005060900007, 68.33018857100006],
      [67.94478381800008, 69.62942298600007],
      [66.27287777400005, 69.62219860200008],
      [68.83118810000008, 72.66299365100008],
      [73.14109110200008, 72.66299365100008],
      [71.67242168800004, 71.06224604300007],
      [73.05012656300005, 68.58822632000005],
      [71.19428997500006, 66.27014137200007],
      [71.96424276000005, 66.27014137200007],
      [73.84014987000006, 68.58822632000005],
      [76.24783994700005, 68.58822632000005],
      [76.72477211300003, 69.13266228000003],
      [74.28585984900008, 69.11946094100006],
      [73.47338214200005, 71.05369313400007],
      [74.27552997500004, 71.91399143500007],
      [75.45029147300005, 71.91399143500007],
      [74.93985954400006, 71.37894974600005],
      [76.96233726300005, 71.37894974600005],
      [77.72471554300006, 72.15292002000007],
      [81.84901882900004, 72.15292002000007],
      [82.42607402700008, 72.69309849000007],
      [79.77582163600005, 72.69309849000007],
      [80.91314460300003, 73.75394483100007],
      [87.21197447900005, 73.75394483100007],
      [86.28854153000003, 74.36654329200007],
      [87.96770506800004, 75.71011627600006],
      [99.22773486800008, 75.71011627600006],
      [100.91016479500007, 76.81445671600005],
      [102.47607133800005, 77.78375184800007],
      [107.16160397900006, 77.78375184800007],
      [105.52409919900003, 76.81445671600005],
      [114.08085027300001, 76.81445671600005],
      [113.30593914500002, 74.91005986200008],
      [106.10693540000005, 73.16891708400004],
      [106.05771395500005, 72.62468969900004],
      [113.15679286600005, 74.35382971500007],
      [112.96780058700006, 73.54087689200003],
      [122.80104010900004, 73.54087689200003],
      [130.34434714000008, 73.54087689200003],
      [129.53834266700005, 71.41738489600004],
      [137.13781817900008, 71.41738489600004],
      [137.73202121300005, 72.72532898100008],
      [153.72180254700004, 72.72532898100008],
      [154.29672627800005, 71.81759322900007],
      [160.74962393700002, 71.81759322900007],
      [158.78612824900006, 68.57819586000005],
      [165.1190795550001, 68.57819586000005],
      [166.2644034100001, 70.42531826200008],
      [179.99952885900007, 70.42531826200008],
      [180.0000000000001, 70.42511817900004],
      [180.0000000000001, 65.23696790600007]],
     [[143.63728947800007, 46.62891739500003],
      [141.83719862600003, 45.78381714600005],
      [141.2531844780001, 47.430498182000065],
      [141.7447547170001, 47.97231254400003],
      [142.93962508700008, 49.24981184500007],
      [142.0789195420001, 53.16179146500008],
      [144.18656559600004, 54.03079871800003],
      [145.25899872500008, 48.700895143000025],
      [144.11000392300002, 48.608775999000045],
      [143.26199867200012, 47.699567364000075],
      [143.63728947800007, 46.62891739500003]],
     [[56.995495263000066, 73.40802236600007],
      [54.413161149000075, 73.40802236600007],
      [55.510083429000076, 74.86060975300006],
      [59.04797951200004, 76.50678764800006],
      [60.97240925600005, 76.50678764800006],
      [63.036956538000084, 77.08818856300007],
      [69.32122691400008, 77.08818856300007],
      [68.98335256500008, 76.77594501300007],
      [67.50592342700003, 75.34206700300007],
      [61.12356990500007, 75.34206700300007],
      [56.995495263000066, 73.40802236600007]],
     [[56.603098877000036, 73.05866594500003],
      [55.78577121400008, 71.94316539900007],
      [56.78902118700006, 71.94316539900007],
      [57.613224194000054, 70.56054533300005],
      [53.69379332800003, 70.56054533300005],
      [52.81326742200008, 71.92406671500004],
      [53.60014999300006, 73.05866594500003],
      [56.603098877000036, 73.05866594500003]],
     [[22.921698396000068, 54.31978912300008],
      [19.21575602000007, 54.31978912300008],
      [20.57889983900003, 55.26160763200005],
      [23.102276611000036, 55.26160763200005],
      [22.921698396000068, 54.31978912300008]],
     [[150.80623007300005, 45.99472753300006], // Island #5
      [149.47938181100005, 45.38042633400005],
      [149.45533146900004, 45.453392301000065],
      [149.33262225800001, 45.83006391200007],
      [149.64913500600005, 45.97622755800006],
      [150.66600398800006, 46.44307218600005],
      [150.80623007300005, 45.99472753300006]],
     [[156.2403814160001, 50.61102144000006],
      [155.7608114310001, 50.181409201000065],
      [155.24713281000004, 50.18292646000003],
      [155.72023326700003, 50.60816267200005],
      [156.2403814160001, 50.61102144000006]],
     [[164.9924567810001, 59.178512468000065],
      [164.3066232440001, 58.72960786600004],
      [163.7562938210001, 58.731192640000074],
      [164.43283913400012, 59.17552415500006],
      [164.9924567810001, 59.178512468000065]],
     [[154.96807260100002, 49.37311869700005],
      [154.52549177900005, 48.946569915000055],
      [154.0160021150001, 48.948076798000045],
      [154.45261672300012, 49.37028114700007],
      [154.96807260100002, 49.37311869700005]],
     [[153.73348345400007, 48.254030114000045], // Island #3
      [153.3085649520001, 47.82874483000006],
      [152.80275225000003, 47.830247255000074],
      [153.221941871, 48.25120097800004],
      [153.73348345400007, 48.254030114000045]],
     [[152.54945634000012, 47.26306559600005], // Island #4
      [152.13995276000003, 46.83889292500004],
      [151.63728264100007, 46.84039142300003],
      [152.04126339100003, 47.26024387100006],
      [152.54945634000012, 47.26306559600005]],
     [[166.9281912680001, 55.30064900900004],
      [166.31685258200002, 54.861718547000066],
      [165.78465627600008, 54.863264823000065],
      [166.38780624700007, 55.297724188000075],
      [166.9281912680001, 55.30064900900004]],
     [[-180.0, 70.42511817900004],
      [-169.74228524599997, 66.06888279100008],
      [-172.38220246299997, 64.40435252600008],
      [-178.63526926499998, 66.13644796900007],
      [-180.0, 65.23696790600007],
      [-180.0, 70.42511817900004]]]},
   'id': 'RU'},
  {'type': 'Feature',
   'properties': {'id': 'RS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[20.949501129000055, 45.39475974100003],
      [21.42651240500004, 45.39475974100003],
      [21.338730799000075, 44.67829344200004],
      [22.451986009000052, 44.67785759100008],
      [22.362503163000042, 44.01212526300003],
      [22.294761066000035, 43.494834119000075],
      [22.743523442000026, 43.08869760500005],
      [22.425300890000074, 42.854983565000055],
      [22.36161050100003, 42.31304949300005],
      [21.284483358000045, 42.31409305500006],
      [20.921799648000047, 42.31409305500006],
      [20.451588726000068, 41.970347340000046],
      [20.506235274000062, 42.45583102900008],
      [20.333313780000026, 42.45671178900005],
      [20.38896854500007, 42.94107836300003],
      [19.903685101000065, 42.94107836300003],
      [19.235138263000067, 43.52612004400004],
      [19.235800419000043, 43.53176898500004],
      [19.394386678000046, 44.86291204500003],
      [18.94958444200006, 44.86291204500003],
      [18.985216517000026, 45.171903902000054],
      [19.077087636000044, 45.96421067700004],
      [19.109153939000066, 46.23786402800005],
      [20.00624953600004, 46.23786402800005],
      [20.949501129000055, 45.39475974100003]]]},
   'id': 'RS'},
  {'type': 'Feature',
   'properties': {'id': 'HR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[17.285776129000055, 45.964692057000036],
      [19.077087636000044, 45.96421067700004],
      [18.985216517000026, 45.171903902000054],
      [15.61979126600005, 45.17189781800005],
      [15.561462773000073, 44.55534183800006],
      [16.953940273000057, 43.33057564200004],
      [15.47236123700003, 43.32893034800003],
      [14.730588715000067, 43.97599901400008],
      [14.780575611000074, 44.554519097000025],
      [14.061714892000055, 44.556756015000076],
      [14.145738498000071, 45.53919217300006],
      [14.961885025000072, 45.543406954000034],
      [15.641963045000068, 46.051724156000034],
      [15.68053754300007, 46.44893301400003],
      [16.73368576400003, 46.44893301400003],
      [17.285776129000055, 45.964692057000036]]]},
   'id': 'HR'},
  {'type': 'Feature',
   'properties': {'id': 'SI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[16.73368576400003, 46.44893301400003],
      [15.68053754300007, 46.44893301400003],
      [15.641963045000068, 46.051724156000034],
      [14.961885025000072, 45.543406954000034],
      [14.145738498000071, 45.53919217300006],
      [13.45220786300007, 45.53919217300006],
      [13.53042153000007, 46.54744123900008],
      [14.605471932000057, 46.548300262000055],
      [15.022170318000065, 46.85899092900007],
      [16.26435751300005, 46.85899092900007],
      [16.73368576400003, 46.44893301400003]]]},
   'id': 'SI'},
  {'type': 'Feature',
   'properties': {'id': 'PM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-56.07750464099996, 46.92524478400003],
      [-55.98081014199994, 46.649546255000075],
      [-56.33720907299994, 46.64957147000007],
      [-56.43452417799995, 46.92527492900007],
      [-56.07750464099996, 46.92524478400003]]]},
   'id': 'PM'},
  {'type': 'Feature',
   'properties': {'id': 'KZ'}, // KAZAKHSTAN WITH CASPIAN SEA
   'geometry': {'type': 'Polygon',
    'coordinates': [[
      [60.746045914000035, 53.90572652700007], // new loop top
      [61.54316870900004, 54.35378090200004],
      [65.72569658700007, 54.35378090200004],
      [67.49617706400005, 55.31781807100003],
      [70.47237495500008, 55.31781807100003],
      [71.74074137100007, 53.49040647100003],
      [73.98026837900005, 53.49040647100003],
      [76.04308119500007, 54.06565208100005],
      [80.22947685600008, 51.297644621000074],
      [83.43246863500008, 51.297644621000074],
      [84.30410106000005, 49.97244245500008],
      [87.18981298200003, 49.969996421000076],
      [86.77689983400006, 49.26812114200004],
      [85.58760551800003, 47.158613417000026],
      [84.04270423600008, 47.16188564300006],
      [80.41758852600003, 44.423894776000054],
      [79.87193411900006, 43.232430805000035],
      [75.57511015700004, 43.232430805000035],
      [73.85818596400003, 42.63841445700007],
      [70.65513096800004, 42.63841445700007],
      [69.95033354500003, 42.20353949400004],
      [68.24334961000005, 41.13716841200005],
      [64.47953536700004, 43.70516003000006],
      [61.96403186600003, 43.70516003000006],
      [59.83450467800003, 45.24568751000004], // a
      [55.91011356000007, 45.24568751000004], // b
      [54.91084330900003, 42.158516906000045], // c
      [54.20412027700007, 42.92120754600006], // d
      [52.994309283000064, 42.13079279600004], // e

      [53.25667494100003, 41.85053755000007], // f KZmeeting point 

      //  [54.78980103200007, 41.856310680000036], // delete
      //  [54.54184105200005, 40.96866421300007], // delete
      //  [53.53665959400007, 40.96866421300007], // delete
      //  [51.67723816700004, 40.70636648100003], // delete
      //  [49.84433246200007, 42.63053591900007], // delete
      // [47.90102398400006, 44.673726560000034], // delete
      // [49.893029916000046, 45.96451887100005], // delete
               
       [52.131008805137483, 41.823052722277616],//CS#1
       [50.99702170345288, 44.151010646079023],//CS#2
       [51.220809898430666, 45.080969388098787],//CS#3
       [52.700549211371658, 45.561402997065926], //CS#4
       [53.071788369381736, 46.98969378969376],//CS#5
       [50.930674236525832, 47.007581521722848],//CS#6@@ want

       [49.48049063711397, 46.40287612737734],// intersection point here??

      [47.211713675000055, 48.813640133000035],
       [51.098401144000036, 51.234375029000034],
      [54.339914950000036, 51.234375029000034],
      [54.91410493500007, 50.571014880000064],
      [60.648995599000045, 50.571014880000064],
      [60.07661615100005, 51.266007811000065],
      [61.097575852000034, 53.45848780400007],

      [60.746045914000035, 53.90572652700007]]]}, // new loop
      //[53.53665959400007, 40.96866421300007]]]},
   'id': 'KZ'},
  {'type': 'Feature',
   'properties': {'id': 'CH'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[9.658467926000071, 47.52792583300004],
      [9.659437270000069, 47.436731476000034],
      [9.380595174000064, 47.43679119500007],
      [9.384913192000056, 47.017461784000034],
      [9.940763874000027, 47.017461784000034],
      [9.939710071000036, 47.17418660700008],
      [10.244368842000029, 47.169936654000026],
      [10.21463174400003, 46.70982761600004],
      [10.193240526000068, 46.37442466500005],
      [9.27990350400006, 46.37442466500005],
      [8.875816343000054, 46.06413064000003],
      [8.535531203000062, 46.34959180100003],
      [8.149016523000057, 46.051724156000034],
      [7.268402190000074, 46.051724156000034],
      [7.044637422000051, 46.23799328200005],
      [6.820646608000061, 46.424095271000056],
      [6.293647583000052, 46.01450713400004],
      [6.328348624000057, 46.89629093600007],
      [7.149251281000033, 47.53095406700004],
      [9.658467926000071, 47.52792583300004]]]},
   'id': 'CH'},
  {'type': 'Feature',
   'properties': {'id': 'RO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[26.402205767000055, 47.581960422000066],
      [28.129721405000055, 45.97753208800003],
      [28.040365852000036, 45.46907608300006],
      [28.363648169000044, 45.46907608300006],
      [28.675484078000068, 45.17484434600004],
      [28.47859659100004, 44.012074263000045],
      [22.362503163000042, 44.01212526300003],
      [22.451986009000052, 44.67785759100008],
      [21.338730799000075, 44.67829344200004],
      [21.42651240500004, 45.39475974100003],
      [20.949501129000055, 45.39475974100003],
      [20.00624953600004, 46.23786402800005],
      [20.70227198300006, 46.23786402800005],
      [23.17443935600005, 48.017004446000044],
      [25.929994342000043, 48.017004446000044],
      [26.402205767000055, 47.581960422000066]]]},
   'id': 'RO'},
  {'type': 'Feature',
   'properties': {'id': 'MD'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[29.74884226900008, 46.31234555300006],
      [28.83585765500004, 46.31234555300006],
      [28.68693048600005, 45.46907608300006],
      [28.363648169000044, 45.46907608300006],
      [28.040365852000036, 45.46907608300006],
      [28.129721405000055, 45.97753208800003],
      [26.402205767000055, 47.581960422000066],
      [27.54129053400004, 48.37883248600008],
      [29.74884226900008, 46.31234555300006]]]},
   'id': 'MD'},
  {'type': 'Feature',
   'properties': {'id': 'HU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[23.17443935600005, 48.017004446000044],
      [20.70227198300006, 46.23786402800005],
      [20.00624953600004, 46.23786402800005],
      [19.109153939000066, 46.23786402800005],
      [19.077087636000044, 45.96421067700004],
      [17.285776129000055, 45.964692057000036],
      [16.73368576400003, 46.44893301400003],
      [16.26435751300005, 46.85899092900007],
      [16.335340864000045, 47.54340909100006],
      [16.945812185000023, 47.99206356800005],
      [17.827888362000067, 47.98893547000006],
      [19.995232659000067, 47.98857931200007],
      [20.72355009100005, 48.51616842000004],
      [22.62253873900005, 48.51616842000004],
      [23.17443935600005, 48.017004446000044]]]},
   'id': 'HU'},
  {'type': 'Feature',
   'properties': {'id': 'AT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[16.73744743000003, 48.94311210800004],
      [17.827888362000067, 47.98893547000006],
      [16.945812185000023, 47.99206356800005],
      [16.335340864000045, 47.54340909100006],
      [16.26435751300005, 46.85899092900007],
      [15.022170318000065, 46.85899092900007],
      [14.605471932000057, 46.548300262000055],
      [13.53042153000007, 46.54744123900008],
      [13.317186738000032, 46.70982761600004],
      [10.21463174400003, 46.70982761600004],
      [10.244368842000029, 47.169936654000026],
      [9.939710071000036, 47.17418660700008],
      [9.937931951000053, 47.43679119500007],
      [9.659437270000069, 47.436731476000034],
      [9.658467926000071, 47.52792583300004],
      [9.674599981000028, 47.76766974000003],
      [12.688806421000038, 47.76766974000003],
      [12.729000708000058, 48.25402500800004],
      [13.646919927000056, 48.94447707200004],
      [16.73744743000003, 48.94311210800004]]]},
   'id': 'AT'},
  {'type': 'Feature',
   'properties': {'id': 'CA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-92.60110182299996, 71.70446720600006],
      [-87.83599059399995, 67.21336551700006],
      [-86.14551904199999, 67.21336551700006],
      [-85.17953529699997, 67.21336551700006],
      [-84.29911697799997, 69.70014706900008],
      [-81.25021553099998, 68.35643011900004],
      [-82.14096170999994, 66.18173060500004],
      [-86.52912108499999, 66.17345112800007],
      [-87.60588137199994, 63.45572580000004],
      [-92.75311481499995, 63.45572580000004],
      [-94.10568617999996, 59.953195132000076],
      [-91.53300885399995, 56.92325852100004],
      [-87.17134718499995, 56.92325852100004],
      [-81.70855798299993, 54.18825175300003],
      [-80.33893125199995, 52.047186863000036],
      [-77.63422359799995, 52.047186863000036],
      [-78.94794271899997, 54.173108522000064],
      [-77.07914930699997, 57.18538449000005],
      [-78.31119044699994, 58.93751354400007],
      [-77.33163502299999, 60.67822184600004],
      [-78.75259262399999, 62.53975030100008],
      [-73.71404748699996, 62.54183804500008],
      [-69.34384319699996, 60.36246471800007],
      [-69.905037, 59.483700182000064],
      [-66.88003329099996, 57.912073332000034],
      [-65.06087982199995, 60.58342055000003],
      [-63.053753222999944, 59.53059404000004],
      [-60.782936493999955, 55.45008903100006],
      [-58.21840306499996, 55.45008903100006],
      [-56.95970540199994, 52.768849071000034],
      [-59.109171351999976, 50.192558158000054],
      [-67.42325259599994, 50.19550376800004],
      [-69.03862779299993, 48.178115509000065],
      [-68.52137042199996, 47.870765651000056],
      [-67.49248087399997, 49.143139243000064],
      [-64.22942002699995, 49.143139243000064],
      [-63.730926214999954, 47.96223333800003],
      [-65.03111931599994, 47.96223333800003],
      [-64.44523915399998, 46.541901163000034],
      [-62.28086218399994, 45.221154528000056],
      [-64.09465079299997, 43.12081071800003],
      [-65.91380989899994, 44.24169166400003],
      [-64.96019597299994, 45.369073462000074],
      [-65.68957941899998, 45.81351281700006],
      [-67.09429509799998, 44.14122049200006],
      [-68.23033298699994, 46.85919350700004],
      [-70.16322838199994, 46.85919350700004],
      [-70.88816703399993, 45.96161224000008],
      [-71.53283833999996, 45.16553994000003],
      [-75.54361272199998, 45.16553994000003],
      [-76.35787345999995, 44.12498991100006],
      [-79.97560836099996, 44.12498991100006],
      [-81.38517425099997, 42.296673105000025],
      [-82.83748994099994, 45.31467656700005],
      [-86.82266537699996, 47.55878553900004],
      [-89.13996402599997, 47.55878553900004],
      [-91.45100532699996, 48.811287598000035],
      [-121.38140391999997, 48.811287598000035],
      [-123.37227822699998, 48.811287598000035],
      [-123.42258970899996, 48.876531732000046],
      [-126.73864326299997, 50.44156342100007],
      [-129.89934526999997, 53.68649159800003],
      [-129.73930947199995, 54.55464808600004],
      [-131.21220344299996, 55.89962720500006],
      [-132.81211977699996, 55.89962720500006],
      [-136.38358522699997, 58.88671590700005],
      [-137.82115760599999, 58.88671590700005],
      [-139.20128368999997, 59.94670579500007],
      [-140.23530617699998, 67.86879291500003],
      [-140.68808181599996, 69.42985604100005],
      [-139.37328210299995, 68.98103756300003],
      [-132.62590279499994, 68.98103756300003],
      [-132.77757551599996, 69.67851073300005],
      [-121.45702234299995, 69.67870613800005],
      [-118.79742793799994, 68.69498914200005],
      [-104.53337501299995, 68.69498914200005],
      [-102.97486867599997, 68.06950651300008],
      [-96.30181422799996, 68.07188791700008],
      [-96.15873787699996, 68.71194569700003],
      [-95.67941357999996, 71.70446720600006],
      [-92.60110182299996, 71.70446720600006]],
     [[-86.67452149899998, 74.18651014700004],
      [-86.94800525699998, 72.40312659900007],
      [-85.73708186899995, 72.40312659900007],
      [-85.48812264899999, 73.81847199000003],
      [-81.30349920299994, 73.81847199000003],
      [-81.67644175899994, 72.22294600500004],
      [-73.26495149899995, 72.24294629400003],
      [-73.57937311399996, 71.40713933900008],
      [-71.91594027099995, 71.40713933900008],
      [-71.04414101099997, 70.42311973300008],
      [-69.81169007299997, 70.42311973300008],
      [-69.10561158499996, 69.56902265200006],
      [-68.24145492399998, 69.56902265200006],
      [-68.42377649499997, 69.22270396400006],
      [-62.305654810999954, 66.23058777500006],
      [-63.40038781699997, 64.52799788300007],
      [-64.22244918899997, 65.74614555500006],
      [-65.79243157099995, 65.72755648800006],
      [-67.22932966599996, 66.43620151200008],
      [-67.85517930099996, 65.44910284100007],
      [-65.26711041599998, 64.16217181900004],
      [-64.58896516499993, 63.14299534400004],
      [-65.01517837899996, 62.49174919500007],
      [-68.33293488499999, 64.16217181900004],
      [-68.59731650499998, 63.724460399000066],
      [-65.86234568399993, 62.347440996000046],
      [-67.27320761999994, 62.347440996000046],
      [-70.69576316199993, 64.05261352200006],
      [-76.48551528499996, 64.05261352200006],
      [-79.30006412999995, 65.37481261000005],
      [-78.76670859399997, 65.37496919900008],
      [-74.64155641999997, 65.37618029800007],
      [-73.71262221399996, 67.20607082100008],
      [-75.47759904499998, 69.29956458200007],
      [-78.33203821899997, 70.57977630800008],
      [-87.90185262899996, 70.57977630700003],
      [-89.39130956599996, 71.92353149200005],
      [-89.09784798799996, 74.18651014700004],
      [-86.67452149899998, 74.18651014700004]],
     [[-70.30990563999995, 82.00751829400008],
      [-70.33458099299997, 80.56074154200007],
      [-75.28406531799999, 80.56074154200007],
      [-73.27344571399993, 78.96770922500008],
      [-76.29151187799994, 78.96770922500008],
      [-76.33007817399994, 77.54267924400006],
      [-79.10783983199997, 77.54267924400006],
      [-79.16985291999998, 76.36934554600003],
      [-85.29207793499995, 76.36934554600003],
      [-89.63329203499995, 76.36934554600003],
      [-91.16768655599998, 77.45487986000006],
      [-88.05417215599994, 77.45487986000006],
      [-89.46413598099997, 78.42877496600005],
      [-87.10598786499997, 78.42877496600005],
      [-87.35378233899996, 79.64936847900003],
      [-83.71274549599997, 79.64936847900003],
      [-83.88880239499997, 80.66092779500008],
      [-87.05448431199994, 80.66092779500008],
      [-90.72297866599996, 82.06106772700008],
      [-84.67262230199998, 82.06106772700008],
      [-84.81627004199999, 82.60442250600005],
      [-73.84017332299999, 82.60442250600005],
      [-73.91550329999995, 83.27653807300004],
      [-65.68514470499997, 83.27653807300004],
      [-65.73033246299997, 82.00751829400008],
      [-70.30990563999995, 82.00751829400008]],
     [[-107.25637155099997, 73.41133635300008],
      [-103.21780878199996, 70.41289320000004],
      [-103.38573542799998, 68.81955920900003],
      [-105.23241207399997, 69.55204963800003],
      [-106.22434580599997, 69.55204963800003],
      [-115.30955703199999, 69.55204963800003],
      [-118.94276025799996, 72.07217207000008],
      [-119.22036811299995, 73.20183919700008],
      [-118.85924465999994, 73.20183919700008],
      [-110.26853621899994, 73.20183919700008],
      [-108.47602408799997, 72.55171286700005],
      [-108.58172853299999, 73.41133635300008],
      [-107.25637155099997, 73.41133635300008]],
     [[-52.28664694799994, 47.73522696200007],
      [-53.51699017899995, 46.40995327400003],
      [-54.59183361999993, 47.08673568900008],
      [-58.641292635999946, 47.08673568900008],
      [-58.936950397999965, 47.88007256900005],
      [-55.58356780599996, 51.76259480400006],
      [-54.56799730599994, 49.153994391000026],
      [-52.28664694799994, 47.73522696200007]],
     [[-113.94758266199995, 77.06155924600006],
      [-111.19826178299996, 76.15482843200004],
      [-109.36758239299996, 76.15482843200004],
      [-109.69081349899994, 76.97454529700008],
      [-108.67956403299996, 76.97454529700008],
      [-105.02263725199998, 74.67990744200006],
      [-116.15211264599998, 74.67990744200006],
      [-118.15418790299998, 75.85591264600004],
      [-118.78571416199998, 77.06155924600006],
      [-113.94758266199995, 77.06155924600006]],
     [[-119.341232736, 74.63976805900006],
      [-117.43751702299994, 73.98723886800008],
      [-121.516121296, 73.99496962200004],
      [-121.04881978299994, 72.45907114600004],
      [-120.99054465599994, 72.23202244700008],
      [-119.98496178299996, 71.57555644400003],
      [-124.39847256499996, 71.57555644400003],
      [-126.49816091299999, 72.87067229600007],
      [-127.21948183699999, 74.64284045800008],
      [-119.341232736, 74.63976805900006]],
     [[-79.92254514199999, 63.29459003900007],
      [-86.59876596799995, 63.29459003900007],
      [-85.71748345599997, 65.42266375700007],
      [-83.24126856599997, 65.42266375700007],
      [-80.72303411299998, 64.26423738600005],
      [-79.92254514199999, 63.29459003900007]],
     [[-91.86287266199997, 76.84428770200003],
      [-90.08659958799996, 75.55861558800007],
      [-80.46472604199994, 75.55861558800007],
      [-80.56844276199996, 74.80687402700005],
      [-82.04273831199998, 74.80851110300006],
      [-90.69043564299994, 74.80851110300006],
      [-91.79630611099998, 75.64339395800005],
      [-94.76907285599998, 75.64339395800005],
      [-96.51637049899995, 76.84428770200003],
      [-91.86287266199997, 76.84428770200003]],
     [[-97.25135152599995, 71.80407367300006],
      [-99.34112640299998, 71.80407367300006],
      [-103.47713682899996, 73.37094873900008],
      [-103.10385622899997, 73.37094873900008],
      [-101.02415001299994, 73.37094873900008],
      [-101.08073121499996, 74.30957056600005],
      [-97.19191059899998, 74.30957056600005],
      [-97.18389055399996, 73.45213005500005],
      [-97.25135152599995, 71.80407367300006]],
     [[-101.15156170899996, 78.87749805000004],
      [-99.65835928099995, 77.98386726400008],
      [-102.17055761299997, 77.98386726400008],
      [-102.38518380099998, 78.51821121700004],
      [-105.95648457699997, 78.51821121700004],
      [-106.45271600099994, 79.46670684100008],
      [-102.94033384399995, 79.46670684100008],
      [-101.15156170899996, 78.87749805000004]],
     [[-98.06062944299998, 75.17871326600005],
      [-100.57574704499996, 75.17871326600005],
      [-102.59072701199995, 75.89851518000006],
      [-100.49080252899995, 75.89851518000006],
      [-100.74570535399994, 76.93109107300006],
      [-98.38772851599998, 76.93109107300006],
      [-98.06062944299998, 75.17871326600005]],
     [[-93.19733412099998, 72.56362467500003],
      [-95.41321503799998, 72.56362467500003],
      [-95.35668701699996, 74.02272671300005],
      [-91.75217093799995, 74.02272671300005],
      [-91.80221292599998, 73.33038898300003],
      [-93.13463369299996, 73.33038898300003],
      [-93.19733412099998, 72.56362467500003]],
     [[-94.03651094699995, 77.63062373200006],
      [-96.98850971999997, 77.63062373200006],
      [-99.23546017599995, 79.01287379200005],
      [-97.20250653499994, 79.01287379200005],
      [-94.99183322699997, 78.25035948900006],
      [-94.03651094699995, 77.63062373200006]],
     [[-130.53646504, 52.06975113100003],
      [-131.304927438, 52.06975113100003],
      [-133.586202099, 54.24818546700004],
      [-131.92220701499997, 54.24818546700004],
      [-132.06438860299994, 53.55969174000006],
      [-130.53646504, 52.06975113100003]],
     [[-124.58117174099999, 48.96959792000007],
      [-125.52072365699996, 48.96959792000007],
      [-127.52067449799995, 49.914660026000035],
      [-128.48054014599995, 50.96324751700007],
      [-124.82719696699996, 49.26417030200008],
      [-124.58117174099999, 48.96959792000007]],
     [[-75.26020375499996, 67.69717225400007],
      [-76.75299734899994, 67.69717225400007],
      [-78.02478478299997, 69.14589974000006],
      [-76.50725578899994, 69.14589974000006],
      [-75.26020375499996, 67.69717225400007]],
     [[-61.14075584699998, 46.26298642900008],
      [-61.81541043699997, 45.48501074500007],
      [-63.05774461899995, 46.24829287600005],
      [-62.39135670699994, 47.02783701700008],
      [-61.14075584699998, 46.26298642900008]],
     [[-111.59579865499995, 78.60780085700003],
      [-110.99159107, 77.47681614200008],
      [-113.00438697799996, 77.51470443600005],
      [-113.61487993399999, 78.60780085700003],
      [-111.59579865499995, 78.60780085700003]],
     [[-93.24103907299997, 74.51745803300008],
      [-96.20760361299995, 74.50310935000005],
      [-96.2352047, 75.12441826400004],
      [-93.23037259299997, 75.12441826400004],
      [-93.24103907299997, 74.51745803300008]],
     [[-97.18053091999997, 68.72447904500007],
      [-98.74108137999997, 68.72447904500007],
      [-98.5623275199999, 69.72331161500006],
      [-96.98367658199999, 69.72331161500006],
      [-97.18053091999997, 68.72447904500007]],
     [[-61.50288720299994, 49.08703424500004],
      [-63.31175629799998, 49.08703424500004],
      [-63.57815516699998, 49.70931821700003],
      [-61.76167483599994, 49.70931821700003],
      [-61.50288720299994, 49.08703424500004]],
     [[-82.48640801499994, 62.20328203000008],
      [-83.47259860299994, 62.20328203000008],
      [-84.29978448299994, 62.85317563500007],
      [-82.17275713499998, 62.85317563500007],
      [-82.48640801499994, 62.20328203000008]],
     [[-104.11101564499995, 77.01803465900008],
      [-105.60548561899998, 77.01803465900008],
      [-106.86713609199995, 77.76281411800005],
      [-105.35481194299996, 77.76281411800005],
      [-104.11101564499995, 77.01803465900008]],
     [[-78.83483625199995, 61.73579045500003],
      [-79.72285735399998, 61.73579045500003],
      [-80.20610870399997, 62.347440996000046],
      [-79.31256281099996, 62.347440996000046],
      [-78.83483625199995, 61.73579045500003]],
     [[-53.90898802099997, 49.80392953000006],
      [-53.807823001999964, 49.52612078100003],
      [-54.170966798999984, 49.52614618900003],
      [-54.272819915999946, 49.803959906000046],
      [-53.90898802099997, 49.80392953000006]],
     [[-78.92979654199996, 56.10492869300003],
      [-78.73723789799999, 55.817757107000034],
      [-79.11852752899995, 55.81778336000008],
      [-79.31202488999998, 56.10496010600008],
      [-78.92979654199996, 56.10492869300003]],
     [[-128.653957516, 51.900250699000026],
      [-128.38191615, 51.61981230300006],
      [-128.75056262199996, 51.61983799500007],
      [-129.02239077999997, 51.90080956600008],
      [-128.653957516, 51.900250699000026]],
     [[-130.08775477399996, 53.525232250000045],
      [-129.79444613799996, 53.24294393900004],
      [-130.16773328099998, 53.242969800000026],
      [-130.460912609, 53.52579480800006],
      [-130.08775477399996, 53.525232250000045]],
     [[-130.84302600599995, 54.26596275800006],
      [-130.53937679599994, 53.98282306400006],
      [-130.91489004599998, 53.98284900300007],
      [-131.21845047199997, 54.266527014000076],
      [-130.84302600599995, 54.26596275800006]]]},
   'id': 'CA'},
  {'type': 'Feature',
   'properties': {'id': 'SK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[22.62253873900005, 48.51616842000004],
      [20.72355009100005, 48.51616842000004],
      [19.995232659000067, 47.98857931200007],
      [17.827888362000067, 47.98893547000006],
      [16.73744743000003, 48.94311210800004],
      [17.545891981000068, 48.94275504700005],
      [18.816791907000038, 49.86104324300004],
      [21.479324791000067, 49.86104324300004],
      [22.834796077000078, 49.86104324300004],
      [22.62253873900005, 48.51616842000004]]]},
   'id': 'SK'},
  {'type': 'Feature',
   'properties': {'id': 'CZ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[18.816791907000038, 49.86104324300004],
      [17.545891981000068, 48.94275504700005],
      [16.73744743000003, 48.94311210800004],
      [13.646919927000056, 48.94447707200004],
      [12.662140456000031, 49.78443353200004],
      [14.071812014000045, 50.82318322700007],
      [17.727475292000065, 50.82318322700007],
      [18.816791907000038, 49.86104324300004]]]},
   'id': 'CZ'},
  {'type': 'Feature',
   'properties': {'id': 'MN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[102.24252655600009, 50.34182103400008],
      [108.51173645600005, 50.34182103400008],
      [108.88536256300006, 49.60485777300005],
      [112.10705166600007, 49.60485777300005],
      [113.70036681600004, 50.38289494800006],
      [117.17276665100007, 50.38289494800006],
      [116.76726626200002, 49.89081036600004],
      [115.27047978400003, 47.954667836000056],
      [117.25891271800003, 47.954667836000056],
      [117.693798291, 47.08156415800005],
      [108.10144061400007, 42.067722944000025],
      [96.51308064200003, 42.067722944000025],
      [94.79949945700008, 44.57593414100006],
      [89.95680457800006, 44.57593414100006],
      [91.33136132700008, 47.041003690000025],
      [87.60743088200007, 48.48357156800006],
      [88.06631598400008, 49.268133885000054],
      [88.32779875300008, 49.706958729000064],
      [89.97844813300009, 49.706958729000064],
      [90.56449726600005, 50.629480743000045],
      [94.79587645300006, 50.629480743000045],
      [95.36815369600004, 49.66611502000006],
      [97.97236145200009, 49.66611502000006],
      [99.38798382300007, 51.659561437000036],
      [101.55899795800008, 51.659561437000036],
      [102.24252655600009, 50.34182103400008]]]},
   'id': 'MN'},
  {'type': 'Feature',
   'properties': {'id': 'BE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[6.034358428000075, 50.59046881000006],
      [6.034295855000039, 50.58916825700004],
      [6.003329637000036, 49.77415045500004],
      [3.943693780000046, 49.77415045500004],
      [2.102038695000033, 51.25780884200003],
      [2.833373599000026, 51.82824492100008],
      [4.502984851000065, 51.82824492100008],
      [6.034358428000075, 50.59046881000006]]]},
   'id': 'BE'},
  {'type': 'Feature',
   'properties': {'id': 'UA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[36.59210374500003, 50.27096080900003],
      [40.35814697300003, 50.25801270300008],
      [39.79814206400005, 48.18557788500004],
      [37.65685433800007, 46.758075846000054],
      [35.24558528600005, 46.758075846000054],
      [34.917866840000045, 45.24131169800006],
      [35.85774175100005, 45.24131169800006],
      [34.03234462900008, 43.98393507000003],
      [32.49407874100007, 45.46212956000005],
      [33.913398818000076, 46.441582984000036],
      [30.481182654000065, 46.441582984000036],
      [28.675484078000068, 45.17484434600004],
      [28.363648169000044, 45.46907608300006],
      [28.68693048600005, 45.46907608300006],
      [28.83585765500004, 46.31234555300006],
      [29.74884226900008, 46.31234555300006],
      [27.54129053400004, 48.37883248600008],
      [26.402205767000055, 47.581960422000066],
      [25.929994342000043, 48.017004446000044],
      [23.17443935600005, 48.017004446000044],
      [22.62253873900005, 48.51616842000004],
      [22.834796077000078, 49.86104324300004],
      [23.76720423300003, 50.51474941500004],
      [23.934965024000064, 51.45589959300003],
      [30.89310057800003, 51.45589959300003],
      [31.84530638600006, 52.09307307800003],
      [34.75659174200007, 52.09307307800003],
      [36.59210374500003, 50.27096080900003]]]},
   'id': 'UA'},
  {'type': 'Feature',
   'properties': {'id': 'NL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[6.705980723000039, 51.78109113800008],
      [6.091263745000049, 51.78349124700003],
      [6.034358428000075, 50.59046881000006],
      [4.502984851000065, 51.82824492100008],
      [4.549124325000037, 53.14874125500006],
      [6.774766075000059, 53.14874125500006],
      [6.705980723000039, 51.78109113800008]]]},
   'id': 'NL'},
  {'type': 'Feature',
   'properties': {'id': 'PL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[19.21575602000007, 54.31978912300008],
      [22.921698396000068, 54.31978912300008],
      [24.47418777000007, 54.31978912300008],
      [23.934965024000064, 51.45589959300003],
      [23.76720423300003, 50.51474941500004],
      [22.834796077000078, 49.86104324300004],
      [21.479324791000067, 49.86104324300004],
      [18.816791907000038, 49.86104324300004],
      [17.727475292000065, 50.82318322700007],
      [14.071812014000045, 50.82318322700007],
      [14.458127296000043, 54.31978912400007],
      [19.21575602000007, 54.31978912300008]]]},
   'id': 'PL'},
  {'type': 'Feature',
   'properties': {'id': 'IE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-8.093132217999937, 54.03514117800006],
      [-5.888243589999945, 54.03534404100003],
      [-5.816204144999972, 52.42436758400004],
      [-6.91215654399997, 51.526199947000066],
      [-11.142118961999927, 51.526199947000066],
      [-10.011899514999982, 52.47730264000006],
      [-10.17948901699998, 54.55068952700003],
      [-8.788717234999979, 54.55068952700003],
      [-8.093132217999937, 54.03514117800006]]]},
   'id': 'IE'},
  {'type': 'Feature',
   'properties': {'id': 'GB'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-3.238845484999956, 59.12475077200003],
      [-3.205824319999977, 58.00834831800006],
      [-2.10180842799997, 58.00834831800006],
      [-2.06534791699994, 56.20224640500004],
      [-0.140623782999967, 54.71143494700004],
      [-0.138618645999941, 52.93707219100003],
      [1.234157931000027, 52.93707219100003],
      [1.220978191000029, 51.498754226000074],
      [0.343742678000069, 50.80649489100006],
      [-2.513005727999939, 50.80649489100006],
      [-3.122035195999956, 50.31618313100006],
      [-5.527371267999968, 50.31618313100006],
      [-5.559009956999944, 51.10465620400004],
      [-3.139905733999967, 51.10465620400004],
      [-3.150542780999956, 51.56136093200007],
      [-4.197176473999946, 51.56136093200007],
      [-4.251063864999935, 53.219587689000036],
      [-3.236101901999973, 53.21958768800005],
      [-3.292767441999956, 55.33620305800008],
      [-4.830394191999972, 55.33620305800008],
      [-4.953859114999943, 58.22675132900008],
      [-4.994828649999931, 59.121334036000064],
      [-3.238845484999956, 59.12475077200003]],
     [[-5.888243589999945, 54.03534404100003],
      [-8.093132217999937, 54.03514117800006],
      [-8.788717234999979, 54.55068952700003],
      [-8.847912540999971, 55.35412677700003],
      [-5.955821833999948, 55.35412677700003],
      [-5.888243589999945, 54.03534404100003]]]},
   'id': 'GB'},
  {'type': 'Feature',
   'properties': {'id': 'LT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[26.827961980000055, 54.31978912300008],
      [24.47418777000007, 54.31978912300008],
      [22.921698396000068, 54.31978912300008],
      [23.102276611000036, 55.26160763200005],
      [20.57889983900003, 55.26160763200005],
      [21.384579685000062, 55.81442972100007],
      [21.45005666900005, 56.17070381000008],
      [27.23985323100004, 56.17070381000008],
      [26.827961980000055, 54.31978912300008]]]},
   'id': 'LT'},
  {'type': 'Feature',
   'properties': {'id': 'BY'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[30.595377176000056, 54.398057848000064],
      [32.06121881200005, 52.96707802700007],
      [31.84530638600006, 52.09307307800003],
      [30.89310057800003, 51.45589959300003],
      [23.934965024000064, 51.45589959300003],
      [24.47418777000007, 54.31978912300008],
      [26.827961980000055, 54.31978912300008],
      [27.23985323100004, 56.17070381000008],
      [31.054729226000063, 56.17070381000008],
      [30.595377176000056, 54.398057848000064]]]},
   'id': 'BY'},
  {'type': 'Feature',
   'properties': {'id': 'DK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[9.232634145000077, 54.750576746000036],
      [9.468533157000024, 54.55466894800003],
      [7.964715771000044, 54.554670301000044],
      [8.031568074000063, 55.57730061900003],
      [10.359422284000061, 57.28360844800005],
      [11.448822321000023, 56.36893614000007],
      [9.232634145000077, 54.750576746000036]],
     [[11.275722674000065, 54.62646803500007],
      [10.496815186000049, 54.62646803500007],
      [10.569054997000023, 55.446515359000045],
      [11.35332298000003, 55.446515359000045],
      [11.275722674000065, 54.62646803500007]]]},
   'id': 'DK'},
  {'type': 'Feature',
   'properties': {'id': 'LV'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[27.23985323100004, 56.17070381000008],
      [21.45005666900005, 56.17070381000008],
      [21.598053711000034, 56.96493685400003],
      [22.72337771800005, 57.72270262100005],
      [23.67317621600006, 56.84557968100006],
      [23.909782758000063, 57.96266039900007],
      [27.68106943300006, 57.96293586300004],
      [27.23985323100004, 56.17070381000008]]]},
   'id': 'LV'},
  {'type': 'Feature',
   'properties': {'id': 'EE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[27.68106943300006, 57.96293586300004],
      [23.909782758000063, 57.96266039900007],
      [23.98760922100007, 58.323198509000065],
      [22.79522464100006, 58.323198509000065],
      [24.810231978000047, 59.65141374600006],
      [28.116871097000057, 59.65141374600006],
      [27.68106943300006, 57.96293586300004]]]},
   'id': 'EE'},
  {'type': 'Feature',
   'properties': {'id': 'IS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-21.34912542799998, 65.59593347700007],
      [-20.42788687199993, 65.59424180700006],
      [-20.554819850999934, 66.17140319300006],
      [-14.399678987999948, 66.17140319400005],
      [-14.222291279999979, 65.00923323100005],
      [-15.498362770999961, 63.898551017000045],
      [-17.418366980999963, 63.898551017000045],
      [-18.56204834199997, 62.873696875000064],
      [-20.833120492999967, 63.68030886400004],
      [-22.52777943999996, 63.68030886400004],
      [-22.928130989999943, 65.36659994400003],
      [-24.39044066499997, 65.36659994400003],
      [-24.472523105999983, 65.68205884900004],
      [-23.555099393999967, 66.55435080800004],
      [-21.570796580999968, 66.55435080800004],
      [-21.34912542799998, 65.59593347700007]]]},
   'id': 'IS'},
  {'type': 'Feature',
   'properties': {'id': 'SE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[20.27538433500007, 68.99126403500003],
      [20.190752518000068, 68.62599923200008],
      [21.534758969000052, 68.62599923000005],
      [23.682832408000024, 66.60346026800005],
      [23.447265265000055, 65.67727217800007],
      [21.124091554000074, 65.67727217800007],
      [20.896822906000068, 64.65494958700003],
      [18.26911820500004, 62.91596997600004],
      [17.937981425000032, 61.06201280300007],
      [19.043441640000026, 60.07638189200003],
      [16.77866880700003, 58.53050169100004],
      [16.45206853700006, 56.290296202000036],
      [14.243055563000041, 56.30283464100006],
      [14.073728967000022, 54.88780457900003],
      [12.773862020000024, 54.88780457900003],
      [12.96459887800006, 56.633583298000076],
      [10.558706960000052, 58.66437298400007],
      [11.97086373600007, 59.67161437900006],
      [12.464033070000028, 63.78271992900005],
      [13.830510286000049, 63.78271992900005],
      [14.10810695400005, 65.67727217800007],
      [16.808676129000048, 67.50162867600005],
      [16.924793489000024, 68.11673909300004],
      [18.11789476900003, 68.11673909300004],
      [18.29905053600004, 68.99126999800006],
      [20.27538433500007, 68.99126403500003]]]},
   'id': 'SE'},
  {'type': 'Feature',
   'properties': {'id': 'GL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-22.263144281999928, 84.49965555800009],
      [-23.414661769999952, 82.85561924900009],
      [-22.57141920199996, 82.28500078000008],
      [-21.168448053999953, 84.19607666900004],
      [-19.351873525999963, 82.91571697700005],
      [-20.941167045999975, 80.96184904500006],
      [-19.948949483999968, 80.31076951800003],
      [-18.978432513999962, 81.43345221000004],
      [-15.606314302999976, 81.43345221000004],
      [-15.351169096999968, 80.42428088100007],
      [-17.71395505199996, 80.42428088100007],
      [-18.696693452999966, 79.38084587600008],
      [-17.91297242899998, 76.77114960400007],
      [-21.590961340999968, 76.77114960400007],
      [-20.79957352699995, 74.22679217800004],
      [-22.105308028999957, 72.95303780600005],
      [-23.30796613399997, 73.69617685100008],
      [-24.739540612999974, 73.69617685100008],
      [-25.67702548699998, 72.73758006900005],
      [-22.005244652999977, 70.46426273400004],
      [-22.711487551999937, 70.46426273400004],
      [-23.91334190699996, 71.21504000700008],
      [-27.081473048999953, 71.21504000700008],
      [-26.676649048999934, 69.98738861000004],
      [-22.59037333799995, 69.97530959500006],
      [-24.219226929999934, 68.42080124300003],
      [-31.451486407999937, 68.43270222300004],
      [-33.187165092999976, 66.61398096300007],
      [-37.16730918099995, 66.61398096300007],
      [-43.359820335999984, 59.72192572700004],
      [-45.16013006899993, 59.71351319000007],
      [-46.23748269199996, 60.33552280500004],
      [-47.29336391299995, 60.33552280500004],
      [-50.465647187999934, 62.119855905000065],
      [-53.858397346999936, 68.28727168600005],
      [-53.44295818099994, 68.87066213600008],
      [-51.32469839199996, 68.87040961300005],
      [-52.08704687799997, 70.13606773900005],
      [-53.67061109399998, 70.94397178700007],
      [-53.37941003099996, 71.39625051600007],
      [-52.133409538999956, 70.76375418400005],
      [-52.808755179999935, 71.79025520700003],
      [-54.40436990799998, 71.79025520700003],
      [-54.71756627599996, 71.35091032500003],
      [-55.47837655999996, 71.72951523700004],
      [-54.83728605699997, 72.85381735400006],
      [-56.376701400999934, 74.88721493300005],
      [-59.30001180299996, 76.24455060200006],
      [-68.25113452199997, 76.24455060200006],
      [-69.31006779999996, 77.23617392700004],
      [-67.93148935699998, 77.23617392700004],
      [-68.63044338799995, 77.87381867200008],
      [-70.28434918699998, 77.87381867200008],
      [-71.86898043099995, 79.20737389600004],
      [-65.81628337499995, 79.20737389600004],
      [-65.62519510899995, 80.63390398300004],
      [-60.38708731899993, 80.61601435500006],
      [-60.15518642699993, 81.87515094700007],
      [-55.874376810999934, 81.87515094700007],
      [-47.871366749999936, 81.87515094700007],
      [-47.255710041999976, 83.74066581300008],
      [-24.713648965999937, 83.72655660900006],
      [-23.605886589999955, 85.48503935200006],
      [-22.263144281999928, 84.49965555800009]],
     [[-52.43956436299993, 69.25116809000008],
      [-53.01971338299995, 69.25116809000008],
      [-54.16264316699994, 69.83972780800008],
      [-54.41250813399995, 70.22544689000006],
      [-53.04324364299998, 70.22544689000006],
      [-52.43956436299993, 69.25116809000008]]]},
   'id': 'GL'},
  {'type': 'Feature',
   'properties': {'id': 'FI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[28.181588867000073, 68.27430917300006],
      [27.984472466000057, 67.64925724500006],
      [29.971691811000028, 65.66525544300004],
      [29.313017222000042, 63.541016712000044],
      [31.27200649200006, 63.541016712000044],
      [30.791105998000035, 61.99797712900005],
      [28.357460770000046, 60.44943256300007],
      [25.324977627000067, 60.44943256300007],
      [24.33859310500003, 59.80634385600007],
      [22.542673577000073, 59.80634385600007],
      [21.099384609000026, 61.130242],
      [21.393068409000023, 62.53630957200005],
      [24.83109704000003, 64.75999034700004],
      [25.07348686000006, 65.67727217800007],
      [23.447265265000055, 65.67727217800007],
      [23.682832408000024, 66.60346026800005],
      [21.534758969000052, 68.62599923000005],
      [20.190752518000068, 68.62599923200008],
      [20.27538433500007, 68.99126403500003],
      [20.318076569000027, 69.17438313900004],
      [22.540011011000047, 69.17438313900004],
      [23.501481994000073, 68.26199147500006],
      [26.68908926200004, 70.24430126300007],
      [28.841282678000027, 70.24430126300007],
      [28.181588867000073, 68.27430917300006]]]},
   'id': 'FI'},
  {'type': 'Feature',
   'properties': {'id': 'NO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[31.13963281100007, 70.05638835000008],
      [28.181588867000073, 68.27430917300006],
      [28.841282678000027, 70.24430126300007],
      [26.68908926200004, 70.24430126300007],
      [23.501481994000073, 68.26199147500006],
      [22.540011011000047, 69.17438313900004],
      [20.318076569000027, 69.17438313900004],
      [20.27538433500007, 68.99126403500003],
      [18.29905053600004, 68.99126999800006],
      [18.11789476900003, 68.11673909300004],
      [16.924793489000024, 68.11673909300004],
      [16.808676129000048, 67.50162867600005],
      [14.10810695400005, 65.67727217800007],
      [13.830510286000049, 63.78271992900005],
      [12.464033070000028, 63.78271992900005],
      [11.97086373600007, 59.67161437900006],
      [10.558706960000052, 58.66437298400007],
      [9.47526775600005, 58.66437298400007],
      [8.23736877400006, 57.76267337200005],
      [6.174143614000059, 57.76267337200005],
      [4.677818886000068, 58.965949772000045],
      [4.803690169000049, 61.79122429800003],
      [7.400139517000071, 63.67842264600006],
      [8.492151405000072, 63.67842264600006],
      [14.283707408000055, 67.71831958400003],
      [15.213248278000037, 67.73639712300007],
      [18.007020443000044, 70.13256700600004],
      [20.88901391400003, 70.13256700600004],
      [22.72616619000007, 71.29449478600003],
      [28.67232858600005, 71.29449478600003],
      [31.13963281100007, 70.05638835000008]]]},
   'id': 'NO'},
  {'type': 'Feature',
   'properties': {'id': 'QG'}, // territory with Egypt
   'geometry': {'type': 'Polygon',
    'coordinates': [[[33.22915268500003, 21.77351397600006],
      [34.08820519500006, 21.773535855000034],
      [34.03209388700003, 21.564382333000026],
      [33.65787875700005, 21.46895494300003],
      [33.22915268500003, 21.77351397600006]]]},
   'id': 'QG'},
  {'type': 'Feature',
   'properties': {'id': 'KU'}, // Kunashir
   'geometry': {'type': 'Polygon',
    'coordinates': [[[148.8405956030001, 45.21668488700004],
      [148.4427392770001, 45.02885275400007],
      [147.13708871200004, 44.41378276800003],
      [146.98358775000008, 44.86133665500006],
      [148.6678477170001, 45.64074104100007],
      [148.67993068600003, 45.61084565400006],
      [148.8405956030001, 45.21668488700004]]]},
   'id': 'KU'},
  {'type': 'Feature',
   'properties': {'id': 'QQ'}, // triangle territory with N Sudan
   'geometry': {'type': 'Polygon',
    'coordinates': [[[34.08820519500006, 21.773535855000034],
      [36.62559441600007, 22.97025227900008],
      [37.11436048000007, 22.523524473000066],
      [37.06164721400006, 21.77361158800005],
      [34.08820519500006, 21.773535855000034]]]},
   'id': 'QQ'},
  {'type': 'Feature',
   'properties': {'id': 'LU'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[7.033147564000046, 49.77415045500004],
      [6.003329637000036, 49.77415045500004],
      [6.034295855000039, 50.58916825700004],
      [6.034358428000075, 50.59046881000006],
      [7.033147564000046, 49.77415045500004]]]},
   'id': 'LU'},
  {'type': 'Feature',
   'properties': {'id': 'DE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[9.468533157000024, 54.55466894800003],
      [9.750578872000062, 54.31978912400007],
      [14.458127296000043, 54.31978912400007],
      [14.071812014000045, 50.82318322700007],
      [12.662140456000031, 49.78443353200004],
      [13.646919927000056, 48.94447707200004],
      [12.729000708000058, 48.25402500800004],
      [12.688806421000038, 47.76766974000003],
      [9.674599981000028, 47.76766974000003],
      [9.658467926000071, 47.52792583300004],
      [7.149251281000033, 47.53095406700004],
      [7.255425241000069, 49.77415045500004],
      [7.033147564000046, 49.77415045500004],
      [6.034358428000075, 50.59046881000006],
      [6.091263745000049, 51.78349124700003],
      [6.705980723000039, 51.78109113800008],
      [6.774766075000059, 53.14874125500006],
      [7.872952529000031, 53.14874125500006],
      [7.964715771000044, 54.554670301000044],
      [9.468533157000024, 54.55466894800003]]]},
   'id': 'DE'},
  {'type': 'Feature',
   'properties': {'id': 'AD'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[1.310257963000026, 42.80579196900004],
      [0.795039554000027, 42.80579196900004],
      [0.795983767000052, 43.01488353700006],
      [0.796768252000049, 43.187130205000074],
      [0.797768667000071, 43.187130205000074],
      [1.313106928000025, 43.187130205000074],
      [1.311814065000021, 43.01488353700006],
      [1.310257963000026, 42.80579196900004]]]},
   'id': 'AD'},
  {'type': 'Feature',
   'properties': {'id': 'EG'}, // Egypt
   'geometry': {'type': 'Polygon',
    'coordinates': [[[33.703737010000054, 31.09450617600004],
      [34.91836188800005, 28.805597211000077],
      [34.91898299300004, 28.80442953200003],
      [34.920045266000045, 28.804429595000045],
      [34.918059767000045, 28.80287345200003],
      [34.16362067500006, 28.210053281000057],
      [32.712536698000065, 29.45948519800004],
      [32.09786395500004, 28.976554442000065],
      [34.91835002300007, 26.781029834000037],
      [34.75667549000008, 24.67374101100006],
      [36.62559441600007, 22.97025227900008],
      [34.08820519500006, 21.773535855000034],
      [33.22915268500003, 21.77351397600006],
      [24.87893627400007, 21.773301297000046],
      [25.485203096000077, 31.495061874000044],
      [27.590885024000045, 31.495061874000044],
      [28.293059738000068, 30.880638687000044],
      [29.203561179000076, 30.878119166000033],
      [30.012181561000034, 31.495061874000044],
      [33.49175178200005, 31.495061874000044],
      [33.703737010000054, 31.09450617600004]]]},
   'id': 'EG'},
  {'type': 'Feature',
   'properties': {'id': 'MO'},  // Macao
   'geometry': {'type': 'Polygon',
    'coordinates': [[[113.98770741800001, 21.969726454000067],
      [113.70214798500001, 21.811577922000026],
      [113.53351479500009, 21.98743520000005],
      [113.81920890300012, 22.145654523000076],
      [113.98770741800001, 21.969726454000067]]]},
   'id': 'MO'},
  {'type': 'Feature',
   'properties': {'id': 'HK'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[114.64016023900001, 22.330414878000056],
      [114.34067666800001, 22.164967534000027],
      [114.172280397, 22.34092620000007],
      [114.17227502300011, 22.34093181700007],
      [114.47201346700001, 22.50649425200004],
      [114.64016023900001, 22.330414878000056]]]},
   'id': 'HK'},
  {'type': 'Feature',
   'properties': {'id': 'FR'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[2.102038695000033, 51.25780884200003],
      [3.943693780000046, 49.77415045500004],
      [6.003329637000036, 49.77415045500004],
      [7.033147564000046, 49.77415045500004],
      [7.255425241000069, 49.77415045500004],
      [7.149251281000033, 47.53095406700004],
      [6.328348624000057, 46.89629093600007],
      [6.293647583000052, 46.01450713400004],
      [6.820646608000061, 46.424095271000056],
      [7.044637422000051, 46.23799328200005],
      [6.948984716000041, 43.96529024600005],
      [6.948942036000062, 43.96427878800006],
      [6.948941836000074, 43.964274085000056],
      [6.426792555000077, 43.96528467400003],
      [6.411437904000024, 43.55722637200006],
      [6.411425633000022, 43.55722637200006],
      [5.732675620000066, 43.55722637200006],
      [3.196025810000037, 43.55722637200006],
      [3.187025795000068, 43.01477678400005],
      [1.311814065000021, 43.01488353700006],
      [1.313106928000025, 43.187130205000074],
      [0.797768667000071, 43.187130205000074],
      [0.795983767000052, 43.01488353700006],
      [-0.872878963999938, 43.01488353700006],
      [-1.643007896999961, 43.632506284000044],
      [-1.675035331999936, 46.80873924200006],
      [-2.902919145999931, 47.77898401500005],
      [-4.74049905499993, 47.75993566300008],
      [-4.776222807999943, 48.904541616000074],
      [-1.746024935999969, 48.904541616000074],
      [-1.758708199999944, 49.97598710400007],
      [-0.78975281299995, 49.97598710400007],
      [-0.159390796999958, 49.47815071900004],
      [2.102038695000033, 51.25780884200003]],
     [[9.41752566100007, 41.68222852100007],
      [8.567099763000044, 41.68222852100007],
      [8.598356864000039, 42.34687682800006],
      [9.488897043000065, 43.041191894000065],
      [9.41752566100007, 41.68222852100007]]]},
   'id': 'FR'},
  {'type': 'Feature',
   'properties': {'id': 'MC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[6.93142431900003, 43.557512046000056],
      [6.411437904000024, 43.55722637200006],
      [6.426792555000077, 43.96528467400003],
      [6.948942036000062, 43.96427878800006],
      [6.948941836000074, 43.964274085000056],
      [6.93142431900003, 43.557512046000056]]]},
   'id': 'MC'},
  {'type': 'Feature',
   'properties': {'id': 'SG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[104.13848804700007, 0.278827343000046],
      [104.14126096300004, 0.743784695000045],
      [104.71777322800006, 0.743784695000045],
      [104.71498496100008, 0.278827343000046],
      [104.13848804700007, 0.278827343000046]]]},
   'id': 'SG'},
  {'type': 'Feature',
   'properties': {'id': 'LA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[103.12445356800004, 22.367561701000056],
      [104.72196921000005, 20.714240490000066],
      [104.57376612500008, 19.909922064000057],
      [104.05882508700006, 19.909922064000057],
      [103.96686596700005, 19.418394136000074],
      [107.26887668600006, 16.044725179000068],
      [107.05727955700007, 14.592483575000074],
      [104.86127582000006, 14.592483575000074],
      [105.15100737500006, 16.580937463000055],
      [103.98446303500003, 17.765072925000027],
      [101.18626538300003, 17.77554368600005],
      [101.49583359700006, 19.552447207000057],
      [100.53903637200006, 20.535503062000032],
      [100.64711996100004, 21.138741882000033],
      [102.01468438400008, 21.138741882000033],
      [102.39260127500006, 23.12719577200005],
      [103.12445356800004, 22.367561701000056]]]},
   'id': 'LA'},
  {'type': 'Feature',
   'properties': {'id': 'VN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[106.92487216100005, 23.12719577100006],
      [106.70424771100005, 22.032429023000077],
      [108.28080811100006, 22.032429023000077],
      [108.10421652600007, 21.138741882000033],
      [107.51074517300003, 21.138741882000033],
      [106.39984301200008, 20.31208127600007],
      [106.07858694300006, 18.591733530000056],
      [109.66142467500003, 14.949958431000027],
      [109.20899709600008, 11.34208588000007],
      [108.30984020800008, 10.727304392000065],
      [104.89123444200004, 8.357593219000023],
      [104.69378575800005, 8.219397155000024],
      [104.85417773500006, 10.144949799000074],
      [108.32290007100005, 12.514660972000058],
      [108.58937518600004, 14.592483575000074],
      [107.05727955700007, 14.592483575000074],
      [107.26887668600006, 16.044725179000068],
      [103.96686596700005, 19.418394136000074],
      [104.05882508700006, 19.909922064000057],
      [104.57376612500008, 19.909922064000057],
      [104.72196921000005, 20.714240490000066],
      [103.12445356800004, 22.367561701000056],
      [102.39260127500006, 23.12719577200005],
      [106.92487216100005, 23.12719577100006]]]},
   'id': 'VN'},
  {'type': 'Feature',
   'properties': {'id': 'AE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[56.175070996000045, 26.37363863400003],
      [56.09390844900008, 25.779896585000074],
      [56.09390859600006, 25.779896585000074],
      [56.483746659000076, 25.780740955000056],
      [56.48374643300008, 25.780739349000044],
      [56.48362554900007, 25.779878979000046],
      [56.373968234000074, 24.980152644000043],
      [55.08819597000007, 24.135455482000054],
      [54.93016639200005, 22.651826003000053],
      [53.93684321200004, 22.772025040000074],
      [52.58337290600008, 22.935723003000078],
      [52.58335223100005, 22.935747761000073],
      [51.62480774100004, 24.08291849400007],
      [51.59145208700005, 24.122811952000063],
      [51.591452135000054, 24.122818779000056],
      [51.59238075800005, 24.25337661700007],
      [51.592380942000034, 24.253401848000067],
      [51.56417093400006, 24.551518901000065],
      [54.69685773300006, 24.55225548900006],
      [55.98997862700003, 26.37404963700004],
      [56.17507102400003, 26.37363883100005],
      [56.175070996000045, 26.37363863400003]]]},
   'id': 'AE'},
  {'type': 'Feature',
   'properties': {'id': 'DO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-70.34032710699995, 20.01433764500007],
      [-68.69877879499995, 18.72605056200007],
      [-68.62927840699996, 18.121382492000066],
      [-71.48312597599994, 18.119781330000023],
      [-71.75085025099997, 20.014690263000034],
      [-70.34032710699995, 20.01433764500007]]]},
   'id': 'DO'},
  {'type': 'Feature',
   'properties': {'id': 'AS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-170.57153167999996, -14.154144913999971],
      [-170.51001050699998, -14.42368032099995],
      [-170.82915675999996, -14.423655660999941],
      [-170.890571506, -14.154115452999974],
      [-170.57153167999996, -14.154144913999971]],
     [[-170.94387357599996, -10.931382293999945],
      [-170.89638691499997, -11.20091770099998],
      [-171.21438629799997, -11.200893040999972],
      [-171.26179148699998, -10.931352832999949],
      [-170.94387357599996, -10.931382293999945]],
     [[-169.40199775199997, -14.062184866999928],
      [-169.34048537099997, -14.331720273999963],
      [-169.65959474, -14.331695613999955],
      [-169.72100142099998, -14.062155405999931],
      [-169.40199775199997, -14.062184866999928]]]},
   'id': 'AS'},
  {'type': 'Feature',
   'properties': {'id': 'KN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-62.90380144299996, 17.42602428400005],
      [-62.79063741199997, 17.42602428400005],
      [-62.50668309499997, 17.42602428400005],
      [-62.46634384799995, 17.07336100400005],
      [-62.863244263999945, 17.07336100400005],
      [-62.894645784999966, 17.347120501000063],
      [-62.90380144299996, 17.42602428400005]]]},
   'id': 'KN'},
  {'type': 'Feature',
   'properties': {'id': 'MF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-62.97197948799999, 18.055749840000033],
      [-63.21046065499996, 18.055749840000033],
      [-63.210460685999976, 18.055750095000064],
      [-63.21987059299994, 18.133018761000073],
      [-62.979829292999966, 18.133018761000073],
      [-62.91714040699998, 18.133018761000073],
      [-62.90776884999997, 18.055749840000033],
      [-62.90779462399996, 18.055749840000033],
      [-62.97197948799999, 18.055749840000033]]]},
   'id': 'MF'},
  {'type': 'Feature',
   'properties': {'id': 'SX'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-62.89844661899997, 17.978513941000074],
      [-63.201100243999974, 17.978513941000074],
      [-63.20809233699998, 18.036243469000055],
      [-63.21046065499996, 18.055749840000033],
      [-63.210460685999976, 18.055750095000064],
      [-62.971979492999935, 18.055749895000076],
      [-62.90779462399996, 18.055749840000033],
      [-62.89844661899997, 17.978513941000074]]]},
   'id': 'SX'},
  {'type': 'Feature',
   'properties': {'id': 'SJ'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[27.757282111000052, 80.77468327500003],
      [29.708921058000044, 78.77386141800008],
      [24.397878554000044, 78.78302147000005],
      [24.089716227000054, 77.32983732400004],
      [17.211550233000025, 77.36413489900008],
      [17.029710007000062, 76.04831112200003],
      [9.559703584000033, 79.95742907400006],
      [17.69641093100006, 79.94573968500004],
      [17.78767631000005, 80.81852896500004],
      [27.757282111000052, 80.77468327500003]],
     [[33.340216661000056, 80.04679978000007],
      [31.545864091000055, 80.04679978000007],
      [31.666922966000072, 80.40776578800006],
      [33.47184809200007, 80.40776578800006],
      [33.340216661000056, 80.04679978000007]],
     [[25.525946928000053, 76.49726615400004],
      [24.935412244000076, 76.49726615400004],
      [24.990444337000042, 76.75233891200008],
      [25.58331109200003, 76.75233891200008],
      [25.525946928000053, 76.49726615400004]],
     [[19.255844010000033, 74.35732022800005],
      [18.79357454500007, 74.35732022800005],
      [18.815810077000037, 74.56253211300003],
      [19.279398425000068, 74.56253211300003],
      [19.255844010000033, 74.35732022800005]]]},
   'id': 'SJ'},
  {'type': 'Feature',
   'properties': {'id': 'VA'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[12.197797034000075, 41.70767525200006],
      [12.15877888500006, 41.70767525200006],
      [12.158991332000028, 41.74152279100008],
      [12.161398477000034, 42.121435673000065],
      [12.701258170000074, 42.121435673000065],
      [12.701246254000068, 42.12016280300003],
      [12.697420897000029, 41.70767525200006],
      [12.19828540800006, 41.70767525200006],
      [12.197797034000075, 41.70767525200006]]]},
   'id': 'VA'},
  {'type': 'Feature',
   'properties': {'id': 'SM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[12.771083015000045, 43.71540959500004],
      [12.22631444600006, 43.71540959500004],
      [12.229323188000023, 44.13052880200007],
      [12.733352986000057, 44.13052880200007],
      [12.77542833800004, 44.13052880200007],
      [12.775050566000061, 44.09473925800006],
      [12.771083015000045, 43.71540959500004]]]},
   'id': 'SM'},
  {'type': 'Feature',
   'properties': {'id': 'TL'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[125.53611333600008, -8.862006022999935],
      [125.00351069800001, -9.373410384999943],
      [124.78736939100008, -9.179722048999963],
      [124.78736851700012, -9.179722780999953],
      [124.29669283900012, -9.590499473999955],
      [124.29668967700002, -9.590502123999954],
      [123.97057892100008, -9.388156992999939],
      [123.97057887100004, -9.388156960999936],
      [125.1736392140001, -8.23622254999998],
      [127.1885382690001, -8.235316481999973],
      [127.24408404100006, -8.862006022999935],
      [125.53611333600008, -8.862006022999935]]]},
   'id': 'TL'},
  {'type': 'Feature',
   'properties': {'id': 'WF'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-177.86976198799996, -14.441003741999964],
      [-178.22067330199997, -14.441003741999964],
      [-178.28085197599998, -14.159005018999949],
      [-177.93006431599997, -14.159005018999949],
      [-177.86976198799996, -14.441003741999964]],
     [[-176.02168614099998, -13.41452034699995],
      [-176.37215965199997, -13.41452034699995],
      [-176.42848378999997, -13.132521623999935],
      [-176.07812462999996, -13.132521623999935],
      [-176.02168614099998, -13.41452034699995]]]},
   'id': 'WF'},
  {'type': 'Feature',
   'properties': {'id': 'MT'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[14.169207250000056, 36.097033031000024],
      [14.619354658000077, 36.097033031000024],
      [14.614002730000038, 35.74789155000008],
      [14.164520953000022, 35.74789155000008],
      [14.169207250000056, 36.097033031000024]]]},
   'id': 'MT'},
  {'type': 'Feature',
   'properties': {'id': 'CC'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[96.76014269300003, -12.04544422899994],
      [96.95204650500006, -12.04544422899994],
      [96.96881856400006, -12.230361304999974],
      [96.77687730600007, -12.230361304999974],
      [96.76014269300003, -12.04544422899994]]]},
   'id': 'CC'},
  {'type': 'Feature',
   'properties': {'id': 'CX'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[105.46293324700008, -10.290137898999944],
      [105.78222978500008, -10.290137898999944],
      [105.81054570000003, -10.620346961999928],
      [105.49115377300006, -10.620346961999928],
      [105.46293324700008, -10.290137898999944]]]},
   'id': 'CX'},
  {'type': 'Feature',
   'properties': {'id': 'FO'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-7.82273730299994, 62.46566694900008],
      [-6.208863458999929, 62.46566694900008],
      [-6.018029018999925, 61.333063812000034],
      [-7.614006113999949, 61.333063812000034],
      [-7.82273730299994, 62.46566694900008]]]},
   'id': 'FO'},
  {'type': 'Feature',
   'properties': {'id': 'MS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-62.29045309299994, 16.812465153000062],
      [-62.114417566999975, 16.812465153000062],
      [-62.09751972, 16.65891793800006],
      [-62.273514561999946, 16.65891793800006],
      [-62.29045309299994, 16.812465153000062]]]},
   'id': 'MS'},
  {'type': 'Feature',
   'properties': {'id': 'AX'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[19.533041233000063, 60.39745071400006],
      [20.904212749000067, 60.38635871400004],
      [20.865457239000023, 60.024988292000046],
      [19.498961548000068, 60.03605200800007],
      [19.533041233000063, 60.39745071400006]]]},
   'id': 'AX'},
  {'type': 'Feature',
   'properties': {'id': 'BV'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[3.341030829000033, -54.40824029299995],
      [3.484412490000068, -54.40636368899993],
      [3.482383731000027, -54.456259468999974],
      [3.338942705000022, -54.45813645399994],
      [3.341030829000033, -54.40824029299995]]]},
   'id': 'BV'},
  {'type': 'Feature',
   'properties': {'id': 'IM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-4.322885625999959, 54.41489485800008],
      [-4.289110299999948, 54.16392926100008],
      [-4.78654645599994, 54.16488018200005],
      [-4.817399039999941, 54.41489485800008],
      [-4.322885625999959, 54.41489485800008]]]},
   'id': 'IM'},
  {'type': 'Feature',
   'properties': {'id': 'UM'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-162.73848041599996, 6.616113812000037],
      [-162.30740579399998, 6.535066560000075],
      [-162.37337380399998, 6.096034537000037],
      [-162.80390014199997, 6.177081788000066],
      [-162.73848041599996, 6.616113812000037]]]},
   'id': 'UM'},
  {'type': 'Feature',
   'properties': {'id': 'GI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-5.687295881999944, 36.24672041800005],
      [-5.508553473999939, 36.39637213200007],
      [-5.308373983999957, 36.257804160000035],
      [-5.499689054999976, 36.064657183000065],
      [-5.687295881999944, 36.24672041800005]]]},
   'id': 'GI'},
  {'type': 'Feature',
   'properties': {'id': 'LI'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[9.380595174000064, 47.43679119500007],
      [9.659437270000069, 47.436731476000034],
      [9.937931951000053, 47.43679119500007],
      [9.939710071000036, 47.17418660700008],
      [9.940763874000027, 47.017461784000034],
      [9.384913192000056, 47.017461784000034],
      [9.380595174000064, 47.43679119500007]]]},
   'id': 'LI'},
  {'type': 'Feature',
   'properties': {'id': 'GG'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-2.578315492999934, 49.70133549600007],
      [-2.182539500999951, 49.70133549600007],
      [-2.156897895999975, 49.41399845800004],
      [-2.551904055999955, 49.41399845800004],
      [-2.578315492999934, 49.70133549600007]]]},
   'id': 'GG'},
  {'type': 'Feature',
   'properties': {'id': 'JE'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-1.919423261999953, 49.05732594700004],
      [-2.296961633999956, 49.05732594700004],
      [-2.322068575999936, 49.33838156300004],
      [-1.943817345999946, 49.33838156300004],
      [-1.919423261999953, 49.05732594700004]]]},
   'id': 'JE'},
  {'type': 'Feature',
   'properties': {'id': 'SHN544'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-9.712839947999953, -40.21924178499995],
      [-9.726843309999936, -40.49090451899997],
      [-10.070782791999932, -40.49087965799998],
      [-10.056301038999948, -40.21921209799996],
      [-9.712839947999953, -40.21924178499995]]]},
   'id': 'SHN544'},
  {'type': 'Feature',
   'properties': {'id': 'SHN560'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-12.096556600999975, -37.024884904999965],
      [-12.11163357299995, -37.29523311199995],
      [-12.450344925999957, -37.29520837499996],
      [-12.434859304999975, -37.02485535799997],
      [-12.096556600999975, -37.024884904999965]]]},
   'id': 'SHN560'},
  {'type': 'Feature',
   'properties': {'id': 'SHN552'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-5.568726588999937, -15.874882853999964],
      [-5.571325962999936, -16.14441826099994],
      [-5.891211521999935, -16.144393600999933],
      [-5.888488558999939, -15.874853392999967],
      [-5.568726588999937, -15.874882853999964]]]},
   'id': 'SHN552'},
  {'type': 'Feature',
   'properties': {'id': 'SHN551'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-14.220801169999959, -7.849795321999977],
      [-14.22384023099994, -8.119330729999945],
      [-14.541033876999961, -8.119306068999947],
      [-14.537936901999956, -7.84976586199997],
      [-14.220801169999959, -7.849795321999977]]]},
   'id': 'SHN551'},
  //  {'type': 'Feature',
  //   'properties': {'id': 'PS'},
  //   'geometry': {'type': 'Polygon',
  //    'coordinates': [[[34.167815716000064, 31.094942442000047],
  //      [33.703737010000054, 31.09450617600004],
  //      [33.49175178200005, 31.495061874000044],
  //      [33.87207450300008, 31.495061874000044],
  //      [34.21522278400005, 31.495205810000073],
  //      [34.167815716000064, 31.094942442000047]]]},
  //   'id': 'PS'},
    // {'type': 'Feature',
    //   'properties': {'id': 'PX'},
    //   'geometry': {'type': 'Polygon',
    //    'coordinates': [
    //     [[35.351428705000046, 32.56560747300006],
    //      [35.35439556600005, 32.565606141000046],
    //      [35.20657243900007, 31.359974088000058],
    //      [34.77144968300007, 31.360340413000074],
    //      [34.91898512600005, 32.56560804900005],
    //      [35.351428705000046, 32.56560747300006]]]},
    //   'id': 'PX'},
  {'type': 'Feature',
   'properties': {'id': 'PS'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[34.167815716000064, 31.094942442000047],
      [33.703737010000054, 31.09450617600004],
      [33.49175178200005, 31.495061874000044],
      [33.87207450300008, 31.495061874000044],
      [34.21522278400005, 31.495205810000073],
      [34.167815716000064, 31.094942442000047]],
     [[35.351428705000046, 32.56560747300006],
      [35.35439556600005, 32.565606141000046],
      [35.20657243900007, 31.359974088000058],
      [34.77144968300007, 31.360340413000074],
      [34.91898512600005, 32.56560804900005],
      [35.351428705000046, 32.56560747300006]]]},
   'id': 'PS'},
  // {'type': 'Feature',
  //  'properties': {'id': 'PRT560'}, // Portugal sovereignty islands PRT560
  //  'geometry': {'type': 'Polygon',
  //   'coordinates': [[[-16.754449716999943, 32.78442026500005],
  //     [-16.73837679299993, 32.51488485800007],
  //     [-17.07056115699993, 32.514909518000024],
  //     [-17.086962617999973, 32.78444972600005],
  //     [-16.754449716999943, 32.78442026500005]]]},
  //  'id': 'PRT560'},
  {'type': 'Feature',
   'properties': {'id': 'PI'}, // Portugal sovereignty islands PRT1202/PRT560
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-28.041295636999962, 38.523464174000026],
      [-28.00622088399996, 38.25290094400003],
      [-28.34642426499994, 38.252925696000034],
      [-28.381931557999962, 38.52349375000006],
      [-28.041295636999962, 38.523464174000026]],
     [[-26.952622351999935, 38.788649263000025],
      [-26.918563347999964, 38.51803956200007],
      [-27.259189781999964, 38.518064319000075],
      [-27.293686468999965, 38.78867884400006],
      [-26.952622351999935, 38.788649263000025]],
     [[-25.345726614999933, 37.96215870100008],
      [-25.31479040499994, 37.69169378000004],
      [-25.65411404699995, 37.69171852300008],
      [-25.685471906999965, 37.962188266000055],
      [-25.345726614999933, 37.96215870100008]],
     [[-31.080768558999978, 39.525972023000065],
      [-31.040242449999937, 39.255233032000035],
      [-31.382072293999954, 39.25525780000004],
      [-31.423050754999963, 39.52600161700008],
      [-31.080768558999978, 39.525972023000065]],
      [[-16.754449716999943, 32.78442026500005],
      [-16.73837679299993, 32.51488485800007],
      [-17.07056115699993, 32.514909518000024],
      [-17.086962617999973, 32.78444972600005],
      [-16.754449716999943, 32.78442026500005]]]},
   'id': 'PI'},
  {'type': 'Feature',
   'properties': {'id': 'PT'}, // Portugal
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-6.993650144999947, 36.82235105700005],
      [-8.465397764999977, 36.82235105700005],
      [-9.184705039999926, 36.82235105800004],
      [-9.322362900999963, 39.992055281000034],
      [-9.408539281999936, 41.821265899000025],
      [-7.166827209999951, 41.821265899000025],
      [-6.993650144999947, 36.82235105700005]]]},
   'id': 'PT'},
  {'type': 'Feature',
   'properties': {'id': 'EI'}, // Spain sovereigny islands ESP1393
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-13.633065674999955, 29.012966608000056],
      [-13.622811480999928, 28.743431200000032],
      [-13.950931518999937, 28.74345586100003],
      [-13.961443977999977, 29.012996068000064],
      [-13.633065674999955, 29.012966608000056]],
     [[-16.35675558, 28.44891896000007],
      [-16.344772511999963, 28.179383553000036],
      [-16.67236612599993, 28.179408213000045],
      [-16.684598809999954, 28.44894842100007],
      [-16.35675558, 28.44891896000007]],
     [[-15.435115788999951, 27.88532023600004],
      [-15.424219940999933, 27.615784829000063],
      [-15.75130532299994, 27.61580948900007],
      [-15.76244216799995, 27.885349697000038],
      [-15.435115788999951, 27.88532023600004]],
     [[-17.66983632199998, 28.62045481900003],
      [-17.65671948299996, 28.350919412000053],
      [-17.984471422999945, 28.35094407200006],
      [-17.99784053199994, 28.620484280000028],
      [-17.66983632199998, 28.62045481900003]],
     [[-17.94493374299998, 27.891431603000058],
      [-17.932186887999933, 27.621896196000023],
      [-18.25927785099998, 27.62192085600003],
      [-18.27226583299995, 27.891461064000055],
      [-17.94493374299998, 27.891431603000058]]]},
   'id': 'EI'},
  {'type': 'Feature',
   'properties': {'id': 'ES'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-1.643007896999961, 43.632506284000044],
      [-0.872878963999938, 43.01488353700006],
      [0.795983767000052, 43.01488353700006],
      [0.795039554000027, 42.80579196900004],
      [1.310257963000026, 42.80579196900004],
      [1.311814065000021, 43.01488353700006],
      [3.187025795000068, 43.01477678400005],
      [3.157403196000075, 41.37812306700005],
      [1.824562104000051, 41.37812306700005],
      [-0.218773257999942, 39.712113542000054],
      [-0.23475534399995, 38.12635583400004],
      [-1.851510579999967, 36.78471975400004],
      [-2.885343684999953, 36.78471975400004],
      [-4.777670528999977, 36.78505875400003],
      [-5.308373983999957, 36.257804160000035],
      [-5.508553473999939, 36.39637213200007],
      [-5.687295881999944, 36.24672041800005],
      [-6.290804829999956, 36.82235105700005],
      [-6.993650144999947, 36.82235105700005],
      [-7.166827209999951, 41.821265899000025],
      [-9.408539281999936, 41.821265899000025],
      [-9.508717227999966, 43.632506284000044],
      [-1.643007896999961, 43.632506284000044]],
     [[3.110797609000031, 39.71606502100008],
      [3.106184067000072, 39.445292677000054],
      [2.76404188500004, 39.44531744900007],
      [2.768200137000065, 39.716094620000035],
      [3.110797609000031, 39.71606502100008]],
     [[1.546545287000072, 39.116368145000024],
      [1.544060147000039, 38.845700994000026],
      [1.202907216000028, 38.845725755000046],
      [1.204948939000076, 39.11639773200005],
      [1.546545287000072, 39.116368145000024]]]},
   'id': 'ES'},
   {'type': 'Feature',
   'properties': {'id': 'KX'}, // disputed (AKSAI CHIN with CHINA)
   'geometry': {'type': 'Polygon',
    'coordinates':  [[
      // AA               // BB
      [76.73834767600006, 34.54524525100007], // 1
      // TT               // UU
      [78.22106987225004, 35.51944991050007], // 2
      // V                // X
      [78.42298110250005, 35.28902742100007], // 3 mid right
      // C                // D
      [76.94034766200005, 34.31325141100007], //4 mid left
      // AA               // BB
      [76.73834767600006, 34.54524525100007]], // 5 close loop

      [
      // CC               // DD
      [77.14234764800004, 34.081257571000066], // 1
      // VV               // XX
      [78.62489233275005, 35.05860493150007], // 2
      // Y                // Z
      [78.82680356300006, 34.82818244200007], //3 bottom right 
      // E                // F
      [77.34434763400003, 33.849263731000065], //4 bottom left 
      // CC               // DD
      [77.14234764800004, 34.081257571000066] // 5 close loop

      // START: line polygon coord references
      // // E                // F
      // [77.34434763400003, 33.849263731000065], //5 bottom left (empty space, disputed area KX)
      
      // // A                 // B
      // [76.53634769000007, 34.77723909100007], //4 top left     (empty space, disputed area KX)
      
      // // AA               // BB
      // [76.73834767600006, 34.54524525100007],

      // // C                // D
      // [76.94034766200005, 34.31325141100007], // mid left

      // // CC               // DD
      // [77.14234764800004, 34.081257571000066],

      // // T                // U
      // [78.01915864200004, 35.74987240000007], //3 top right    (empty space, disputed area KX)
      
      // // TT               // UU
      // [78.22106987225004, 35.51944991050007],

      // // V                // X
      // [78.42298110250005, 35.28902742100007], // mid right

      // // VV               // XX
      // [78.62489233275005, 35.05860493150007],

      // // Y                // Z
      // [78.82680356300006, 34.82818244200007], //2 bottom right (empty space, disputed area KX)
      // [77.34434763400003, 33.849263731000065] //1 bottom left (empty space, disputed area KX)
      // START: line polygon coord references

      // UP MID LEFT
      // UP MID RIGHT

                  // C                // D
      // MID LEFT [76.940347662, 34.313251411 ]
      // MID LEFT [(76.53634769000007+77.34434763400003)/2,  (34.77723909100007+33.849263731000065)/2 ]
                  // V                // X
      // MID RIGHT [78.4229811025, 35.289027421]
      // MID RIGHT [(78.01915864200004+78.82680356300006)/2, (35.74987240000007+34.82818244200007)/2]

      // START: four corners and close loop for reference CLOCKWISE
      // [77.34434763400003, 33.849263731000065], //5 bottom left (empty space, disputed area KX)
      // [76.53634769000007, 34.77723909100007], //4 top left     (empty space, disputed area KX)
      // [78.01915864200004, 35.74987240000007], //3 top right    (empty space, disputed area KX)
      // [78.82680356300006, 34.82818244200007], //2 bottom right (empty space, disputed area KX)
      // [77.34434763400003, 33.849263731000065] //1 bottom left (empty space, disputed area KX)
      // END: four corners and close loop for reference
 ]]}, // 
    'id': 'KX'},
    {'type': 'Feature', // grey space, disputed (AKSAI CHIN)
   'properties': {'id': 'KXx'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[
      // A                 // B
      [76.53634769000007, 34.77723909100007], //1 top left    
      // T                // U
      [78.01915864200004, 35.74987240000007], //2 top right   
      // TT               // UU
      [78.22106987225004, 35.51944991050007], // 3
      // AA               // BB
      [76.73834767600006, 34.54524525100007], // 4
      // A                 // B
      [76.53634769000007, 34.77723909100007]], //5 close lop   

      [
      // C                // D
      [76.94034766200005, 34.31325141100007], // 1 mid left
       // V                // X
       [78.42298110250005, 35.28902742100007], // 2 mid right
       // VV               // XX
      [78.62489233275005, 35.05860493150007], // 3
      // CC               // DD
      [77.14234764800004, 34.081257571000066], // 4
      // C                // D
      [76.94034766200005, 34.31325141100007]]]}, // 5 close loop]]},
   'id': 'KXx'},
  //  {'type': 'Feature', 
  //  'properties': {'id': 'CS'}, // Caspian Sea
  //  'geometry': {'type': 'Polygon',
  //   'coordinates': [[
  //     [53.982635146166089, 38.898597372216713],   //1
  //       [53.557207278796938, 36.795908257366662], //2
  //       [50.964722024414513, 36.795115346864819], //3
  //       [49.004869843496685, 37.858027179508184], //4
  //       [49.295937582530662, 39.480672663723809], //5
  //       [49.938099994305524, 40.281100022360881], //6 Q
  //        [47.541751851703722, 43.175339315881153], //7 11?QQ
  //       [48.1114860731184, 45.832021205926374], //8 12? M
  //       [50.930674236525832, 47.007581521722848], //9 13? MM
  //       [53.071788369381736, 46.98969378969376],//10
  //       [52.700549211371658, 45.561402997065926], //11
  //       [51.220809898430666, 45.080969388098787],//12
  //       [50.99702170345288, 44.151010646079023],//13
  //       [52.131008805137483, 41.823052722277616],//14
  //       [53.256674941058307, 41.850537550019915],//15
  //        [54.789801031723208, 41.85631068001495], //   19?
  //       [54.541841051868531, 40.968664213421775],
  //       [53.410445755958115, 40.965019194532935],

  //       [52.887392013181461, 40.877153820696194], // CS21?
  //       [53.180474644602079, 39.288899061243541], // CS22?
  //       [53.982635146166089, 38.898597372216713] //CS1?
  //   ]]},
  //  'id': 'CS'},
  {'type': 'Feature',
   'properties': {'id': 'AN'},
   'geometry': {'type': 'Polygon',
    'coordinates': [[[-62.812767158999975, 17.701086900000064],
      [-62.786309647999985, 17.43155149200004],
      [-62.791174343999955, 17.431551867000053],
      [-63.10682043299994, 17.431576153000037],
      [-63.12502524599995, 17.616676330000075],
      [-63.133415698999954, 17.70111636000007],
      [-62.812767158999975, 17.701086900000064]],
     [[-63.15081847299996, 17.787530507000042],
      [-63.12404450599996, 17.517995099000075],
      [-63.44459907099997, 17.518019760000072],
      [-63.47151156299998, 17.78755996700005],
      [-63.15081847299996, 17.787530507000042]]]},
   'id': 'AN'}]}
]